<template>
  <div class="w-full h-screen flex flex-col">
    <section
      v-if="tab == 'ask-mentor' && isStartedYet && !classroomLevel?.is_locked"
      class="block md:hidden fixed inset-x-0 bottom-0 z-50 bg-white shadow-lg"
    >
      <div class="p-4">
        <button
          @click="openModalAskMentor()"
          class="w-full rounded-full py-2 bg-[#FFFFFF] border border-[#009DFF] text-[#009DFF] font-solusi text-base font-semibold outline-none focus:outline-none"
        >
          Tanya Mentor
        </button>
      </div>
    </section>
    <section
      v-if="
        tab == 'webinar' &&
          listRequestWebinarPlus?.length > 0 &&
          showWebinarQuiz == false &&
          isStartedYet &&
          !classroomLevel?.is_locked
      "
      class="block md:hidden fixed inset-x-0 bottom-0 z-50 bg-white shadow-lg"
    >
      <div class="p-4 flex items-center justify-between">
        <p class="font-solusi font-semibold text-sm text-[#212121]">
          Kamu ingin mengikuti Webinar Plus?
        </p>
        <button
          @click="showWebinarPlusModal()"
          class="rounded-full p-2 bg-[#00446F] text-[#FFFFFF] font-solusi text-sm font-semibold outline-none focus:outline-none"
        >
          Request Webinar Plus
        </button>
      </div>
    </section>
    <section
      v-if="tab == 'konsultasi-desain'"
      class="block md:hidden fixed inset-x-0 bottom-0 z-50 bg-white shadow-lg"
    >
      <div class="w-full flex flex-col items-start p-4">
        <p
          class="text-base text-[#9E9E9E] font-solusi font-semibold flex-shrink-0 mb-2"
        >
          Kuota: {{ classroomLevel?.quota_private }}
        </p>
        <div class="w-full grid grid-cols-2 gap-2">
          <button
            @click="openModalAddQuota"
            class="col-span-1 text-[#009DFF] hover:text-[#FFFFFF] hover:bg-[#009DFF] font-solusi px-1.5 py-1.5 rounded-full border border-[#009DFF] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
          >
            <svg
              class="w-4 h-4 mr-1"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.713 8.95303H8.95108V13.7149C8.95108 14.2387 8.52251 14.6673 7.9987 14.6673C7.47489 14.6673 7.04632 14.2387 7.04632 13.7149V8.95303H2.28441C1.7606 8.95303 1.33203 8.52446 1.33203 8.00065C1.33203 7.47684 1.7606 7.04827 2.28441 7.04827H7.04632V2.28637C7.04632 1.76256 7.47489 1.33398 7.9987 1.33398C8.52251 1.33398 8.95108 1.76256 8.95108 2.28637V7.04827H13.713C14.2368 7.04827 14.6654 7.47684 14.6654 8.00065C14.6654 8.52446 14.2368 8.95303 13.713 8.95303Z"
                fill="currentColor"
              />
            </svg>
            Kuota Konsultasi
          </button>
          <button
            v-if="classroomLevel.quota_private > 0"
            @click="openModalPrivateWebinar"
            class="col-span-1 text-[#FB8500] hover:text-[#FFFFFF] hover:bg-[#FB8500] font-solusi px-0 py-1.5 rounded-full border border-[#FB8500] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
          >
            <svg
              class="h-4 mr-1"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.49664 5.85239C8.24559 5.85239 8.92116 5.40135 9.20756 4.70917C9.49401 4.01699 9.33568 3.22065 8.806 2.69092C8.27631 2.16123 7.47997 2.0029 6.78775 2.28936C6.09609 2.57633 5.64453 3.25133 5.64453 4.00028C5.64453 4.49143 5.83984 4.96278 6.18723 5.30965C6.53463 5.65704 7.00545 5.85235 7.4966 5.85235L7.49664 5.85239ZM7.49664 2.88935C7.94611 2.88935 8.35132 3.16017 8.52319 3.57527C8.69507 3.99038 8.60027 4.46849 8.28204 4.7862C7.96434 5.1039 7.48674 5.1987 7.07164 5.02682C6.65602 4.85494 6.38571 4.44975 6.38571 4.00027C6.38571 3.38673 6.88311 2.88935 7.49664 2.88935Z"
                fill="currentColor"
              />
              <path
                d="M13.7949 0.666017H1.20233C0.997643 0.666017 0.832031 0.832162 0.832031 1.03632V9.92532C0.832031 10.0238 0.871094 10.118 0.940364 10.1873C1.01016 10.2566 1.10443 10.2956 1.20233 10.2956H13.7949C13.8928 10.2956 13.9871 10.2566 14.0569 10.1873C14.1261 10.118 14.1652 10.0237 14.1652 9.92532V1.03632C14.1652 0.938404 14.1261 0.844136 14.0569 0.774869C13.9871 0.705078 13.8928 0.666016 13.7949 0.666016V0.666017ZM4.19138 9.55501C4.44659 8.88887 4.90126 8.31857 5.49345 7.92063C6.08511 7.52271 6.78562 7.31751 7.49863 7.3326C8.41893 7.32583 9.30688 7.67167 9.97981 8.29926C10.348 8.64822 10.6298 9.0779 10.8022 9.55499L4.19138 9.55501ZM13.4246 9.55501H11.5725C11.5777 9.5196 11.5777 9.48314 11.5725 9.44772C11.3647 8.80606 10.998 8.22742 10.5059 7.766C9.6918 7.00246 8.61467 6.58164 7.49855 6.59205C6.60429 6.5707 5.72617 6.8358 4.99284 7.34882C4.26003 7.86184 3.71055 8.59621 3.42458 9.44413C3.41885 9.48059 3.41885 9.51809 3.42458 9.55507H1.57247V1.40727H13.4245L13.4246 9.55501Z"
                fill="currentColor"
              />
              <path
                d="M11.2034 11.0371H3.79608C3.59139 11.0371 3.42578 11.2033 3.42578 11.4079C3.42578 11.6121 3.59141 11.7782 3.79608 11.7782H11.2034C11.4081 11.7782 11.5737 11.6121 11.5737 11.4079C11.5737 11.2032 11.408 11.0371 11.2034 11.0371Z"
                fill="currentColor"
              />
            </svg>
            Pengajuan Konsultasi
          </button>
          <button
            v-else
            v-tooltip="{
              content: `<p class='font-solusi text-2xs text-[#212121]'>Mohon maaf, tambahkan kuotamu terlebih</p><p class='font-solusi text-2xs text-[#212121]'>dahulu untuk mengajukan konsultasi desain.</p>`,
              placement: 'top',
              triggers: ['click'],
              autoHide: true,
              html: true,
              theme: 'consultation',
            }"
            class="col-span-1 text-[#FB8500] hover:text-[#FFFFFF] hover:bg-[#FB8500] font-solusi px-1.5 py-1.5 rounded-full border border-[#FB8500] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
          >
            <svg
              class="h-4 mr-1"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.49664 5.85239C8.24559 5.85239 8.92116 5.40135 9.20756 4.70917C9.49401 4.01699 9.33568 3.22065 8.806 2.69092C8.27631 2.16123 7.47997 2.0029 6.78775 2.28936C6.09609 2.57633 5.64453 3.25133 5.64453 4.00028C5.64453 4.49143 5.83984 4.96278 6.18723 5.30965C6.53463 5.65704 7.00545 5.85235 7.4966 5.85235L7.49664 5.85239ZM7.49664 2.88935C7.94611 2.88935 8.35132 3.16017 8.52319 3.57527C8.69507 3.99038 8.60027 4.46849 8.28204 4.7862C7.96434 5.1039 7.48674 5.1987 7.07164 5.02682C6.65602 4.85494 6.38571 4.44975 6.38571 4.00027C6.38571 3.38673 6.88311 2.88935 7.49664 2.88935Z"
                fill="currentColor"
              />
              <path
                d="M13.7949 0.666017H1.20233C0.997643 0.666017 0.832031 0.832162 0.832031 1.03632V9.92532C0.832031 10.0238 0.871094 10.118 0.940364 10.1873C1.01016 10.2566 1.10443 10.2956 1.20233 10.2956H13.7949C13.8928 10.2956 13.9871 10.2566 14.0569 10.1873C14.1261 10.118 14.1652 10.0237 14.1652 9.92532V1.03632C14.1652 0.938404 14.1261 0.844136 14.0569 0.774869C13.9871 0.705078 13.8928 0.666016 13.7949 0.666016V0.666017ZM4.19138 9.55501C4.44659 8.88887 4.90126 8.31857 5.49345 7.92063C6.08511 7.52271 6.78562 7.31751 7.49863 7.3326C8.41893 7.32583 9.30688 7.67167 9.97981 8.29926C10.348 8.64822 10.6298 9.0779 10.8022 9.55499L4.19138 9.55501ZM13.4246 9.55501H11.5725C11.5777 9.5196 11.5777 9.48314 11.5725 9.44772C11.3647 8.80606 10.998 8.22742 10.5059 7.766C9.6918 7.00246 8.61467 6.58164 7.49855 6.59205C6.60429 6.5707 5.72617 6.8358 4.99284 7.34882C4.26003 7.86184 3.71055 8.59621 3.42458 9.44413C3.41885 9.48059 3.41885 9.51809 3.42458 9.55507H1.57247V1.40727H13.4245L13.4246 9.55501Z"
                fill="currentColor"
              />
              <path
                d="M11.2034 11.0371H3.79608C3.59139 11.0371 3.42578 11.2033 3.42578 11.4079C3.42578 11.6121 3.59141 11.7782 3.79608 11.7782H11.2034C11.4081 11.7782 11.5737 11.6121 11.5737 11.4079C11.5737 11.2032 11.408 11.0371 11.2034 11.0371Z"
                fill="currentColor"
              />
            </svg>
            Pengajuan Konsultasi
          </button>
        </div>
      </div>
    </section>
    <div
      class="flex flex-row md:h-[6rem]"
      :class="
        showQuiz || showPrePost || showWebinarQuiz ? 'h-[4rem]' : 'h-[7rem]'
      "
    >
      <div
        class="w-[25%] hidden md:flex flex-col items-center justify-between bg-[#FFFFFF] py-3"
      >
        <a @click="changePage('/')" class="cursor-pointer">
          <img
            src="/assets/images/mentor/logo-primary.svg"
            alt=""
            class="h-8 m-auto"
          />
        </a>
        <div
          class="px-1.5 py-1.5 rounded-md bg-[#dbefff] text-[#00446F] text-2xs mx-3 mt-2 flex items-center relative"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2 w-4 h-4"
          >
            <path
              d="M12 0C5.37288 0 0 5.37288 0 12C0 18.6271 5.37288 24 12 24C18.6271 24 24 18.6271 24 12C24 5.37288 18.6271 0 12 0ZM10.6134 17.1797V11.6858C10.6134 10.9208 11.2341 10.2993 12 10.2993C12.7659 10.2993 13.3866 10.9208 13.3866 11.6858V17.1797C13.3866 17.9456 12.7659 18.5662 12 18.5662C11.2341 18.5662 10.6134 17.9456 10.6134 17.1797ZM12 8.78616C11.3259 8.78616 10.7184 8.38022 10.4606 7.75771C10.2019 7.1352 10.3444 6.41803 10.8216 5.94178C11.2978 5.46458 12.015 5.3221 12.6375 5.5799C13.2609 5.83771 13.6669 6.44616 13.6669 7.12022C13.6669 7.56178 13.4906 7.98554 13.1784 8.29867C12.8662 8.61086 12.4416 8.78616 12 8.78616H12Z"
              fill="#2097F6"
            />
          </svg>
          Sertifikat akan muncul setelah memberikan ulasan
        </div>
      </div>
      <div
        :class="
          showQuiz || showPrePost || showWebinarQuiz
            ? 'block md:hidden'
            : 'hidden'
        "
        class="w-[100%] md:w-[75%] px-4 md:px-6 py-4 md:py-2 space-y-2 bg-gradient-to-b from-[#00446F] md:from-[#FFFFFF] to-[#088BD5] md:to-[#FFFFFF]"
      >
        <div
          v-if="showQuiz"
          @click="changePage('quiz')"
          class="flex flex-row items-center"
        >
          <svg
            class="w-7 h-7 cursor-pointer block md:hidden mr-2 flex-shrink-0"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.07942 12.3116C2.08342 12.3226 2.08342 12.3336 2.08842 12.3446C2.08842 12.3466 2.08842 12.3476 2.08942 12.3496C2.14942 12.4916 2.23742 12.6116 2.33942 12.7196C2.35042 12.7316 2.35442 12.7466 2.36542 12.7586L10.0134 20.3366C10.2624 20.5826 10.5884 20.7056 10.9144 20.7056C11.2404 20.7056 11.5654 20.5826 11.8144 20.3366C12.3124 19.8436 12.3124 19.0456 11.8144 18.5526L6.34042 13.1276L21.1054 13.1276C21.8094 13.1276 22.3784 12.5636 22.3784 11.8656C22.3784 11.1696 21.8094 10.6046 21.1054 10.6046L6.34142 10.6046L11.8154 5.15257C12.3134 4.66057 12.3134 3.86157 11.8154 3.36957C11.3184 2.87657 10.5114 2.87657 10.0134 3.36957L2.36542 10.9736C2.25542 11.0826 2.17642 11.2116 2.11442 11.3476C2.09442 11.3896 2.08342 11.4306 2.06942 11.4726C2.03542 11.5746 2.01442 11.6766 2.00742 11.7846C2.00442 11.8286 1.99842 11.8696 2.00042 11.9136C2.00542 12.0496 2.02942 12.1816 2.07942 12.3116Z"
              fill="#FFFFFF"
            />
          </svg>
          <p
            class="font-desain text-[#FFFFFF] md:text-[#212121] font-semibold text-2xl truncate"
          >
            {{ quizData?.name }}
          </p>
        </div>
        <div
          v-else-if="showPrePost"
          @click="changePage('pre-test')"
          class="flex flex-row items-center"
        >
          <svg
            class="w-7 h-7 cursor-pointer block md:hidden mr-2 flex-shrink-0"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.07942 12.3116C2.08342 12.3226 2.08342 12.3336 2.08842 12.3446C2.08842 12.3466 2.08842 12.3476 2.08942 12.3496C2.14942 12.4916 2.23742 12.6116 2.33942 12.7196C2.35042 12.7316 2.35442 12.7466 2.36542 12.7586L10.0134 20.3366C10.2624 20.5826 10.5884 20.7056 10.9144 20.7056C11.2404 20.7056 11.5654 20.5826 11.8144 20.3366C12.3124 19.8436 12.3124 19.0456 11.8144 18.5526L6.34042 13.1276L21.1054 13.1276C21.8094 13.1276 22.3784 12.5636 22.3784 11.8656C22.3784 11.1696 21.8094 10.6046 21.1054 10.6046L6.34142 10.6046L11.8154 5.15257C12.3134 4.66057 12.3134 3.86157 11.8154 3.36957C11.3184 2.87657 10.5114 2.87657 10.0134 3.36957L2.36542 10.9736C2.25542 11.0826 2.17642 11.2116 2.11442 11.3476C2.09442 11.3896 2.08342 11.4306 2.06942 11.4726C2.03542 11.5746 2.01442 11.6766 2.00742 11.7846C2.00442 11.8286 1.99842 11.8696 2.00042 11.9136C2.00542 12.0496 2.02942 12.1816 2.07942 12.3116Z"
              fill="#FFFFFF"
            />
          </svg>
          <p
            class="font-desain text-[#FFFFFF] md:text-[#212121] font-semibold text-2xl truncate"
          >
            {{ testType ? 'Post-Test' : 'Pre-Test' }}
          </p>
        </div>
        <div
          v-else-if="showWebinarQuiz"
          @click="changePage('webinar-quiz')"
          class="flex flex-row items-center"
        >
          <svg
            class="w-7 h-7 cursor-pointer block md:hidden mr-2 flex-shrink-0"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.07942 12.3116C2.08342 12.3226 2.08342 12.3336 2.08842 12.3446C2.08842 12.3466 2.08842 12.3476 2.08942 12.3496C2.14942 12.4916 2.23742 12.6116 2.33942 12.7196C2.35042 12.7316 2.35442 12.7466 2.36542 12.7586L10.0134 20.3366C10.2624 20.5826 10.5884 20.7056 10.9144 20.7056C11.2404 20.7056 11.5654 20.5826 11.8144 20.3366C12.3124 19.8436 12.3124 19.0456 11.8144 18.5526L6.34042 13.1276L21.1054 13.1276C21.8094 13.1276 22.3784 12.5636 22.3784 11.8656C22.3784 11.1696 21.8094 10.6046 21.1054 10.6046L6.34142 10.6046L11.8154 5.15257C12.3134 4.66057 12.3134 3.86157 11.8154 3.36957C11.3184 2.87657 10.5114 2.87657 10.0134 3.36957L2.36542 10.9736C2.25542 11.0826 2.17642 11.2116 2.11442 11.3476C2.09442 11.3896 2.08342 11.4306 2.06942 11.4726C2.03542 11.5746 2.01442 11.6766 2.00742 11.7846C2.00442 11.8286 1.99842 11.8696 2.00042 11.9136C2.00542 12.0496 2.02942 12.1816 2.07942 12.3116Z"
              fill="#FFFFFF"
            />
          </svg>
          <p
            class="font-desain text-[#FFFFFF] md:text-[#212121] font-semibold text-2xl truncate"
          >
            {{ webinarQuizData?.name }}
          </p>
        </div>
      </div>

      <div
        :class="
          showQuiz || showPrePost || showWebinarQuiz
            ? 'hidden md:block'
            : 'block'
        "
        class="w-[100%] md:w-[75%] px-4 md:px-6 py-4 md:py-2 space-y-2 bg-gradient-to-b from-[#00446F] md:from-[#FFFFFF] to-[#088BD5] md:to-[#FFFFFF]"
      >
        <div class="flex flex-row items-center cursor-pointer">
          <svg
            @click.prevent="changePage('-1')"
            class="w-7 h-7 cursor-pointer block md:hidden mr-2 flex-shrink-0"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.07942 12.3116C2.08342 12.3226 2.08342 12.3336 2.08842 12.3446C2.08842 12.3466 2.08842 12.3476 2.08942 12.3496C2.14942 12.4916 2.23742 12.6116 2.33942 12.7196C2.35042 12.7316 2.35442 12.7466 2.36542 12.7586L10.0134 20.3366C10.2624 20.5826 10.5884 20.7056 10.9144 20.7056C11.2404 20.7056 11.5654 20.5826 11.8144 20.3366C12.3124 19.8436 12.3124 19.0456 11.8144 18.5526L6.34042 13.1276L21.1054 13.1276C21.8094 13.1276 22.3784 12.5636 22.3784 11.8656C22.3784 11.1696 21.8094 10.6046 21.1054 10.6046L6.34142 10.6046L11.8154 5.15257C12.3134 4.66057 12.3134 3.86157 11.8154 3.36957C11.3184 2.87657 10.5114 2.87657 10.0134 3.36957L2.36542 10.9736C2.25542 11.0826 2.17642 11.2116 2.11442 11.3476C2.09442 11.3896 2.08342 11.4306 2.06942 11.4726C2.03542 11.5746 2.01442 11.6766 2.00742 11.7846C2.00442 11.8286 1.99842 11.8696 2.00042 11.9136C2.00542 12.0496 2.02942 12.1816 2.07942 12.3116Z"
              fill="#FFFFFF"
            />
          </svg>
          <p
            @click.prevent="changePage('/classroom/' + classroomCode)"
            class="font-desain text-[#FFFFFF] md:text-[#212121] font-semibold text-2xl truncate md:hover:text-[#383838]"
          >
            {{ classroomLevel?.classroom?.name }}
          </p>
        </div>

        <div class="grid grid-cols-12 gap-3">
          <div class="col-span-8 md:col-span-9">
            <div class="w-full flex md:hidden flex-col">
              <span class="font-solusi text-[#FFFFFF] text-sm font-semibold"
                >{{
                  ((countDoneProgress / countProgress) * 100).toFixed(0) ==
                  'NaN'
                    ? '0'
                    : ((countDoneProgress / countProgress) * 100).toFixed(0)
                }}%</span
              >
              <div class="w-full flex-grow relative">
                <div
                  class="overflow-hidden h-3 text-sm flex rounded-full bg-[#EEEEEE]"
                >
                  <div
                    :style="
                      'width:' + (countDoneProgress / countProgress) * 100 + '%'
                    "
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center"
                    :class="
                      (countDoneProgress / countProgress) * 100 == 100
                        ? 'bg-[#2FBD71]'
                        : (countDoneProgress / countProgress) * 100 >= 50
                        ? 'bg-[#009DFF]'
                        : 'bg-[#FFC200]'
                    "
                  ></div>
                </div>
              </div>
            </div>
            <div
              class="w-full hidden md:flex items-center space-x-3 bg-[#00446F] rounded-full px-4 py-2"
            >
              <span class="font-solusi font-semibold text-sm text-white"
                >Progres Kelas:</span
              >
              <div class="flex-grow relative">
                <div
                  class="overflow-hidden h-2 text-xs flex rounded-full bg-white"
                >
                  <div
                    :style="
                      'width:' + (countDoneProgress / countProgress) * 100 + '%'
                    "
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center"
                    :class="
                      (countDoneProgress / countProgress) * 100 == 100
                        ? 'bg-[#2FBD71]'
                        : (countDoneProgress / countProgress) * 100 >= 50
                        ? 'bg-[#009DFF]'
                        : 'bg-[#FFC200]'
                    "
                  ></div>
                </div>
              </div>
              <span class="font-solusi font-semibold text-sm text-white"
                >{{
                  ((countDoneProgress / countProgress) * 100).toFixed(0) ==
                  'NaN'
                    ? '0'
                    : ((countDoneProgress / countProgress) * 100).toFixed(0)
                }}%</span
              >
            </div>
          </div>
          <div class="col-span-4 md:col-span-3">
            <button
              v-if="
                classroomLevel?.rating <= 3 ||
                  classroomLevel?.is_certificate_disabled
              "
              @click="openModalReview()"
              class="bg-[#00446F] rounded-full text-sm w-full py-2 font-solusi font-semibold text-white"
            >
              Beri Ulasan
            </button>
            <button
              v-else
              @click="$router.push('/my-classes?page=certificate')"
              class="bg-[#00446F] rounded-full text-sm w-full py-2 font-solusi font-semibold text-white"
            >
              Sertifikat
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isLoading"
      class="flex-grow flex flex-col h-[calc(100vh-7rem)] md:h-[calc(100vh-6rem)] justify-center items-center"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="spinner"
        class="w-12 h-12 animate-spin"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="#00446F"
          d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        ></path>
      </svg>
      <p class="font-solusi text-center text-[#00446F] font-semibold mt-3">
        Memuat data...
      </p>
    </div>

    <div
      v-if="!isStartedYet && !isLoading"
      class="flex-grow flex flex-col h-[calc(100vh-7rem)] md:h-[calc(100vh-6rem)] bg-gradient-to-b from-[#00446F] to-[#088BD5] justify-center items-center"
    >
      <div
        class="m-auto flex flex-col items-center justify-center px-6 md:px-0"
      >
        <img
          src="/assets/images/modal/illustration-lock.svg"
          class="w-[240px] md:w-1/2 m-auto"
          alt=""
        />
        <p class="font-solusi text-[#FFFFFF] text-lg my-3">
          Halo, pembelajaran akan dimulai pada
        </p>
        <p class="font-desain text-[#FFFFFF] text-2xl mb-3 font-semibold">
          {{ dateFormatLong(classroomLevel?.classroom?.started_at) }}
        </p>
        <div
          class="bg-[#FFFFFF] py-2 px-4 border border-[#009DFF] rounded-full mb-6 flex items-center space-x-2"
        >
          <span
            v-if="distanceDay"
            class="font-solusi text-[#212121] text-lg font-semibold"
            >{{ displayDays }} hari :
          </span>
          <span class="font-solusi text-[#212121] text-lg font-semibold">
            {{ displayHours }} jam :
          </span>
          <span class="font-solusi text-[#212121] text-lg font-semibold">
            {{ displayMinutes }} menit
          </span>
          <span
            v-if="!distanceDay"
            class="font-solusi text-[#212121] text-lg font-semibold"
          >
            : {{ displaySeconds }} detik
          </span>
        </div>
        <p
          v-if="isExistForum"
          class="font-solusi text-[#FFFFFF] text-lg text-center"
        >
          Sambil nunggu kelas dimulai, gabung ke grup
          {{
            classroomLevel.forum
              ? isDiscordLink
                ? 'Discord'
                : 'Telegram'
              : 'Whatsapp'
          }}
          yuk!
        </p>
        <div v-if="isExistForum" class="my-2 flex justify-center">
          <a
            :href="
              classroomLevel.forum
                ? classroomLevel.forum
                : classroomLevel.whatsapp_link
            "
            target="_blank"
            class="text-[#00446F] font-solusi text-sm font-semibold px-4 py-2 rounded-full border border-gray-200 flex items-center bg-white"
          >
            <img
              v-if="classroomLevel.forum && isDiscordLink"
              src="/assets/images/icon/discord.svg"
              class="mr-2 w-4 h-4"
              alt=""
            />
            <svg
              v-else-if="classroomLevel.forum && !isDiscordLink"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="telegram"
              class="mr-2 w-4 h-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
            >
              <path
                fill="currentColor"
                d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
              ></path>
            </svg>
            <img
              v-else
              src="/assets/images/icon/whatsapp.png"
              class="mr-2 w-5 h-5"
              alt=""
            />
            Gabung Grup
          </a>
        </div>
      </div>
    </div>

    <div
      v-else-if="classroomLevel?.is_locked && !isLoading"
      class="flex-grow flex flex-col h-[calc(100vh-7rem)] md:h-[calc(100vh-6rem)] bg-gradient-to-b from-[#00446F] to-[#088BD5] justify-center items-center"
    >
      <div
        class="m-auto flex flex-col items-center justify-center px-6 md:px-0"
      >
        <img
          src="/assets/images/modal/illustration-lock.svg"
          class="w-[260px] m-auto"
          alt=""
        />
        <p
          class="font-solusi text-[#FFFFFF] text-xl mt-3 font-semibold text-center"
        >
          Kelasmu terkunci,
        </p>
        <p
          class="font-solusi text-[#FFFFFF] text-xl mb-5 font-semibold text-center"
        >
          silahkan hubungi Admin
        </p>

        <div class="my-2 flex justify-center">
          <a
            href="https://wa.me/6285155421080"
            target="_blank"
            class="text-[#00446F] font-solusi text-sm font-semibold px-10 py-2 rounded-full border border-gray-200 flex items-center bg-white"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="telegram"
              class="mr-2 w-4 h-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
            >
              <path
                fill="currentColor"
                d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
              ></path>
            </svg>
            Hubungi Admin
          </a>
        </div>
      </div>
    </div>

    <div
      v-show="isStartedYet && !classroomLevel?.is_locked && !isLoading"
      class="flex-grow flex flex-col md:flex-row h-[calc(100vh-7rem)] md:h-[calc(100vh-6rem)]"
    >
      <div
        v-dragscroll
        class="w-full md:w-[25%] bg-[#FFFFFF] pb-6 order-2 md:order-1 overflow-y-auto scroll-custom items-center flex-nowrap h-full"
        :class="
          showQuiz || showPrePost || showWebinarQuiz ? 'hidden md:block' : ''
        "
      >
        <div
          class="px-1.5 py-1.5 rounded-md bg-[#dbefff] text-[#00446F] text-sm mx-2 mt-2 flex items-center md:hidden relative"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2 w-4 h-4"
          >
            <path
              d="M12 0C5.37288 0 0 5.37288 0 12C0 18.6271 5.37288 24 12 24C18.6271 24 24 18.6271 24 12C24 5.37288 18.6271 0 12 0ZM10.6134 17.1797V11.6858C10.6134 10.9208 11.2341 10.2993 12 10.2993C12.7659 10.2993 13.3866 10.9208 13.3866 11.6858V17.1797C13.3866 17.9456 12.7659 18.5662 12 18.5662C11.2341 18.5662 10.6134 17.9456 10.6134 17.1797ZM12 8.78616C11.3259 8.78616 10.7184 8.38022 10.4606 7.75771C10.2019 7.1352 10.3444 6.41803 10.8216 5.94178C11.2978 5.46458 12.015 5.3221 12.6375 5.5799C13.2609 5.83771 13.6669 6.44616 13.6669 7.12022C13.6669 7.56178 13.4906 7.98554 13.1784 8.29867C12.8662 8.61086 12.4416 8.78616 12 8.78616H12Z"
              fill="#2097F6"
            />
          </svg>
          Sertifikat akan muncul setelah memberikan ulasan
        </div>
        <div
          ref="tabs"
          class="w-full flex flex-row items-center sticky top-0 bg-[#FFFFFF] border-b-8 border-[#F5F6F8] z-20"
        >
          <button
            @click="sideScroll('menu', 'left', 15, 100, 5)"
            class="flex items-center justify-center cursor-pointer text-[#9E9E9E] hover:text-[#212121] py-2 px-2 w-8"
          >
            <svg
              class="w-4 h-4 rotate-180"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.3984 11.9999L6.47381 4.5916C5.88224 4.03808 5.83859 3.09563 6.37683 2.48726C6.91506 1.8789 7.83149 1.834 8.42305 2.38753L17.526 10.898C18.158 11.4897 18.158 12.5103 17.526 13.102L8.42305 21.6125C7.83149 22.166 6.91506 22.1211 6.37683 21.5127C5.8386 20.9044 5.88225 19.9619 6.47381 19.4084L14.3984 11.9999Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <div
            ref="menu"
            v-dragscroll
            class="flex flex-grow items-center overflow-auto scroll-hide space-x-4 w-[calc(100%-64px)]"
          >
            <div
              ref="tab-materi"
              @click="openTab('materi')"
              v-if="
                classroomLevel?.classroom?.must_subject_tab ||
                  classroomLevel?.classroom?.must_module_tab ||
                  classroomLevel?.classroom?.must_quizzes_tab
              "
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'materi'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Materi
            </div>
            <div
              v-if="isExistForum"
              ref="tab-forum"
              @click="openTab('forum')"
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'forum'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Forum
            </div>
            <div
              ref="tab-webinar"
              @click="openTab('webinar')"
              v-if="classroomLevel?.classroom?.must_webinar_tab"
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'webinar'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Webinar
            </div>
            <div
              ref="tab-task"
              @click="openTab('task')"
              v-if="classroomLevel?.classroom?.must_submission_tab"
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'task'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Tugas
            </div>
            <div
              ref="tab-ask-mentor"
              @click="openTab('ask-mentor')"
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'ask-mentor'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Tanya Mentor
            </div>
            <div
              ref="tab-private-webinar"
              @click="openTab('konsultasi-desain')"
              v-if="classroomLevel?.classroom?.is_webinar_private"
              class="font-solusi text-base md:text-sm font-semibold p-2 border-b-2 flex-shrink-0 duration-300 cursor-pointer"
              :class="
                tab == 'konsultasi-desain'
                  ? 'border-[#009DFF] text-[#009DFF]'
                  : 'border-transparent text-[#757575] hover:text-[#212121]'
              "
            >
              Konsultasi Desain
            </div>
          </div>
          <button
            @click="sideScroll('menu', 'right', 15, 100, 5)"
            class="flex items-center justify-center cursor-pointer py-2 px-2 text-[#9E9E9E] hover:text-[#212121] w-8"
          >
            <svg
              class="w-4 h-4"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.3984 11.9999L6.47381 4.5916C5.88224 4.03808 5.83859 3.09563 6.37683 2.48726C6.91506 1.8789 7.83149 1.834 8.42305 2.38753L17.526 10.898C18.158 11.4897 18.158 12.5103 17.526 13.102L8.42305 21.6125C7.83149 22.166 6.91506 22.1211 6.37683 21.5127C5.8386 20.9044 5.88225 19.9619 6.47381 19.4084L14.3984 11.9999Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div
          v-if="tab == 'materi'"
          class="material-list divide-y divide-y-gray-200 border-b border-gray-200"
        >
          <div
            v-if="isExistPreTest"
            class="cursor-pointer flex w-full py-4 px-3 border-l-4 "
            :class="
              !isDonePreTest
                ? 'bg-[#E8EDFF] border-[#00446F]'
                : 'border-transparent'
            "
            @click="openModalPreTest()"
          >
            <div class="flex justify-between w-full">
              <div class="flex items-center">
                <svg
                  v-if="isDonePreTest"
                  class="mr-2 w-4 h-4 flex-shrink-0"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#009DFF" />
                  <path
                    d="M6.18277 11.9412C6.3659 12.129 6.62072 12.2355 6.88703 12.2355C6.88961 12.2355 6.89232 12.2355 6.89516 12.2355C7.16457 12.2332 7.42081 12.1225 7.60252 11.9295L12.9232 6.27858C13.2839 5.89547 13.2558 5.30134 12.8609 4.95154C12.4658 4.602 11.8531 4.62893 11.4924 5.01191L6.87501 9.91578L5.43769 8.43984C5.07013 8.06261 4.45692 8.04583 4.06818 8.40189C3.67917 8.75807 3.66187 9.35246 4.02904 9.72968L6.18277 11.9412Z"
                    fill="white"
                  />
                </svg>
                <svg
                  class="w-4 h-4 flex-shrink-0"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                    fill="#212121"
                  />
                </svg>

                <p class="font-solusi text-sm text-[#212121] ml-2">
                  Pre-Test
                </p>
              </div>
            </div>
          </div>
          <div v-for="(materi, i) of materials" :key="i" class="">
            <div class="text-left">
              <a
                class="flex flex-col w-full py-4 px-3 cursor-pointer border-l-4"
                :class="
                  selectedMaterial.id == materi.id
                    ? 'bg-[#E8EDFF] border-[#00446F]'
                    : 'border-transparent'
                "
                @click="toggleMateri(i)"
              >
                <div class="flex justify-between w-full">
                  <div class="flex items-center">
                    <svg
                      v-if="materi?.is_done"
                      class="mr-2 w-4 h-4 flex-shrink-0"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="8" cy="8" r="8" fill="#009DFF" />
                      <path
                        d="M6.18277 11.9412C6.3659 12.129 6.62072 12.2355 6.88703 12.2355C6.88961 12.2355 6.89232 12.2355 6.89516 12.2355C7.16457 12.2332 7.42081 12.1225 7.60252 11.9295L12.9232 6.27858C13.2839 5.89547 13.2558 5.30134 12.8609 4.95154C12.4658 4.602 11.8531 4.62893 11.4924 5.01191L6.87501 9.91578L5.43769 8.43984C5.07013 8.06261 4.45692 8.04583 4.06818 8.40189C3.67917 8.75807 3.66187 9.35246 4.02904 9.72968L6.18277 11.9412Z"
                        fill="white"
                      />
                    </svg>
                    <p
                      class="font-solusi text-sm"
                      :class="
                        selectedMaterial.id == materi.id
                          ? 'font-semibold text-[#00446F]'
                          : 'text-[#212121]'
                      "
                    >
                      {{ materi.name }}
                      <span
                        class="font-solusi text-2xs"
                        :class="
                          selectedMaterial.id == materi.id
                            ? 'font-semibold text-[#00446F]'
                            : 'text-[#757575]'
                        "
                      >
                        ({{ countMaterialDone(materi.material) }}/{{
                          materi.material?.length
                        }})
                      </span>
                    </p>
                  </div>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chevron-up"
                    class="w-4 h-4 self-center duration-500 flex-shrink-0"
                    :class="isActiveMateri(i) ? 'rotate-0' : 'rotate-180'"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                    ></path>
                  </svg>
                  <!-- <svg
                    v-else
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chevron-down"
                    class="w-4 h-4 self-center"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                    ></path>
                  </svg> -->
                </div>
                <!-- <p class="font-solusi text-xs text-[#757575]">2/6</p> -->
              </a>
            </div>
            <transition name="collapse">
              <div v-if="isActiveMateri(i)">
                <div
                  v-if="materi?.material?.length"
                  class="divide-y divide-gray-200"
                >
                  <div
                    v-for="(item, key) of materi?.material"
                    :key="key"
                    class="first:border-t first:border-gray-200"
                  >
                    <div
                      class="flex w-full p-4 hover:opacity-80 cursor-pointer"
                      @click="openMaterial(materi, item)"
                      :class="
                        selectedMaterialItem?.data?.id == item?.data?.id
                          ? 'bg-[#E8EDFF]'
                          : 'bg-[#F5F7FD]'
                      "
                    >
                      <svg
                        v-if="item.data.is_done"
                        class="mr-2 w-4 h-4 flex-shrink-0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="8" cy="8" r="8" fill="#009DFF" />
                        <path
                          d="M6.18277 11.9412C6.3659 12.129 6.62072 12.2355 6.88703 12.2355C6.88961 12.2355 6.89232 12.2355 6.89516 12.2355C7.16457 12.2332 7.42081 12.1225 7.60252 11.9295L12.9232 6.27858C13.2839 5.89547 13.2558 5.30134 12.8609 4.95154C12.4658 4.602 11.8531 4.62893 11.4924 5.01191L6.87501 9.91578L5.43769 8.43984C5.07013 8.06261 4.45692 8.04583 4.06818 8.40189C3.67917 8.75807 3.66187 9.35246 4.02904 9.72968L6.18277 11.9412Z"
                          fill="white"
                        />
                      </svg>

                      <svg
                        v-if="item.type == 'video'"
                        class="w-4 h-4 mt-0.5 flex-shrink-0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        :fill="
                          selectedMaterialItem?.data?.id == item?.data?.id
                            ? '#00446F'
                            : '#212121'
                        "
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5263 7.59975L6.83001 5.13607C6.51001 4.92795 6.09375 5.15232 6.09375 5.53607V10.4642C6.09375 10.848 6.52562 11.0724 6.83001 10.8642L10.5263 8.40055C10.8145 8.20806 10.8145 7.7918 10.5263 7.59993V7.59975Z"
                        />
                        <path
                          d="M7.99844 0.399902C3.8066 0.399902 0.398438 3.80806 0.398438 7.9999C0.398438 12.1917 3.8066 15.5999 7.99844 15.5999C12.1903 15.5999 15.5984 12.1917 15.5984 7.9999C15.5984 3.80806 12.1903 0.399902 7.99844 0.399902ZM7.99844 14.4162C4.46212 14.4162 1.58212 11.5362 1.58212 7.9999C1.58212 4.46358 4.46212 1.58358 7.99844 1.58358C11.5348 1.58358 14.4148 4.46358 14.4148 7.9999C14.4148 11.5362 11.5348 14.4162 7.99844 14.4162Z"
                        />
                      </svg>

                      <svg
                        v-if="item.type == 'module'"
                        class="w-4 h-4 mt-0.5 flex-shrink-0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        :fill="
                          selectedMaterialItem?.data?.id == item?.data?.id
                            ? '#00446F'
                            : '#212121'
                        "
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8298 5.19262C12.8341 5.15539 12.8341 5.11762 12.8298 5.08038C12.8314 5.06743 12.8314 5.05448 12.8298 5.04153C12.8093 4.99459 12.7817 4.95088 12.7478 4.91203L9.2944 1.45868C9.25555 1.42469 9.21184 1.39717 9.1649 1.37666H9.12605L8.97496 1.3335H4.62802C3.91306 1.3335 3.33301 1.91355 3.33301 2.6285V12.9886C3.33301 13.7035 3.91306 14.2836 4.62802 14.2836H11.5347C12.2497 14.2836 12.8297 13.7035 12.8297 12.9886V5.21852V5.19262H12.8298ZM11.3578 4.78685H9.80809C9.56958 4.78685 9.37642 4.59368 9.37642 4.35518V2.80545L11.3578 4.78685ZM11.5348 13.4202H4.62808C4.38958 13.4202 4.19642 13.2271 4.19642 12.9886V2.6285C4.19642 2.39 4.38958 2.19683 4.62808 2.19683H8.51311V4.35518C8.51311 5.07014 9.09316 5.65019 9.80811 5.65019H11.9665V12.9886C11.9665 13.103 11.9211 13.213 11.8402 13.294C11.7593 13.3749 11.6492 13.4202 11.5348 13.4202L11.5348 13.4202Z"
                        />
                      </svg>

                      <svg
                        v-if="item.type == 'quiz'"
                        class="w-4 h-4 mt-0.5 flex-shrink-0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        :fill="
                          selectedMaterialItem?.data?.id == item?.data?.id
                            ? '#00446F'
                            : '#212121'
                        "
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                        />
                      </svg>

                      <div class="ml-2">
                        <p
                          class="mb-1 font-solusi text-sm"
                          :class="
                            selectedMaterialItem?.data?.id == item?.data?.id
                              ? 'text-[#00446F] font-semibold'
                              : 'text-[#212121]'
                          "
                        >
                          {{ item.data.name }}
                        </p>
                        <p class="font-solusi text-xs text-[#757575]">
                          {{
                            item.type == 'video'
                              ? item.data.duration
                              : item.type == 'quiz'
                              ? item.data.display + ' Soal'
                              : '1 Dokumen'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="flex w-full p-4 hover:opacity-80 bg-[#F5F7FD]">
                    <p class="font-solusi text-sm text-[#212121] ml-2">
                      Belum ada Materi
                    </p>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <div v-if="isExistPostTest" class="cursor-pointer flex w-full">
            <div
              class="text-left py-4 px-3 border-l-4 w-full"
              :class="
                showPostTest
                  ? 'bg-[#E8EDFF] border-[#00446F]'
                  : 'border-transparent'
              "
              @click="openPostTestPage()"
            >
              <div class="flex justify-between w-full">
                <div class="flex items-center">
                  <svg
                    v-if="isDonePostTest"
                    class="mr-2 w-4 h-4 flex-shrink-0"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="8" cy="8" r="8" fill="#009DFF" />
                    <path
                      d="M6.18277 11.9412C6.3659 12.129 6.62072 12.2355 6.88703 12.2355C6.88961 12.2355 6.89232 12.2355 6.89516 12.2355C7.16457 12.2332 7.42081 12.1225 7.60252 11.9295L12.9232 6.27858C13.2839 5.89547 13.2558 5.30134 12.8609 4.95154C12.4658 4.602 11.8531 4.62893 11.4924 5.01191L6.87501 9.91578L5.43769 8.43984C5.07013 8.06261 4.45692 8.04583 4.06818 8.40189C3.67917 8.75807 3.66187 9.35246 4.02904 9.72968L6.18277 11.9412Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    class="w-4 h-4 flex-shrink-0"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                      fill="#212121"
                    />
                  </svg>

                  <p class="font-solusi text-sm text-[#212121] ml-2">
                    Post-Test
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="tab == 'forum'"
          class="w-full order-1 md:order-2 flex mb-12 md:mb-0"
        >
          <div
            class="py-4 px-8 flex md:hidden flex-col justify-center items-center min-h-[calc(100vh-15rem)]"
          >
            <p
              class="font-solusi font-semibold text-lg text-[#212121] text-center"
            >
              Ayo Gabung Grup!
            </p>
            <p
              class="font-solusi text-[#212121] text-lg font-semibold mb-2 text-center"
            >
              Mari berintraksi dengan mentor dan member yang lainnya.
            </p>
            <div class="my-2 flex justify-center">
              <a
                :href="
                  classroomLevel.forum
                    ? classroomLevel.forum
                    : classroomLevel.whatsapp_link
                "
                target="_blank"
                class="text-[#00446F] font-solusi text-sm font-semibold px-4 py-2 rounded-full border border-gray-200 flex items-center bg-white"
              >
                <img
                  v-if="classroomLevel.forum && isDiscordLink"
                  src="/assets/images/icon/discord.svg"
                  class="mr-2 w-4 h-4"
                  alt=""
                />
                <svg
                  v-else-if="classroomLevel.forum && !isDiscordLink"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="telegram"
                  class="mr-2 w-4 h-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 496 512"
                >
                  <path
                    fill="currentColor"
                    d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                  ></path>
                </svg>
                <img
                  v-else
                  src="/assets/images/icon/whatsapp.png"
                  class="mr-2 w-5 h-5"
                  alt=""
                />
                Gabung Grup
              </a>
            </div>
          </div>
        </div>

        <div
          v-if="tab == 'ask-mentor'"
          class="w-full order-1 md:order-2 flex mb-12 md:mb-0"
        >
          <div class="py-4 px-3">
            <p class="font-desain font-semibold text-lg text-[#212121] mb-4">
              Tanya Mentor
            </p>
            <div class="font-solusi text-[#333333] text-sm mb-3">
              Jika ada kendala atau pertanyaan seputar materi yang ada di kelas
              ini, kamu bisa mengajukan pertanyaan kepada mentor melalui fitur
              ini.
            </div>
            <div class="font-solusi text-[#333333] text-sm mb-8">
              Pertanyaan akan dijawab dalam
              <span class="font-solusi text-[#333333] text-sm font-semibold"
                >sesi webinar atau video sesi tanya jawab</span
              >
              yang akan tayang setiap minggunya.
            </div>
            <p class="font-desain text-[#212121] text-lg font-semibold mb-2">
              Pertanyaan yang kamu ajukan:
            </p>
            <div
              v-if="loadingUserQuestion"
              class="flex flex-col items-center justify-center mt-3"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="spinner"
                class="w-5 h-5 animate-spin"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#00446F"
                  d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                ></path>
              </svg>
              <p class="font-solusi text-sm text-[#00446F] font-semibold mt-1">
                Loading...
              </p>
            </div>
            <div v-else>
              <div
                v-if="listUserQuestion?.length"
                class="divide-y-2 divide-[#F5F6F8]"
              >
                <div
                  v-for="(question, i) in listUserQuestion"
                  :key="i"
                  class="pl-2"
                >
                  <div class="grid grid-cols-12 py-3">
                    <span class="col-span-1 font-solusi text-sm text-[#212121]">
                      {{ i + 1 }}.
                    </span>
                    <span
                      class="font-solusi text-sm text-[#212121]"
                      :class="question.file ? 'col-span-9' : 'col-span-11'"
                    >
                      {{ question.question }}
                    </span>
                    <a
                      v-if="question.file"
                      class="col-span-2 flex items-center w-full rounded-full text-[#009DFF] border border-[#009DFF] text-2xs font-solusi font-semibold justify-center py-0.5 hover:text-[#FFFFFF] hover:bg-[#009DFF] h-fit-content"
                      :href="question.file"
                      target="_blank"
                    >
                      <svg
                        class="mr-1 w-4 h-4"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3288 5.19213C13.3331 5.1549 13.3331 5.11713 13.3288 5.0799C13.3304 5.06695 13.3304 5.054 13.3288 5.04105C13.3083 4.9941 13.2808 4.9504 13.2468 4.91155L9.79342 1.45819C9.75457 1.4242 9.71087 1.39668 9.66392 1.37617H9.62507L9.47398 1.33301H5.12704C4.41208 1.33301 3.83203 1.91306 3.83203 2.62802V12.9881C3.83203 13.703 4.41208 14.2831 5.12704 14.2831H12.0337C12.7487 14.2831 13.3288 13.703 13.3288 12.9881V5.21803V5.19213H13.3288ZM11.8568 4.78636H10.3071C10.0686 4.78636 9.87544 4.59319 9.87544 4.35469V2.80497L11.8568 4.78636ZM12.0338 13.4197H5.12711C4.88861 13.4197 4.69544 13.2266 4.69544 12.9881V2.62802C4.69544 2.38951 4.88861 2.19635 5.12711 2.19635H9.01213V4.35469C9.01213 5.06965 9.59218 5.6497 10.3071 5.6497H12.4655V12.9881C12.4655 13.1025 12.4202 13.2125 12.3392 13.2935C12.2583 13.3744 12.1482 13.4197 12.0338 13.4197L12.0338 13.4197Z"
                          fill="currentColor"
                        />
                      </svg>
                      File
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="font-solusi text-[#212121] text-sm ml-2">
                Belum ada pertanyaan yang diajukan
              </p>
            </div>
          </div>
        </div>

        <div v-if="tab == 'task'" class="w-full order-1 md:order-2 flex">
          <div
            class="flex flex-col w-full relative space-y-6 md:space-y-3 mt-6 md:mt-3"
          >
            <div
              v-for="(task, i) in tasks"
              :key="i"
              @click="openTask(task)"
              class="p-2 flex flex-col mx-2 rounded-lg cursor-pointer shadow "
              :class="
                selectedTask.id == task.id
                  ? 'border bg-[#EEF2FF] border-[#0A72ED] border-opacity-50 ring-2 ring-[#0A72ED] ring-opacity-60'
                  : 'border bg-[#FFFFFF] border-[#F5F6F8]'
              "
            >
              <div class="flex justify-between items-center">
                <span
                  v-if="task?.started_at >= dateNow"
                  class="font-solusi text-xs text-[#0A72ED]"
                >
                  Dimulai {{ dateFormat(task?.started_at) }} WIB
                </span>
                <span v-else class="font-solusi text-xs text-[#DE1306]">
                  Batas {{ dateFormat(task?.expired_at) }} WIB
                </span>
                <span
                  class="flex items-center px-2 py-0.5 font-solusi text-[#FFFFFF] font-semibold text-2xs rounded-full text-center flex-shrink-0 self-start"
                  :class="
                    task?.started_at >= dateNow
                      ? 'bg-[#0A72ED]'
                      : task?.score > 0
                      ? 'bg-[#2FBD71]'
                      : task?.file
                      ? 'bg-[#757575]'
                      : task?.expired_at >= dateNow
                      ? 'bg-[#FB8500]'
                      : 'bg-[#DE1306]'
                  "
                >
                  <svg
                    v-if="task?.score > 0"
                    class="-mt-0.5 mr-1 w-3 h-3"
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6.58301" cy="6" r="6" fill="white" />
                    <path
                      d="M5.21984 8.95562C5.35719 9.09652 5.5483 9.17636 5.74803 9.17636C5.74997 9.17636 5.752 9.17636 5.75414 9.17636C5.95619 9.17466 6.14837 9.09163 6.28466 8.94689L10.2751 4.70869C10.5457 4.42136 10.5246 3.97576 10.2284 3.71341C9.93214 3.45126 9.47262 3.47145 9.20208 3.75869L5.73902 7.43659L4.66103 6.32963C4.38536 6.04672 3.92545 6.03413 3.6339 6.30117C3.34214 6.56831 3.32916 7.0141 3.60455 7.29701L5.21984 8.95562Z"
                      fill="#2FBD71"
                    />
                  </svg>
                  {{
                    task?.started_at >= dateNow
                      ? 'Belum Mulai'
                      : task?.score > 0
                      ? 'Sudah Dinilai'
                      : task?.file
                      ? 'Menunggu Review'
                      : task?.expired_at >= dateNow
                      ? 'Belum Unggah'
                      : 'Terlambat'
                  }}
                </span>
              </div>
              <p
                class="font-desain text-[#212121] text-base truncate overflow-hidden font-semibold"
              >
                {{ task?.name }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="tab == 'webinar'" class="w-full order-1 md:order-2 flex">
          <div
            class="flex flex-col w-full relative divide-y-8 divide-[#F5F6F8]"
          >
            <div class="text-left">
              <a
                class="flex w-full py-4 px-3 cursor-pointer border-b border-[#F5F6F8]"
                @click="toggleWebinar()"
              >
                <div class="flex justify-between items-center w-full">
                  <p class="font-solusi text-base text-[#212121] font-semibold">
                    Jadwal Webinar
                  </p>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chevron-up"
                    class="w-4 h-4 self-center duration-500 flex-shrink-0"
                    :class="showWebinarList ? 'rotate-0' : 'rotate-180'"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                    ></path>
                  </svg>
                </div>
              </a>
              <transition name="collapse">
                <div v-if="showWebinarList">
                  <div class="hidden md:block">
                    <div
                      @click="changeFilterWebinar('waiting')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterWebinar == 'waiting'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Akan Berlangsung ({{ countWebinarWaiting }})
                    </div>
                    <div
                      @click="changeFilterWebinar('ongoing')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterWebinar == 'ongoing'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Sedang Berlangsung ({{ countWebinarOnGoing }})
                    </div>
                    <div
                      @click="changeFilterWebinar('done')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterWebinar == 'done'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Selesai ({{ countWebinarDone }})
                    </div>
                  </div>
                  <div class="block md:hidden">
                    <div
                      v-dragscroll
                      class="w-full flex md:hidden my-3 flex-row items-center overflow-auto scroll-hide space-x-2"
                    >
                      <button
                        ref="waiting"
                        @click="changeFilterWebinar('waiting')"
                        class="ml-2 flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterWebinar == 'waiting'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Akan Berlangsung ({{ countWebinarWaiting }})
                      </button>
                      <button
                        ref="ongoing"
                        @click="changeFilterWebinar('ongoing')"
                        class="flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterWebinar == 'ongoing'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Sedang Berlangsung ({{ countWebinarOnGoing }})
                      </button>
                      <button
                        ref="done"
                        @click="changeFilterWebinar('done')"
                        class="flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterWebinar == 'done'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Selesai ({{ countWebinarDone }})
                      </button>
                    </div>
                    <div v-if="listWebinar" class="p-3">
                      <div
                        v-for="webinar in listWebinar"
                        :key="'w-' + webinar.id"
                      >
                        <CardWebinar
                          :onClickWebinar="onClickWebinar"
                          :onClickPreTest="onClickPreTest"
                          :onClickPostTest="onClickPostTest"
                          :preTest="preTest"
                          :postTest="postTest"
                          :webinar="webinar"
                          :onClickRequestWebinarPlus="onClickRequestWebinarPlus"
                        />
                      </div>
                    </div>
                    <div
                      v-else
                      class="px-3 py-14 flex flex-col justify-center items-center"
                    >
                      <img
                        src="/assets/images/modal/ilustration-webinar.svg"
                        alt=""
                        class="w-1/2"
                      />
                      <p
                        class="text-center mt-3 font-solusi font-semibold text-[#333333]"
                      >
                        Belum ada webinar yang
                        {{
                          filterWebinar == 'waiting'
                            ? 'akan berlangsung'
                            : filterWebinar == 'ongoing'
                            ? 'sedang berlangsung'
                            : 'selesai'
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="text-left">
              <a
                class="flex w-full py-4 px-3 cursor-pointer border-b border-[#F5F6F8]"
                @click="toggleWebinarRecord()"
              >
                <div class="flex justify-between items-center w-full">
                  <p class="font-solusi text-base text-[#212121] font-semibold">
                    Rekaman Webinar
                  </p>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chevron-up"
                    class="w-4 h-4 self-center duration-500 flex-shrink-0"
                    :class="showWebinarRecordList ? 'rotate-0' : 'rotate-180'"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                    ></path>
                  </svg>
                </div>
              </a>
              <transition name="collapse">
                <div
                  v-if="showWebinarRecordList"
                  class="divide-y divide-gray-100"
                >
                  <p
                    v-if="webinarRecord?.length == 0"
                    class="font-solusi py-4 pl-6 pr-4 text-sm  text-[#212121]"
                  >
                    Belum ada rekaman webinar
                  </p>
                  <div
                    v-show="webinarRecord"
                    v-for="(record, i) in webinarRecord"
                    :key="i"
                    @click="openWebinarRecord(record)"
                    class="hover:opacity-80 cursor-pointer"
                  >
                    <div
                      class="py-1.5 px-3 border-l-4 space-x-2 w-full grid grid-cols-12"
                      :class="
                        selectedWebinarRecord?.id == record.id
                          ? 'bg-[#E8EDFF] border-[#00446F]'
                          : ' border-transparent'
                      "
                    >
                      <div
                        class="col-span-10 flex flex-row items-center font-solusi text-sm"
                        :class="
                          selectedWebinarRecord?.id == record.id
                            ? 'font-semibold text-[#00446F]'
                            : 'text-[#212121]'
                        "
                      >
                        <svg
                          v-if="record.is_viewed"
                          class="mr-2 w-4 h-4 flex-shrink-0"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8" cy="8" r="8" fill="#009DFF" />
                          <path
                            d="M6.18277 11.9412C6.3659 12.129 6.62072 12.2355 6.88703 12.2355C6.88961 12.2355 6.89232 12.2355 6.89516 12.2355C7.16457 12.2332 7.42081 12.1225 7.60252 11.9295L12.9232 6.27858C13.2839 5.89547 13.2558 5.30134 12.8609 4.95154C12.4658 4.602 11.8531 4.62893 11.4924 5.01191L6.87501 9.91578L5.43769 8.43984C5.07013 8.06261 4.45692 8.04583 4.06818 8.40189C3.67917 8.75807 3.66187 9.35246 4.02904 9.72968L6.18277 11.9412Z"
                            fill="white"
                          />
                        </svg>
                        {{ record.name }}
                      </div>
                      <div
                        class="col-span-2 flex flex-col items-center justify-center"
                      >
                        <svg
                          v-if="record.type == 'Youtube'"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="youtube"
                          class="w-6 h-6 svg-inline--fa fa-youtube fa-w-18"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 576 512"
                        >
                          <path
                            fill="#FF0000"
                            d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                          ></path>
                        </svg>
                        <div
                          v-else
                          class="w-7 h-5 mb-1 rounded-md bg-[#2D8CFF] flex items-center justify-center"
                        >
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="video"
                            class="w-4 h-3"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="#FFFFFF"
                              d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                            ></path>
                          </svg>
                        </div>
                        <span class="font-solusi text-2xs text-[#333333]">
                          {{ record.type }}
                        </span>
                      </div>
                      <p
                        v-if="record.live_at"
                        class="col-span-12 text-2xs font-solusi text-[#333333]"
                      >
                        Berlangsung pada {{ dateFormat(record.live_at) }}
                      </p>
                      <p
                        v-if="record.expired_at"
                        class="col-span-12 text-2xs font-solusi text-[#DE1306]"
                      >
                        Kadaluarsa pada {{ dateFormat(record.expired_at) }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <!-- Sidebar Konsultasi Desain -->
        <div
          v-if="tab == 'konsultasi-desain'"
          class="w-full order-1 md:order-2 flex mb-12 md:mb-0 md:h-[calc(100%-3rem)]"
        >
          <div
            class="flex flex-col justify-between w-full relative divide-y-8 divide-[#F5F6F8]"
          >
            <div class="text-left">
              <div class="flex w-full py-4 px-3 border-b border-[#F5F6F8]">
                <div class="flex justify-between items-center w-full">
                  <p class="font-solusi text-base text-[#212121] font-semibold">
                    Jadwal Konsultasi Desain
                  </p>
                </div>
              </div>
              <transition name="collapse">
                <div v-if="showWebinarList">
                  <div class="hidden md:block">
                    <div
                      @click="changeFilterPrivateWebinar('requested')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterPrivateWebinar == 'requested'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Pengajuan Konsultasi
                      {{
                        countPrivateWebinarRequested > 0
                          ? '(' + countPrivateWebinarRequested + ')'
                          : ''
                      }}
                    </div>
                    <div
                      @click="changeFilterPrivateWebinar('approved')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterPrivateWebinar == 'approved'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Yang telah disetujui
                      {{
                        countPrivateWebinarApproved > 0
                          ? '(' + countPrivateWebinarApproved + ')'
                          : ''
                      }}
                    </div>
                    <div
                      @click="changeFilterPrivateWebinar('rejected')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterPrivateWebinar == 'rejected'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Pengajuan ditolak
                      {{
                        countPrivateWebinarRejected > 0
                          ? '(' + countPrivateWebinarRejected + ')'
                          : ''
                      }}
                    </div>
                    <div
                      @click="changeFilterPrivateWebinar('all')"
                      class="py-4 px-3 border-l-4 flex w-full hover:opacity-80 cursor-pointer font-solusi text-sm"
                      :class="
                        filterPrivateWebinar == 'all'
                          ? 'font-semibold text-[#00446F] bg-[#E8EDFF] border-[#00446F]'
                          : 'text-[#212121] border-transparent'
                      "
                    >
                      Semua
                    </div>
                  </div>
                  <div class="block md:hidden">
                    <div
                      v-dragscroll
                      class="w-full flex md:hidden my-3 flex-row items-center overflow-auto scroll-hide space-x-2"
                    >
                      <button
                        ref="requested"
                        @click="changeFilterPrivateWebinar('requested')"
                        class="ml-2 flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterPrivateWebinar == 'requested'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Pengajuan Konsultasi
                        {{
                          countPrivateWebinarRequested > 0
                            ? '(' + countPrivateWebinarRequested + ')'
                            : ''
                        }}
                      </button>
                      <button
                        ref="approved"
                        @click="changeFilterPrivateWebinar('approved')"
                        class="flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterPrivateWebinar == 'approved'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Disetujui
                        {{
                          countPrivateWebinarApproved > 0
                            ? '(' + countPrivateWebinarApproved + ')'
                            : ''
                        }}
                      </button>
                      <button
                        ref="rejected"
                        @click="changeFilterPrivateWebinar('rejected')"
                        class="flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterPrivateWebinar == 'rejected'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Ditolak
                        {{
                          countPrivateWebinarRejected > 0
                            ? '(' + countPrivateWebinarRejected + ')'
                            : ''
                        }}
                      </button>
                      <button
                        ref="all"
                        @click="changeFilterPrivateWebinar('all')"
                        class="flex flex-shrink-0 px-4 py-2 font-solusi text-sm font-semibold rounded-full"
                        :class="
                          filterPrivateWebinar == 'all'
                            ? 'text-white bg-[#00446F]'
                            : 'text-[#00446F] bg-[#F5F6F8]'
                        "
                      >
                        Semua
                      </button>
                    </div>
                    <div v-if="privateWebinar?.length > 0" class="p-3">
                      <div
                        v-for="webinar in privateWebinar"
                        :key="'w-' + webinar.id"
                        class="last:pb-3"
                      >
                        <CardPrivateWebinar
                          :classroom="classroomLevel.classroom"
                          :startDate="webinar.started_at"
                          :expiredDate="webinar.expired_at"
                          :webinar="webinar"
                          :joinPrivateWebinar="joinPrivateWebinar"
                          :quota="classroomLevel.quota_private"
                          @reApply="openModalReapplyPrivateWebinar"
                        />
                      </div>
                    </div>
                    <div
                      v-else
                      class="px-3 py-14 flex flex-col justify-center items-center"
                    >
                      <img
                        src="/assets/images/mentor/empty-state.svg"
                        alt=""
                        class="w-3/4"
                      />
                      <p
                        class="text-center mt-3 font-solusi font-semibold text-[#333333]"
                      >
                        Belum ada jadwal konsultasi desain.
                      </p>
                      <p
                        class="text-center mt-1 font-solusi font-semibold text-[#333333]"
                      >
                        Jika ingin mengajukan konsultasi desain, tekan tombol
                        "Pengajuan Konsultasi".
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="w-full hidden md:flex flex-col items-start px-3">
              <p
                class="text-base text-[#9E9E9E] font-solusi font-semibold flex-shrink-0 mb-2"
              >
                Kuota: {{ classroomLevel?.quota_private }}
              </p>
              <div class="w-full flex flex-row gap-1">
                <button
                  @click="openModalAddQuota"
                  class="flex-grow text-[#009DFF] hover:text-[#FFFFFF] hover:bg-[#009DFF] font-solusi px-1.5 py-1.5 rounded-full border border-[#009DFF] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
                >
                  <svg
                    class="w-4 h-4 mr-1"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.713 8.95303H8.95108V13.7149C8.95108 14.2387 8.52251 14.6673 7.9987 14.6673C7.47489 14.6673 7.04632 14.2387 7.04632 13.7149V8.95303H2.28441C1.7606 8.95303 1.33203 8.52446 1.33203 8.00065C1.33203 7.47684 1.7606 7.04827 2.28441 7.04827H7.04632V2.28637C7.04632 1.76256 7.47489 1.33398 7.9987 1.33398C8.52251 1.33398 8.95108 1.76256 8.95108 2.28637V7.04827H13.713C14.2368 7.04827 14.6654 7.47684 14.6654 8.00065C14.6654 8.52446 14.2368 8.95303 13.713 8.95303Z"
                      fill="currentColor"
                    />
                  </svg>
                  Kuota Konsultasi
                </button>
                <button
                  v-if="classroomLevel.quota_private > 0"
                  @click="openModalPrivateWebinar"
                  class="flex-shrink-0 text-[#FB8500] hover:text-[#FFFFFF] hover:bg-[#FB8500] font-solusi px-1.5 py-1.5 rounded-full border border-[#FB8500] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
                  style="flex-basis:content;"
                >
                  <svg
                    class="h-4 mr-1"
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.49664 5.85239C8.24559 5.85239 8.92116 5.40135 9.20756 4.70917C9.49401 4.01699 9.33568 3.22065 8.806 2.69092C8.27631 2.16123 7.47997 2.0029 6.78775 2.28936C6.09609 2.57633 5.64453 3.25133 5.64453 4.00028C5.64453 4.49143 5.83984 4.96278 6.18723 5.30965C6.53463 5.65704 7.00545 5.85235 7.4966 5.85235L7.49664 5.85239ZM7.49664 2.88935C7.94611 2.88935 8.35132 3.16017 8.52319 3.57527C8.69507 3.99038 8.60027 4.46849 8.28204 4.7862C7.96434 5.1039 7.48674 5.1987 7.07164 5.02682C6.65602 4.85494 6.38571 4.44975 6.38571 4.00027C6.38571 3.38673 6.88311 2.88935 7.49664 2.88935Z"
                      fill="currentColor"
                    />
                    <path
                      d="M13.7949 0.666017H1.20233C0.997643 0.666017 0.832031 0.832162 0.832031 1.03632V9.92532C0.832031 10.0238 0.871094 10.118 0.940364 10.1873C1.01016 10.2566 1.10443 10.2956 1.20233 10.2956H13.7949C13.8928 10.2956 13.9871 10.2566 14.0569 10.1873C14.1261 10.118 14.1652 10.0237 14.1652 9.92532V1.03632C14.1652 0.938404 14.1261 0.844136 14.0569 0.774869C13.9871 0.705078 13.8928 0.666016 13.7949 0.666016V0.666017ZM4.19138 9.55501C4.44659 8.88887 4.90126 8.31857 5.49345 7.92063C6.08511 7.52271 6.78562 7.31751 7.49863 7.3326C8.41893 7.32583 9.30688 7.67167 9.97981 8.29926C10.348 8.64822 10.6298 9.0779 10.8022 9.55499L4.19138 9.55501ZM13.4246 9.55501H11.5725C11.5777 9.5196 11.5777 9.48314 11.5725 9.44772C11.3647 8.80606 10.998 8.22742 10.5059 7.766C9.6918 7.00246 8.61467 6.58164 7.49855 6.59205C6.60429 6.5707 5.72617 6.8358 4.99284 7.34882C4.26003 7.86184 3.71055 8.59621 3.42458 9.44413C3.41885 9.48059 3.41885 9.51809 3.42458 9.55507H1.57247V1.40727H13.4245L13.4246 9.55501Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.2034 11.0371H3.79608C3.59139 11.0371 3.42578 11.2033 3.42578 11.4079C3.42578 11.6121 3.59141 11.7782 3.79608 11.7782H11.2034C11.4081 11.7782 11.5737 11.6121 11.5737 11.4079C11.5737 11.2032 11.408 11.0371 11.2034 11.0371Z"
                      fill="currentColor"
                    />
                  </svg>
                  Pengajuan Konsultasi
                </button>
                <button
                  v-else
                  v-tooltip="{
                    content: `<p class='font-solusi text-2xs text-[#212121]'>Mohon maaf, tambahkan kuotamu terlebih</p><p class='font-solusi text-2xs text-[#212121]'>dahulu untuk mengajukan konsultasi desain.</p>`,
                    placement: 'top',
                    triggers: ['click'],
                    autoHide: true,
                    html: true,
                    theme: 'consultation',
                  }"
                  class="flex-shrink-0 text-[#FB8500] hover:text-[#FFFFFF] hover:bg-[#FB8500] font-solusi px-1.5 py-1.5 rounded-full border border-[#FB8500] text-sm md:text-xs flex items-center justify-center w-full font-semibold duration-300"
                  style="flex-basis:content;"
                >
                  <svg
                    class="h-4 mr-1"
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.49664 5.85239C8.24559 5.85239 8.92116 5.40135 9.20756 4.70917C9.49401 4.01699 9.33568 3.22065 8.806 2.69092C8.27631 2.16123 7.47997 2.0029 6.78775 2.28936C6.09609 2.57633 5.64453 3.25133 5.64453 4.00028C5.64453 4.49143 5.83984 4.96278 6.18723 5.30965C6.53463 5.65704 7.00545 5.85235 7.4966 5.85235L7.49664 5.85239ZM7.49664 2.88935C7.94611 2.88935 8.35132 3.16017 8.52319 3.57527C8.69507 3.99038 8.60027 4.46849 8.28204 4.7862C7.96434 5.1039 7.48674 5.1987 7.07164 5.02682C6.65602 4.85494 6.38571 4.44975 6.38571 4.00027C6.38571 3.38673 6.88311 2.88935 7.49664 2.88935Z"
                      fill="currentColor"
                    />
                    <path
                      d="M13.7949 0.666017H1.20233C0.997643 0.666017 0.832031 0.832162 0.832031 1.03632V9.92532C0.832031 10.0238 0.871094 10.118 0.940364 10.1873C1.01016 10.2566 1.10443 10.2956 1.20233 10.2956H13.7949C13.8928 10.2956 13.9871 10.2566 14.0569 10.1873C14.1261 10.118 14.1652 10.0237 14.1652 9.92532V1.03632C14.1652 0.938404 14.1261 0.844136 14.0569 0.774869C13.9871 0.705078 13.8928 0.666016 13.7949 0.666016V0.666017ZM4.19138 9.55501C4.44659 8.88887 4.90126 8.31857 5.49345 7.92063C6.08511 7.52271 6.78562 7.31751 7.49863 7.3326C8.41893 7.32583 9.30688 7.67167 9.97981 8.29926C10.348 8.64822 10.6298 9.0779 10.8022 9.55499L4.19138 9.55501ZM13.4246 9.55501H11.5725C11.5777 9.5196 11.5777 9.48314 11.5725 9.44772C11.3647 8.80606 10.998 8.22742 10.5059 7.766C9.6918 7.00246 8.61467 6.58164 7.49855 6.59205C6.60429 6.5707 5.72617 6.8358 4.99284 7.34882C4.26003 7.86184 3.71055 8.59621 3.42458 9.44413C3.41885 9.48059 3.41885 9.51809 3.42458 9.55507H1.57247V1.40727H13.4245L13.4246 9.55501Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.2034 11.0371H3.79608C3.59139 11.0371 3.42578 11.2033 3.42578 11.4079C3.42578 11.6121 3.59141 11.7782 3.79608 11.7782H11.2034C11.4081 11.7782 11.5737 11.6121 11.5737 11.4079C11.5737 11.2032 11.408 11.0371 11.2034 11.0371Z"
                      fill="currentColor"
                    />
                  </svg>
                  Pengajuan Konsultasi
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- End Sidebar Konsultasi Desain -->
      </div>
      <div
        v-if="tab == 'materi'"
        class="w-full md:w-[75%] order-1 md:order-2 bg-[#F9FCFF] flex"
      >
        <div
          v-if="showPrePost"
          class="flex flex-col w-full h-full relative min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-7rem)]"
        >
          <div v-dragscroll id="scroll-quiz" class="header-quiz">
            <div
              :id="'q' + i"
              :ref="'q' + i"
              v-for="(item, i) in prePostTestData.items?.length"
              :key="i"
              class="question-number"
              :class="
                questionIndex == i
                  ? 'question-selected'
                  : payloadQuiz.answers[i] != null
                  ? 'blue-sd-1'
                  : ''
              "
              @click="changeQuestion(i)"
            >
              {{ i + 1 }}
            </div>
          </div>
          <div class="body-quiz">
            <div class="question-body">
              <p class="font-solusi font-semibold text-[#212121] text-lg mb-3">
                {{ prePostTestData?.items[questionIndex].question }}
              </p>
              <div
                v-show="
                  prePostTestData?.items[questionIndex].choices?.length > 0
                "
                v-for="(choice, j) in prePostTestData?.items[questionIndex]
                  .choices"
                :key="j"
                class="answer text-left mb-4"
              >
                <label class="form-check-label cursor-pointer flex">
                  <input
                    class="form-check-input hidden cursor-pointer"
                    type="radio"
                    :value="j"
                    v-model="payloadQuiz.answers[questionIndex]"
                  />
                  <div class="flex">
                    <span
                      class="btn-choice mr-2 font-solusi"
                      :class="
                        j == payloadQuiz.answers[questionIndex]
                          ? 'choice-selected'
                          : ''
                      "
                    >
                      {{
                        j == 0
                          ? 'A'
                          : j == 1
                          ? 'B'
                          : j == 2
                          ? 'C'
                          : j == 3
                          ? 'D'
                          : j == 4
                          ? 'E'
                          : j == 5
                          ? 'F'
                          : j == 6
                          ? 'G'
                          : j == 7
                          ? 'H'
                          : j == 8
                          ? 'I'
                          : 'J'
                      }}
                    </span>
                    <span class="m-0 self-center font-solusi text-[#212121]">{{
                      choice
                    }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="flex justify-end space-x-6 px-4 py-3">
              <button
                v-if="questionIndex != 0"
                class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                @click="prevQuestion()"
              >
                <svg
                  class="w-4 h-4 mr-2"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.7326 10.2599C1.73594 10.269 1.73594 10.2782 1.7401 10.2874C1.7401 10.289 1.7401 10.2899 1.74094 10.2915C1.79094 10.4099 1.86427 10.5099 1.94927 10.5999C1.95844 10.6099 1.96177 10.6224 1.97094 10.6324L8.34427 16.9474C8.55177 17.1524 8.82344 17.2549 9.0951 17.2549C9.36677 17.2549 9.6376 17.1524 9.8451 16.9474C10.2601 16.5365 10.2601 15.8715 9.8451 15.4607L5.28344 10.9399L17.5876 10.9399C18.1743 10.9399 18.6484 10.4699 18.6484 9.88822C18.6484 9.30822 18.1743 8.83738 17.5876 8.83738L5.28427 8.83738L9.84594 4.29405C10.2609 3.88405 10.2609 3.21822 9.84594 2.80822C9.43177 2.39738 8.75927 2.39738 8.34427 2.80822L1.97094 9.14488C1.87927 9.23572 1.81344 9.34322 1.76177 9.45655C1.7451 9.49155 1.73594 9.52572 1.72427 9.56072C1.69594 9.64572 1.67844 9.73072 1.67261 9.82072C1.6701 9.85738 1.66511 9.89155 1.66677 9.92822C1.67094 10.0415 1.69094 10.1515 1.7326 10.2599Z"
                    fill="#009DFF"
                  />
                </svg>
                Sebelumnya
              </button>
              <button
                v-if="prePostTestData?.items?.length != questionIndex + 1"
                class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                @click="nextQuestion()"
              >
                Selanjutnya
                <svg
                  class="w-4 h-4 ml-2"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.5838 9.495C18.5805 9.48583 18.5805 9.47667 18.5763 9.4675C18.5763 9.46583 18.5763 9.465 18.5755 9.46333C18.5255 9.345 18.4521 9.245 18.3671 9.155C18.358 9.145 18.3546 9.1325 18.3455 9.1225L11.9721 2.8075C11.7646 2.6025 11.493 2.5 11.2213 2.5C10.9496 2.5 10.6788 2.6025 10.4713 2.8075C10.0563 3.21833 10.0563 3.88333 10.4713 4.29417L15.033 8.815H2.7288C2.14214 8.815 1.66797 9.285 1.66797 9.86667C1.66797 10.4467 2.14214 10.9175 2.7288 10.9175H15.0321L10.4705 15.4608C10.0555 15.8708 10.0555 16.5367 10.4705 16.9467C10.8846 17.3575 11.5571 17.3575 11.9721 16.9467L18.3455 10.61C18.4371 10.5192 18.503 10.4117 18.5546 10.2983C18.5713 10.2633 18.5805 10.2292 18.5921 10.1942C18.6205 10.1092 18.638 10.0242 18.6438 9.93417C18.6463 9.8975 18.6513 9.86333 18.6496 9.82667C18.6455 9.71333 18.6255 9.60333 18.5838 9.495Z"
                    fill="#009DFF"
                  />
                </svg>
              </button>
              <button
                v-if="prePostTestData?.items?.length == questionIndex + 1"
                class="font-solusi font-semibold text-[#FFFFFF] bg-[#00446F] border border-[#00446F] rounded-full flex items-center py-1 px-5"
                @click="showConfirmPrePostTest()"
              >
                Akhiri {{ isDonePreTest ? 'Post-Test' : 'Pre-Test' }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="showQuiz"
          class="flex flex-col w-full h-full relative min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-7rem)]"
        >
          <div v-dragscroll id="scroll-quiz" class="header-quiz">
            <div
              :id="'q' + i"
              :ref="'q' + i"
              v-for="(item, i) in quizData.items?.length"
              :key="i"
              class="question-number"
              :class="
                questionIndex == i
                  ? 'question-selected'
                  : payloadQuiz.answers[i] != null
                  ? 'blue-sd-1'
                  : ''
              "
              @click="changeQuestion(i)"
            >
              {{ i + 1 }}
            </div>
          </div>
          <div class="body-quiz">
            <div class="question-body">
              <p class="font-solusi font-semibold text-[#212121] text-lg mb-3">
                {{ quizData?.items[questionIndex].question }}
              </p>
              <div
                v-show="quizData?.items[questionIndex].choices?.length > 0"
                v-for="(choice, j) in quizData?.items[questionIndex].choices"
                :key="j"
                class="answer text-left mb-4"
              >
                <label class="form-check-label cursor-pointer flex">
                  <input
                    class="form-check-input hidden cursor-pointer"
                    type="radio"
                    :value="j"
                    v-model="payloadQuiz.answers[questionIndex]"
                  />
                  <div class="flex">
                    <span
                      class="btn-choice mr-2 font-solusi"
                      :class="
                        j == payloadQuiz.answers[questionIndex]
                          ? 'choice-selected'
                          : ''
                      "
                    >
                      {{
                        j == 0
                          ? 'A'
                          : j == 1
                          ? 'B'
                          : j == 2
                          ? 'C'
                          : j == 3
                          ? 'D'
                          : j == 4
                          ? 'E'
                          : j == 5
                          ? 'F'
                          : j == 6
                          ? 'G'
                          : j == 7
                          ? 'H'
                          : j == 8
                          ? 'I'
                          : 'J'
                      }}
                    </span>
                    <span class="m-0 self-center font-solusi text-[#212121]">{{
                      choice
                    }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="flex justify-end space-x-6 px-4 py-3">
              <button
                v-if="questionIndex != 0"
                class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                @click="prevQuestion()"
              >
                <svg
                  class="w-4 h-4 mr-2"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.7326 10.2599C1.73594 10.269 1.73594 10.2782 1.7401 10.2874C1.7401 10.289 1.7401 10.2899 1.74094 10.2915C1.79094 10.4099 1.86427 10.5099 1.94927 10.5999C1.95844 10.6099 1.96177 10.6224 1.97094 10.6324L8.34427 16.9474C8.55177 17.1524 8.82344 17.2549 9.0951 17.2549C9.36677 17.2549 9.6376 17.1524 9.8451 16.9474C10.2601 16.5365 10.2601 15.8715 9.8451 15.4607L5.28344 10.9399L17.5876 10.9399C18.1743 10.9399 18.6484 10.4699 18.6484 9.88822C18.6484 9.30822 18.1743 8.83738 17.5876 8.83738L5.28427 8.83738L9.84594 4.29405C10.2609 3.88405 10.2609 3.21822 9.84594 2.80822C9.43177 2.39738 8.75927 2.39738 8.34427 2.80822L1.97094 9.14488C1.87927 9.23572 1.81344 9.34322 1.76177 9.45655C1.7451 9.49155 1.73594 9.52572 1.72427 9.56072C1.69594 9.64572 1.67844 9.73072 1.67261 9.82072C1.6701 9.85738 1.66511 9.89155 1.66677 9.92822C1.67094 10.0415 1.69094 10.1515 1.7326 10.2599Z"
                    fill="#009DFF"
                  />
                </svg>
                Sebelumnya
              </button>
              <button
                v-if="quizData?.items?.length != questionIndex + 1"
                class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                @click="nextQuestion()"
              >
                Selanjutnya
                <svg
                  class="w-4 h-4 ml-2"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.5838 9.495C18.5805 9.48583 18.5805 9.47667 18.5763 9.4675C18.5763 9.46583 18.5763 9.465 18.5755 9.46333C18.5255 9.345 18.4521 9.245 18.3671 9.155C18.358 9.145 18.3546 9.1325 18.3455 9.1225L11.9721 2.8075C11.7646 2.6025 11.493 2.5 11.2213 2.5C10.9496 2.5 10.6788 2.6025 10.4713 2.8075C10.0563 3.21833 10.0563 3.88333 10.4713 4.29417L15.033 8.815H2.7288C2.14214 8.815 1.66797 9.285 1.66797 9.86667C1.66797 10.4467 2.14214 10.9175 2.7288 10.9175H15.0321L10.4705 15.4608C10.0555 15.8708 10.0555 16.5367 10.4705 16.9467C10.8846 17.3575 11.5571 17.3575 11.9721 16.9467L18.3455 10.61C18.4371 10.5192 18.503 10.4117 18.5546 10.2983C18.5713 10.2633 18.5805 10.2292 18.5921 10.1942C18.6205 10.1092 18.638 10.0242 18.6438 9.93417C18.6463 9.8975 18.6513 9.86333 18.6496 9.82667C18.6455 9.71333 18.6255 9.60333 18.5838 9.495Z"
                    fill="#009DFF"
                  />
                </svg>
              </button>
              <button
                v-if="quizData?.items?.length == questionIndex + 1"
                class="font-solusi font-semibold text-[#FFFFFF] bg-[#00446F] border border-[#00446F] rounded-full flex items-center py-1 px-5"
                @click="showConfirmQuiz()"
              >
                Akhiri {{ quizData?.name }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-show="!showQuiz && !showPrePost"
          ref="materi"
          class="flex flex-col w-full"
        >
          <div
            v-if="!isDonePreTest"
            class="w-full h-full flex justify-center items-center bg-gradient-to-b from-[#00446F] to-[#088BD5] min-h-[40vh]"
          >
            <div class="m-auto flex flex-col items-center justify-center">
              <svg
                class="w-10 h-10"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#FFFFFF"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                />
              </svg>
              <span class="font-solusi text-[#FFFFFF] font-semibold mt-3">
                Pre-Test
              </span>
              <span class="font-solusi text-sm text-[#FFFFFF] mb-5">
                {{ prePostTestData.items?.length }} Soal
              </span>
              <button
                @click="openModalPreTest()"
                class="font-solusi bg-[#00446F] text-[#FFFFFF] py-2 px-12 rounded-full font-semibold"
              >
                Mulai Pre Test
              </button>
            </div>
          </div>
          <div
            v-if="showPostTest"
            class="w-full h-full flex justify-center items-center bg-gradient-to-b from-[#00446F] to-[#088BD5] min-h-[40vh]"
          >
            <div
              v-if="isAttemptPostTest"
              class="m-auto md:w-[38%] w-full p-5 md:p-3"
            >
              <img
                :src="
                  postTestClass.is_done
                    ? '/assets/images/modal/illustration-success.svg'
                    : '/assets/images/modal/illustration-failed.svg'
                "
                class="m-auto w-[12rem]"
                alt=""
              />
              <div v-if="postTestClass.is_done" class="py-3">
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Selamat!
                </p>
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Kamu telah menyelesaikan Post-Test
                </p>
              </div>
              <div v-else class="py-3">
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Yach!
                </p>
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Kamu belum lulus Post-Test, Tetap semangat ya!
                </p>
              </div>
              <div
                class="grid grid-cols-5 gap-1 bg-[#FFFFFF] p-3 rounded-md mb-3"
              >
                <div class="col-span-1 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Benar</span
                  >
                  <span
                    class="font-desain font-semibold text-[#2FBD71] text-lg"
                    >{{
                      roundingScore(
                        (postTestClass.items?.length * postTestClass.score) /
                          100
                      )
                    }}</span
                  >
                </div>
                <div class="col-span-1 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Salah</span
                  >
                  <span
                    class="font-desain font-semibold text-[#DE1306] text-lg"
                    >{{
                      postTestClass.items?.length -
                        roundingScore(
                          (postTestClass.items?.length * postTestClass.score) /
                            100
                        )
                    }}</span
                  >
                </div>
                <div class="col-span-1 flex flex-col items-center  space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Nilai</span
                  >
                  <span
                    class="font-desain font-semibold text-[#009DFF] text-lg"
                    >{{ postTestClass.score }}</span
                  >
                </div>
                <div class="col-span-2 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Status</span
                  >
                  <span
                    class="font-desain font-semibold text-lg"
                    :class="
                      postTestClass.is_done
                        ? 'text-[#2FBD71]'
                        : 'text-[#DE1306]'
                    "
                  >
                    {{ postTestClass.is_done ? 'Lulus' : 'Tidak Lulus' }}
                  </span>
                </div>
              </div>
              <div
                v-if="postTestClass.is_done == false"
                class="grid grid-cols-2 gap-3"
              >
                <button
                  @click="openLastMaterial()"
                  class="font-solusi text-[#009DFF] rounded-full bg-[#FFFFFF] font-semibold py-2"
                >
                  Materi Sebelumnya
                </button>
                <button
                  @click="openModalPostTest()"
                  class="font-solusi text-[#FFFFFF] rounded-full bg-[#00446F] font-semibold py-2"
                >
                  Ulangi Post-Test
                </button>
              </div>
            </div>
            <div
              v-else
              class="m-auto flex flex-col items-center justify-center"
            >
              <svg
                class="w-10 h-10"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#FFFFFF"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                />
              </svg>
              <span class="font-solusi text-[#FFFFFF] font-semibold mt-3">
                Post-Test
              </span>
              <span class="font-solusi text-sm text-[#FFFFFF] mb-5">
                {{ postTestClass.items?.length }} Soal
              </span>
              <button
                @click="openModalPostTest()"
                class="font-solusi bg-[#00446F] text-[#FFFFFF] py-2 px-12 rounded-full font-semibold"
              >
                Mulai Post Test
              </button>
            </div>
          </div>
          <div
            v-if="
              !showPostTest &&
                isDonePreTest &&
                selectedMaterialItem.type == 'video'
            "
            class="flex flex-col h-full md:mx-4 md:mt-3"
          >
            <div
              v-if="selectedMaterialItem?.data?.is_done == false && isPrakerja"
              class="text-left flex p-2 bg-gray-500 md:rounded-t-lg w-fit-content"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="info-circle"
                class="w-5 h-5 text-white"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                ></path>
              </svg>
              <span class="font-solusi text-sm text-white pl-2 self-center"
                >Tonton video sampai selesai untuk bisa mengaktifkan fitur
                forward/backward</span
              >
            </div>
            <div
              id="play"
              class="w-full h-auto"
              :class="
                assets?.length > 0
                  ? selectedMaterialItem?.data?.is_done == false && isPrakerja
                    ? 'md:h-[calc(100vh-16rem)]'
                    : 'md:h-[calc(100vh-13.5rem)]'
                  : selectedMaterialItem?.data?.is_done == false && isPrakerja
                  ? 'md:h-[calc(100vh-14.5rem)]'
                  : 'md:h-[calc(100vh-11rem)]'
              "
            >
              <vue-plyr
                id="vplyr"
                :clickToPlay="true"
                :options="options"
                :autoplay="isAutoPlay"
              >
                <video controls playsinline @ended="onEndVideo">
                  <source
                    key="origin"
                    :src="selectedMaterialItem.data.link"
                    type="video/mp4"
                  />
                  <source
                    v-for="video in resolutionVideos?.resolutions"
                    :key="video.resolution"
                    :src="video.link"
                    type="video/mp4"
                    :size="video.resolution"
                  />
                  dont support
                </video>
              </vue-plyr>
            </div>
            <div
              v-if="assets?.length > 0"
              class="flex my-2 flex-wrap mx-3 md:mx-0"
            >
              <a
                class="btn btn-sm btn-light btn-asset flex items-center shadow-sm mr-2 my-1 text-poppins"
                v-for="(asset, i) in assets"
                :key="i"
                :href="asset.file"
                target="_blank"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mr-1"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99456 0.500063C7.61553 0.505177 7.31191 0.816462 7.31895 1.19486V10.4541L4.39599 7.53117C4.25154 7.38032 4.04508 7.30426 3.8367 7.32472C3.57271 7.35092 3.34772 7.52798 3.2608 7.77853C3.17323 8.02908 3.23906 8.30778 3.42953 8.49251L7.52164 12.5846C7.78754 12.8492 8.21707 12.8492 8.48297 12.5846L12.5738 8.49251C12.7182 8.36914 12.8045 8.1908 12.8115 8.00097C12.8192 7.81113 12.747 7.62704 12.6121 7.49281C12.4779 7.35795 12.2938 7.28572 12.1039 7.29338C11.9141 7.30041 11.7358 7.3867 11.6124 7.53115L8.68422 10.4605V1.19484C8.69125 0.810685 8.37869 0.49558 7.99455 0.500047L7.99456 0.500063ZM1.17505 11.4117C0.993515 11.4136 0.820933 11.4871 0.69438 11.6162C0.567821 11.746 0.497515 11.9205 0.500067 12.1014V14.8301C0.498789 15.0116 0.571016 15.1861 0.699502 15.3146C0.827987 15.443 1.00248 15.5153 1.184 15.514H14.8191C15.0006 15.5153 15.1751 15.4431 15.3036 15.3146C15.4321 15.1861 15.5043 15.0116 15.503 14.8301V12.1014C15.4954 11.7306 15.1924 11.4347 14.8217 11.4347C14.4509 11.4347 14.148 11.7306 14.1396 12.1014V14.1505H1.8635V12.1014C1.86541 11.9179 1.79382 11.7415 1.66406 11.6117C1.53495 11.482 1.35853 11.4097 1.17508 11.4117L1.17505 11.4117Z"
                    fill="#212121"
                  />
                </svg>
                {{ asset?.name }}
              </a>
            </div>
            <!-- <p class="text-left m-0 pt-2 video-name">
              {{ selectedMaterialItem.data.name }}
            </p> -->
          </div>
          <div
            v-else-if="
              !showPostTest &&
                isDonePreTest &&
                selectedMaterialItem.type == 'module'
            "
            class="w-full h-[40vh] md:h-full pb-4 md:px-4"
          >
            <iframe
              :src="selectedMaterialItem?.data.link"
              width="100%"
              height="90%"
            >
            </iframe>
            <button
              @click="downloadLink(selectedMaterialItem?.data?.link)"
              class="font-solusi bg-[#00446F] text-[#FFFFFF] font-semibold px-5 py-2 text-sm rounded-full mt-2 mx-2 flex items-center"
            >
              <svg
                class="mr-1 h-4 w-4"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.9935 3.00008C11.5386 3.00621 11.1743 3.37975 11.1827 3.83383V14.9449L7.67519 11.4374C7.50184 11.2564 7.2541 11.1651 7.00404 11.1897C6.68725 11.2211 6.41726 11.4336 6.31296 11.7342C6.20787 12.0349 6.28688 12.3693 6.51544 12.591L11.426 17.5015C11.745 17.8191 12.2605 17.8191 12.5796 17.5015L17.4885 12.591C17.6619 12.443 17.7654 12.229 17.7738 12.0012C17.7831 11.7734 17.6964 11.5525 17.5345 11.3914C17.3735 11.2295 17.1525 11.1429 16.9247 11.1521C16.6969 11.1605 16.4829 11.264 16.3349 11.4374L12.8211 14.9526V3.83381C12.8295 3.37282 12.4544 2.9947 11.9935 3.00006L11.9935 3.00008ZM3.81006 16.094C3.59222 16.0963 3.38512 16.1845 3.23326 16.3395C3.08138 16.4952 2.99702 16.7046 3.00008 16.9216V20.1961C2.99855 20.4139 3.08522 20.6233 3.2394 20.7775C3.39358 20.9317 3.60298 21.0183 3.8208 21.0168H20.1829C20.4008 21.0183 20.6102 20.9317 20.7643 20.7775C20.9185 20.6233 21.0052 20.4139 21.0036 20.1961V16.9216C20.9944 16.4768 20.6309 16.1216 20.186 16.1216C19.7411 16.1216 19.3775 16.4768 19.3676 16.9216V19.3806H4.6362V16.9216C4.6385 16.7015 4.55259 16.4898 4.39687 16.3341C4.24194 16.1784 4.03023 16.0917 3.8101 16.094L3.81006 16.094Z"
                  fill="#FFFFFF"
                />
              </svg>
              Unduh Dokumen
            </button>
            <!-- <p class="text-left m-0 pt-2 video-name">
              {{ selectedMaterialItem.data.name }}
            </p> -->
          </div>
          <div
            v-else-if="
              !showPostTest &&
                isDonePreTest &&
                selectedMaterialItem.type == 'quiz'
            "
            class="w-full h-full flex justify-center items-center bg-gradient-to-b from-[#00446F] to-[#088BD5] min-h-[40vh]"
          >
            <div
              v-if="selectedMaterialItem.data.score > 0"
              class="m-auto w-full p-5 md:p-3"
            >
              <img
                :src="
                  selectedMaterialItem.data.is_done
                    ? '/assets/images/modal/illustration-success.svg'
                    : '/assets/images/modal/illustration-failed.svg'
                "
                class="m-auto w-[12rem]"
                alt=""
              />
              <div
                v-if="selectedMaterialItem.data.is_done"
                class="py-3 w-full md:w-[50%] m-auto"
              >
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Selamat!
                </p>
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Kamu telah menyelesaikan {{ selectedMaterialItem.data.name }}
                </p>
              </div>
              <div v-else class="py-3">
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Yach!
                </p>
                <p
                  class="text-white font-desain font-semibold text-lg text-center"
                >
                  Kamu belum lulus {{ selectedMaterialItem.data.name }}, Tetap
                  semangat ya!
                </p>
              </div>
              <div
                class="grid grid-cols-6 gap-1 bg-[#FFFFFF] p-3 rounded-md mb-3 w-full md:w-[38%] m-auto"
              >
                <div class="col-span-1 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Benar</span
                  >
                  <span
                    class="font-desain font-semibold text-[#2FBD71] text-lg"
                    >{{
                      roundingScore(
                        (selectedMaterialItem.data.display *
                          selectedMaterialItem.data.score) /
                          100
                      )
                    }}</span
                  >
                </div>
                <div class="col-span-1 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Salah</span
                  >
                  <span
                    class="font-desain font-semibold text-[#DE1306] text-lg"
                    >{{
                      selectedMaterialItem.data.display -
                        roundingScore(
                          (selectedMaterialItem.data.display *
                            selectedMaterialItem.data.score) /
                            100
                        )
                    }}</span
                  >
                </div>
                <div class="col-span-1 flex flex-col items-center  space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Nilai</span
                  >
                  <span
                    class="font-desain font-semibold text-[#009DFF] text-lg"
                    >{{ selectedMaterialItem.data.score }}</span
                  >
                </div>
                <div class="col-span-1 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Minimal</span
                  >
                  <span
                    class="font-desain font-semibold text-lg text-[#F3DB00]"
                  >
                    {{ selectedMaterialItem.data.min_score }}
                  </span>
                </div>
                <div class="col-span-2 flex flex-col items-center space-y-2">
                  <span class="font-solusi font-semibold text-[#212121]"
                    >Status</span
                  >
                  <span
                    class="font-desain font-semibold text-lg"
                    :class="
                      selectedMaterialItem.data.is_done
                        ? 'text-[#2FBD71]'
                        : 'text-[#DE1306]'
                    "
                  >
                    {{
                      selectedMaterialItem.data.is_done
                        ? 'Lulus'
                        : 'Tidak Lulus'
                    }}
                  </span>
                </div>
              </div>
              <div
                class="grid gap-3 w-full md:w-[38%] m-auto"
                :class="
                  selectedMaterialItem.data.is_done
                    ? 'grid-cols-1'
                    : 'grid-cols-2'
                "
              >
                <button
                  v-if="!selectedMaterialItem.data.is_done"
                  @click="openModalQuiz(selectedMaterialItem.data)"
                  class="font-solusi text-[#009DFF] rounded-full bg-[#FFFFFF] font-semibold py-2"
                >
                  Ulangi Tes
                </button>
                <button
                  @click="nextMateri()"
                  class="font-solusi text-[#FFFFFF] rounded-full bg-[#00446F] font-semibold py-2"
                >
                  Lanjut Belajar
                </button>
              </div>
            </div>

            <div
              v-else
              class="m-auto flex flex-col items-center justify-center"
            >
              <svg
                class="w-10 h-10"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#FFFFFF"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                />
              </svg>
              <span class="font-solusi text-[#FFFFFF] font-semibold mt-3">
                {{ selectedMaterialItem.data.name }}
              </span>
              <span class="font-solusi text-sm text-[#FFFFFF] mb-5">
                {{ selectedMaterialItem.data.display }} Soal
              </span>
              <button
                @click="openModalQuiz(selectedMaterialItem.data)"
                class="font-solusi bg-[#00446F] text-[#FFFFFF] py-2 px-12 rounded-full font-semibold"
              >
                Mulai Kuis
              </button>
            </div>
          </div>
          <div
            v-if="!showPostTest && isDonePreTest && selectedMaterialItem?.data"
            class="hidden md:flex flex-grow justify-end space-x-6 px-4 py-3"
          >
            <button
              v-if="selectedMaterialItem?.data?.material_ordering != 1"
              class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full py-1 px-5 flex items-center"
              @click="
                changeMateri(
                  selectedMaterialItem?.data?.material_ordering,
                  'back'
                )
              "
            >
              <svg
                class="w-4 h-4 mr-2"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.7326 10.2599C1.73594 10.269 1.73594 10.2782 1.7401 10.2874C1.7401 10.289 1.7401 10.2899 1.74094 10.2915C1.79094 10.4099 1.86427 10.5099 1.94927 10.5999C1.95844 10.6099 1.96177 10.6224 1.97094 10.6324L8.34427 16.9474C8.55177 17.1524 8.82344 17.2549 9.0951 17.2549C9.36677 17.2549 9.6376 17.1524 9.8451 16.9474C10.2601 16.5365 10.2601 15.8715 9.8451 15.4607L5.28344 10.9399L17.5876 10.9399C18.1743 10.9399 18.6484 10.4699 18.6484 9.88822C18.6484 9.30822 18.1743 8.83738 17.5876 8.83738L5.28427 8.83738L9.84594 4.29405C10.2609 3.88405 10.2609 3.21822 9.84594 2.80822C9.43177 2.39738 8.75927 2.39738 8.34427 2.80822L1.97094 9.14488C1.87927 9.23572 1.81344 9.34322 1.76177 9.45655C1.7451 9.49155 1.73594 9.52572 1.72427 9.56072C1.69594 9.64572 1.67844 9.73072 1.67261 9.82072C1.6701 9.85738 1.66511 9.89155 1.66677 9.92822C1.67094 10.0415 1.69094 10.1515 1.7326 10.2599Z"
                  fill="#009DFF"
                />
              </svg>
              Sebelumnya
            </button>
            <button
              v-if="
                selectedMaterialItem?.data?.material_ordering != countMateri
              "
              class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full py-1 px-5 flex items-center"
              @click="
                changeMateri(
                  selectedMaterialItem?.data?.material_ordering,
                  'next'
                )
              "
            >
              Selanjutnya
              <svg
                class="w-4 h-4 ml-2"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.5838 9.495C18.5805 9.48583 18.5805 9.47667 18.5763 9.4675C18.5763 9.46583 18.5763 9.465 18.5755 9.46333C18.5255 9.345 18.4521 9.245 18.3671 9.155C18.358 9.145 18.3546 9.1325 18.3455 9.1225L11.9721 2.8075C11.7646 2.6025 11.493 2.5 11.2213 2.5C10.9496 2.5 10.6788 2.6025 10.4713 2.8075C10.0563 3.21833 10.0563 3.88333 10.4713 4.29417L15.033 8.815H2.7288C2.14214 8.815 1.66797 9.285 1.66797 9.86667C1.66797 10.4467 2.14214 10.9175 2.7288 10.9175H15.0321L10.4705 15.4608C10.0555 15.8708 10.0555 16.5367 10.4705 16.9467C10.8846 17.3575 11.5571 17.3575 11.9721 16.9467L18.3455 10.61C18.4371 10.5192 18.503 10.4117 18.5546 10.2983C18.5713 10.2633 18.5805 10.2292 18.5921 10.1942C18.6205 10.1092 18.638 10.0242 18.6438 9.93417C18.6463 9.8975 18.6513 9.86333 18.6496 9.82667C18.6455 9.71333 18.6255 9.60333 18.5838 9.495Z"
                  fill="#009DFF"
                />
              </svg>
            </button>
            <button
              v-if="
                selectedMaterialItem?.data?.material_ordering == countMateri &&
                  isExistPostTest
              "
              class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full py-2 px-4 flex items-center"
              @click="openPostTestPage()"
            >
              Kerjakan Post-Test
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="tab == 'webinar'"
        class="w-full md:w-[75%] order-1 md:order-2 bg-[#F9FCFF] flex overflow-y-auto scroll-custom"
        :class="showWebinarRecord ? 'h-[300px] md:h-full' : ''"
      >
        <div
          v-if="showWebinarQuiz"
          class="flex flex-col w-full h-full relative min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-7rem)]"
        >
          <div v-dragscroll id="scroll-quiz" class="header-quiz">
            <div
              :id="'q' + i"
              :ref="'q' + i"
              v-for="(item, i) in webinarQuizData.items?.length"
              :key="i"
              class="question-number"
              :class="
                isDoneWebinarQuiz
                  ? webinarQuizData?.items[item - 1]?.result
                    ? questionIndex == i
                      ? 'bg-[#2FA742] text-[#FFFFFF]'
                      : 'bg-[#FFFFFF] text-[#2FA742]'
                    : questionIndex == i
                    ? 'bg-[#DE1306] text-[#FFFFFF]'
                    : 'bg-[#FFFFFF] text-[#DE1306]'
                  : questionIndex == i
                  ? 'question-selected'
                  : payloadWebinarQuiz?.answers[i] != null
                  ? 'blue-sd-1'
                  : ''
              "
              @click="changeQuestion(i)"
            >
              {{ i + 1 }}
            </div>
          </div>
          <div class="body-quiz">
            <div class="question-body">
              <div
                class="font-solusi font-semibold text-[#212121] text-lg mb-3 flex items-center"
              >
                {{ webinarQuizData?.items[questionIndex].question }}
                <div v-if="isDoneWebinarQuiz" class="ml-2">
                  <svg
                    v-if="webinarQuizData?.items[questionIndex]?.result"
                    svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="check-circle"
                    class="svg-inline--fa fa-check-circle fa-w-16"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style="width:1.5rem;"
                  >
                    <path
                      fill="#65C344"
                      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                    ></path>
                  </svg>
                  <svg
                    v-else
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="times-circle"
                    class="svg-inline--fa fa-times-circle fa-w-16"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style="width:1.5rem;"
                  >
                    <path
                      fill="#AE0003"
                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div
                v-show="
                  webinarQuizData?.items[questionIndex]?.choices?.length > 0
                "
                v-for="(choice, j) in webinarQuizData?.items[questionIndex]
                  .choices"
                :key="j"
                class="answer text-left mb-4"
              >
                <label class="form-check-label cursor-pointer flex">
                  <input
                    class="form-check-input hidden cursor-pointer"
                    type="radio"
                    :value="j"
                    :disabled="isDoneWebinarQuiz"
                    v-model="payloadWebinarQuiz.answers[questionIndex]"
                  />
                  <div class="flex">
                    <span
                      class="btn-choice mr-2 font-solusi"
                      :class="
                        j == payloadWebinarQuiz.answers[questionIndex]
                          ? 'choice-selected'
                          : ''
                      "
                    >
                      {{
                        j == 0
                          ? 'A'
                          : j == 1
                          ? 'B'
                          : j == 2
                          ? 'C'
                          : j == 3
                          ? 'D'
                          : j == 4
                          ? 'E'
                          : j == 5
                          ? 'F'
                          : j == 6
                          ? 'G'
                          : j == 7
                          ? 'H'
                          : j == 8
                          ? 'I'
                          : 'J'
                      }}
                    </span>
                    <span class="m-0 self-center font-solusi text-[#212121]">{{
                      choice
                    }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div
              class="flex px-4 py-3 justify-end"
              :class="isDoneWebinarQuiz ? 'md:justify-between' : ''"
            >
              <button
                v-if="isDoneWebinarQuiz"
                class="hidden md:flex font-solusi font-semibold text-[#FFFFFF] bg-[#00446F] border border-[#00446F] rounded-full items-center py-1 px-3"
                @click="changePage('webinar-quiz')"
              >
                <svg
                  class="w-4 h-4 mr-2"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.7326 10.2599C1.73594 10.269 1.73594 10.2782 1.7401 10.2874C1.7401 10.289 1.7401 10.2899 1.74094 10.2915C1.79094 10.4099 1.86427 10.5099 1.94927 10.5999C1.95844 10.6099 1.96177 10.6224 1.97094 10.6324L8.34427 16.9474C8.55177 17.1524 8.82344 17.2549 9.0951 17.2549C9.36677 17.2549 9.6376 17.1524 9.8451 16.9474C10.2601 16.5365 10.2601 15.8715 9.8451 15.4607L5.28344 10.9399L17.5876 10.9399C18.1743 10.9399 18.6484 10.4699 18.6484 9.88822C18.6484 9.30822 18.1743 8.83738 17.5876 8.83738L5.28427 8.83738L9.84594 4.29405C10.2609 3.88405 10.2609 3.21822 9.84594 2.80822C9.43177 2.39738 8.75927 2.39738 8.34427 2.80822L1.97094 9.14488C1.87927 9.23572 1.81344 9.34322 1.76177 9.45655C1.7451 9.49155 1.73594 9.52572 1.72427 9.56072C1.69594 9.64572 1.67844 9.73072 1.67261 9.82072C1.6701 9.85738 1.66511 9.89155 1.66677 9.92822C1.67094 10.0415 1.69094 10.1515 1.7326 10.2599Z"
                    fill="#FFFFFF"
                  />
                </svg>
                Kembali ke webinar
              </button>
              <div class="flex justify-end space-x-6">
                <button
                  v-if="questionIndex != 0"
                  class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                  @click="prevQuestion()"
                >
                  <svg
                    class="w-4 h-4 mr-2"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.7326 10.2599C1.73594 10.269 1.73594 10.2782 1.7401 10.2874C1.7401 10.289 1.7401 10.2899 1.74094 10.2915C1.79094 10.4099 1.86427 10.5099 1.94927 10.5999C1.95844 10.6099 1.96177 10.6224 1.97094 10.6324L8.34427 16.9474C8.55177 17.1524 8.82344 17.2549 9.0951 17.2549C9.36677 17.2549 9.6376 17.1524 9.8451 16.9474C10.2601 16.5365 10.2601 15.8715 9.8451 15.4607L5.28344 10.9399L17.5876 10.9399C18.1743 10.9399 18.6484 10.4699 18.6484 9.88822C18.6484 9.30822 18.1743 8.83738 17.5876 8.83738L5.28427 8.83738L9.84594 4.29405C10.2609 3.88405 10.2609 3.21822 9.84594 2.80822C9.43177 2.39738 8.75927 2.39738 8.34427 2.80822L1.97094 9.14488C1.87927 9.23572 1.81344 9.34322 1.76177 9.45655C1.7451 9.49155 1.73594 9.52572 1.72427 9.56072C1.69594 9.64572 1.67844 9.73072 1.67261 9.82072C1.6701 9.85738 1.66511 9.89155 1.66677 9.92822C1.67094 10.0415 1.69094 10.1515 1.7326 10.2599Z"
                      fill="#009DFF"
                    />
                  </svg>
                  Sebelumnya
                </button>
                <button
                  v-if="webinarQuizData?.items?.length != questionIndex + 1"
                  class="font-solusi font-semibold text-[#009DFF] border border-[#009DFF] rounded-full flex items-center py-1 px-5"
                  @click="nextQuestion()"
                >
                  Selanjutnya
                  <svg
                    class="w-4 h-4 ml-2"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.5838 9.495C18.5805 9.48583 18.5805 9.47667 18.5763 9.4675C18.5763 9.46583 18.5763 9.465 18.5755 9.46333C18.5255 9.345 18.4521 9.245 18.3671 9.155C18.358 9.145 18.3546 9.1325 18.3455 9.1225L11.9721 2.8075C11.7646 2.6025 11.493 2.5 11.2213 2.5C10.9496 2.5 10.6788 2.6025 10.4713 2.8075C10.0563 3.21833 10.0563 3.88333 10.4713 4.29417L15.033 8.815H2.7288C2.14214 8.815 1.66797 9.285 1.66797 9.86667C1.66797 10.4467 2.14214 10.9175 2.7288 10.9175H15.0321L10.4705 15.4608C10.0555 15.8708 10.0555 16.5367 10.4705 16.9467C10.8846 17.3575 11.5571 17.3575 11.9721 16.9467L18.3455 10.61C18.4371 10.5192 18.503 10.4117 18.5546 10.2983C18.5713 10.2633 18.5805 10.2292 18.5921 10.1942C18.6205 10.1092 18.638 10.0242 18.6438 9.93417C18.6463 9.8975 18.6513 9.86333 18.6496 9.82667C18.6455 9.71333 18.6255 9.60333 18.5838 9.495Z"
                      fill="#009DFF"
                    />
                  </svg>
                </button>
                <button
                  v-if="
                    webinarQuizData?.items?.length == questionIndex + 1 &&
                      !isDoneWebinarQuiz
                  "
                  class="font-solusi font-semibold text-[#FFFFFF] bg-[#00446F] border border-[#00446F] rounded-full flex items-center py-1 px-5"
                  @click="showConfirmWebinarQuiz()"
                >
                  Akhiri {{ webinarQuizData?.name }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showWebinar" class="w-full">
          <div
            v-if="listWebinar?.length > 0"
            class="hidden md:flex flex-col w-full h-full relative p-6"
          >
            <div v-for="webinar in listWebinar" :key="'e-' + webinar.id">
              <CardWebinar
                :onClickWebinar="onClickWebinar"
                :onClickPreTest="onClickPreTest"
                :onClickPostTest="onClickPostTest"
                :preTest="preTest"
                :postTest="postTest"
                :webinar="webinar"
                :onClickRequestWebinarPlus="onClickRequestWebinarPlus"
              />
            </div>
          </div>
          <div
            v-else
            class="hidden md:flex flex-col w-full h-full relative p-6 justify-center items-center"
          >
            <img
              src="/assets/images/modal/ilustration-webinar.svg"
              alt=""
              class="w-1/3"
            />
            <p
              class="text-center mt-3 font-solusi font-semibold text-[#333333]"
            >
              Belum ada webinar yang
              {{
                filterWebinar == 'waiting'
                  ? 'akan berlangsung'
                  : filterWebinar == 'ongoing'
                  ? 'sedang berlangsung'
                  : 'selesai'
              }}
            </p>
          </div>
        </div>
        <div v-else-if="showWebinarRecord" class="w-full flex">
          <div
            v-if="selectedWebinarRecord.type == 'Youtube'"
            class="flex flex-col md:py-4 md:px-6 w-full"
          >
            <p
              class="hidden md:block font-desain text-[#212121] font-semibold text-lg mb-3"
            >
              {{ selectedWebinarRecord.name }}
            </p>
            <!-- <div v-html="selectedWebinarRecord.link"></div> -->
            <iframe
              class="w-full h-[50vh] md:h-[calc(100vh-11rem)]"
              :src="selectedWebinarRecord?.url"
              :title="selectedWebinarRecord?.name"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div
            v-else
            class="w-full h-full flex flex-col justify-center items-center bg-gradient-to-b from-[#00446F] to-[#088BD5] min-h-[25vh]"
          >
            <div
              class="w-20 h-20 mb-3 rounded-md bg-[#2D8CFF] flex items-center justify-center"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="video"
                class="w-12 h-12"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  fill="#FFFFFF"
                  d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                ></path>
              </svg>
            </div>
            <p class="font-solusi text-[#FFFFFF] font-semibold text-2xl mb-2">
              {{ selectedWebinarRecord.name }}
            </p>
            <div
              v-if="selectedWebinarRecord?.password"
              class="flex items-center bg-[#FFFFFF] rounded-md mb-2 px-3 py-1"
            >
              <span class="font-solusi text-sm font-semibold text-[#0A72ED] "
                >password: {{ selectedWebinarRecord?.password }}</span
              >
              <input
                type="hidden"
                ref="password"
                :value="selectedWebinarRecord?.password"
              />
              <button
                @click="copyPasswordWebinar()"
                v-tooltip="{
                  content: 'Salin',
                }"
                class="ml-1 font-solusi text-[#0A72ED] text-base font-semibold outline-none focus:outline-none flex items-center"
              >
                <svg
                  class="ml-1 w-4 h-4"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 4H3C2.44813 4 2 4.44813 2 5V14C2 14.5519 2.44813 15 3 15H11C11.5519 15 12 14.5519 12 14V13H4V4Z"
                    fill="#0A72ED"
                  />
                  <path d="M11 1V5H15L11 1Z" fill="#0A72ED" />
                  <path
                    d="M10 6V1H6C5.44813 1 5 1.44813 5 2V12H14C14.5519 12 15 11.5519 15 11V6H10Z"
                    fill="#0A72ED"
                  />
                </svg>
              </button>
            </div>
            <a
              class="font-solusi text-[#FFFFFF] rounded-full bg-[#00446F] font-semibold py-2 px-8 mt-6"
              :href="selectedWebinarRecord.link"
              target="_blank"
            >
              Buka Link
            </a>
          </div>
        </div>
      </div>

      <div
        v-if="tab == 'task'"
        class="w-full md:w-[75%] order-1 md:order-2 hidden md:flex flex-col bg-[#F9FCFF] overflow-y-auto scroll-custom"
      >
        <div
          v-if="selectedTask.id > 0"
          class="flex flex-col divide-y-8 divide-[#EEEEEE]"
        >
          <div class="py-6 px-12">
            <div class="w-full flex flex-row justify-between">
              <p class="font-desain text-[#212121] font-semibold text-lg">
                {{ selectedTask.name }}
              </p>
              <span
                class="flex justify-end items-center px-2 py-1 font-solusi text-[#FFFFFF] font-semibold text-sm self-end rounded-full"
                :class="
                  selectedTask?.started_at >= dateNow
                    ? 'bg-[#0A72ED]'
                    : selectedTask?.score > 0
                    ? 'bg-[#2FBD71]'
                    : selectedTask?.file
                    ? 'bg-[#757575]'
                    : selectedTask?.expired_at >= dateNow
                    ? 'bg-[#FB8500]'
                    : 'bg-[#DE1306]'
                "
              >
                <svg
                  v-if="selectedTask?.score > 0"
                  class="mr-1 w-4 h-4"
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="6.58301" cy="6" r="6" fill="white" />
                  <path
                    d="M5.21984 8.95562C5.35719 9.09652 5.5483 9.17636 5.74803 9.17636C5.74997 9.17636 5.752 9.17636 5.75414 9.17636C5.95619 9.17466 6.14837 9.09163 6.28466 8.94689L10.2751 4.70869C10.5457 4.42136 10.5246 3.97576 10.2284 3.71341C9.93214 3.45126 9.47262 3.47145 9.20208 3.75869L5.73902 7.43659L4.66103 6.32963C4.38536 6.04672 3.92545 6.03413 3.6339 6.30117C3.34214 6.56831 3.32916 7.0141 3.60455 7.29701L5.21984 8.95562Z"
                    fill="#2FBD71"
                  />
                </svg>
                {{
                  selectedTask?.started_at >= dateNow
                    ? 'Belum Mulai'
                    : selectedTask?.score > 0
                    ? 'Sudah Dinilai'
                    : selectedTask?.file
                    ? 'Menunggu Review Mentor'
                    : selectedTask?.expired_at >= dateNow
                    ? 'Belum Unggah'
                    : 'Terlambat'
                }}
              </span>
            </div>
            <div
              v-html="selectedTask.description"
              class="font-solusi text-[#333333] mb-3"
            ></div>
            <div class="flex flex-row w-full items-center justify-between">
              <p
                v-if="timeZone(selectedTask.started_at) <= dateNow"
                class="font-solusi text-[#DE1306] font-semibold"
              >
                Deadline: {{ dateFormat(selectedTask.expired_at) }}
              </p>
              <p v-else class="font-solusi text-[#2FBD71] font-semibold">
                Dimulai: {{ dateFormat(selectedTask.started_at) }}
              </p>
              <button
                v-if="selectedTask?.score > 0"
                @click="openModalTaskScore"
                class="font-solusi text-[#2097F6] text-sm font-semibold flex items-center px-3 py-1 border border-[#2097F6] rounded-full"
              >
                <svg
                  class="mr-1 w-4 h-4"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.92183 3.91797H4.08203V9.03897H7.92183V3.91797ZM7.28121 8.39837H4.72261V4.55857H7.28121V8.39837Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M9.19922 3.91797H13.6796V4.55859H9.19922V3.91797Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M9.19922 6.16016H13.6796V6.80078H9.19922V6.16016Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M9.19922 8.39844H13.6796V9.03906H9.19922V8.39844Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M4.07812 10.6406H13.6797V11.2812H4.07812V10.6406Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M4.07812 12.8789H11.4413V13.5195H4.07812V12.8789Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M4.07812 16.7227H8.55852V17.3633H4.07812V16.7227Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M19.293 8.86713C18.7579 8.33589 17.7227 8.17181 17.0312 8.86713L15.6016 10.2968V2.00001H13.6797V0.078125H0.238281V17.9999H2.16016V19.9218H15.6016V14.8242L19.293 11.1328C19.918 10.5078 19.918 9.49219 19.293 8.86721L19.293 8.86713ZM2.16024 17.3631H0.879001V0.718525H13.043V1.99977H2.1602L2.16024 17.3631ZM14.961 19.2811H2.80084V2.63649H14.961V10.9373L9.71884 16.1795L9.15244 19.0077L11.9806 18.4413L14.9572 15.4609V19.2813L14.961 19.2811ZM10.4688 16.3357L11.3751 15.4294L12.7345 16.7888L11.8243 17.6951L10.4688 16.3357ZM11.1759 17.949L9.96884 18.1911L10.211 16.9841L11.1759 17.949ZM13.1837 16.3357L11.8243 14.9763L17.2539 9.54271L18.6133 10.9021L13.1837 16.3357ZM19.0275 10.4099L17.754 9.14035C18.1095 8.98019 18.5587 9.03878 18.84 9.32394C19.1369 9.6169 19.1954 10.0544 19.0275 10.4099V10.4099Z"
                    fill="#2097F7"
                  />
                  <path
                    d="M15.4453 13.1677L14.9922 12.7145L17.2546 10.4521L17.7077 10.9053L15.4453 13.1677Z"
                    fill="#2097F7"
                  />
                </svg>
                Lihat Nilai
              </button>
            </div>
          </div>
          <div
            v-if="
              (timeZone(selectedTask?.expired_at) >= dateNow &&
                timeZone(selectedTask?.started_at) <= dateNow) ||
                selectedTask.file != ''
            "
            class="py-6 px-12"
          >
            <p class="font-desain text-[#212121] font-semibold text-lg mb-2">
              Pengumpulan Tugas
            </p>
            <div v-if="selectedTask.file == ''">
              <div class="mb-3 flex flex-col w-full justify-center">
                <label class="block text-left">
                  <span class="font-solusi text-sm text-[#212121] mb-1"
                    >Tipe File</span
                  >
                  <select
                    v-model="typeFile"
                    class="block w-full mt-1 bg-[#FFFFFF] text-[#212121] px-2 py-1 border border-gray-300 rounded-md font-solusi text-sm"
                    @change="onChangeSelectTaskType"
                  >
                    <option class="font-solusi text-sm" value="berkas"
                      >Berkas</option
                    >
                    <option class="font-solusi text-sm" value="link"
                      >Link</option
                    >
                  </select>
                </label>
              </div>
              <div
                v-if="typeFile == 'link'"
                class="mb-3 flex flex-col w-full justify-center"
              >
                <label class="font-solusi text-sm text-[#212121] mb-1">
                  Link
                  <span
                    v-if="formTask.file && formTask.file != ''"
                    class="font-solusi text-sm text-[#212121] mb-1"
                    >(diawali dengan https://)</span
                  >
                </label>
                <input
                  type="text"
                  class="font-solusi text-sm text-[#212121] p-2 rounded-md border"
                  :class="
                    errorTaskLinkName ? 'border-[#DE1306]' : 'border-gray-300'
                  "
                  v-model="formTask.file"
                  @change="checkFormTaskFileLink"
                  placeholder="Masukkan Link URL (diawali https://)"
                />
                <span
                  v-if="errorTaskLinkName"
                  class="text-sm font-solusi text-[#DE1306]"
                  >Isi link sesuai format</span
                >
              </div>
              <div
                v-if="typeFile == 'berkas'"
                class="mb-3 flex flex-col w-full justify-center"
              >
                <label
                  for="questionFile"
                  class="font-solusi text-sm text-[#212121] mb-1"
                  >Berkas</label
                >
                <label
                  for="assetsFieldHandle"
                  class="py-3 text-center bg-[#FFFFFF] border-2 border-dashed border-gray-300 rounded-md flex flex-col items-center cursor-pointer z-10"
                  @dragover="dragoverTask"
                  @dragleave="dragleaveTask"
                  @drop="dropTask"
                >
                  <svg
                    class="w-12 h-12 mb-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.9935 3.00008C11.5386 3.00621 11.1743 3.37975 11.1827 3.83383V14.9449L7.67519 11.4374C7.50184 11.2564 7.2541 11.1651 7.00404 11.1897C6.68725 11.2211 6.41726 11.4336 6.31296 11.7342C6.20787 12.0349 6.28688 12.3693 6.51544 12.591L11.426 17.5015C11.745 17.8191 12.2605 17.8191 12.5796 17.5015L17.4885 12.591C17.6619 12.443 17.7654 12.229 17.7738 12.0012C17.7831 11.7734 17.6964 11.5525 17.5345 11.3914C17.3735 11.2295 17.1525 11.1429 16.9247 11.1521C16.6969 11.1605 16.4829 11.264 16.3349 11.4374L12.8211 14.9526V3.83381C12.8295 3.37282 12.4544 2.9947 11.9935 3.00006L11.9935 3.00008ZM3.81006 16.094C3.59222 16.0963 3.38512 16.1845 3.23326 16.3395C3.08138 16.4952 2.99702 16.7046 3.00008 16.9216V20.1961C2.99855 20.4139 3.08522 20.6233 3.2394 20.7775C3.39358 20.9317 3.60298 21.0183 3.8208 21.0168H20.1829C20.4008 21.0183 20.6102 20.9317 20.7643 20.7775C20.9185 20.6233 21.0052 20.4139 21.0036 20.1961V16.9216C20.9944 16.4768 20.6309 16.1216 20.186 16.1216C19.7411 16.1216 19.3775 16.4768 19.3676 16.9216V19.3806H4.6362V16.9216C4.6385 16.7015 4.55259 16.4898 4.39687 16.3341C4.24194 16.1784 4.03023 16.0917 3.8101 16.094L3.81006 16.094Z"
                      fill="#00446F"
                    />
                  </svg>
                  <input
                    type="file"
                    name="fields[assetsFieldHandle][]"
                    id="assetsFieldHandle"
                    class="w-px h-px opacity-0 overflow-hidden absolute"
                    @change="onTaskFile"
                    ref="taskFile"
                  />
                  <label
                    for="deleteFile"
                    v-if="formTask.file"
                    class="block font-solusi text-sm text-[#00446F] font-semibold"
                  >
                    {{ formTask?.file?.name }}
                    <button
                      for="deleteFile"
                      class="font-solusi text-sm ml-2 text-[#DE1306]"
                      @click="removeTaskFile()"
                      title="Remove file"
                    >
                      hapus
                    </button>
                  </label>
                  <label
                    v-else
                    for="assetsFieldHandle"
                    class="block cursor-pointer"
                  >
                    <div class="font-solusi text-sm text-[#00446F]">
                      <span
                        class="font-solusi text-sm font-semibold text-[#00446F] hover:text-[#009DFF]"
                        >Pilih Berkas</span
                      >
                      atau drag disini
                    </div>
                  </label>
                </label>
              </div>
            </div>
            <div v-else class="mb-3 flex flex-col w-full">
              <label class="font-solusi text-sm text-[#212121] mb-1"
                >File Tugas</label
              >
              <a
                v-if="checkIsAssetFile(selectedTask.file)"
                :href="'https://' + selectedTask.file"
                target="_blank"
                class="font-solusi text-sm text-[#009DFF] hover:text-[#FFFFFF] flex items-center px-2 py-1 hover:bg-[#009DFF] border border-[#009DFF] rounded-md w-fit-content"
              >
                <svg
                  class="mr-1 w-5 h-5"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3298 5.19213C13.3341 5.1549 13.3341 5.11713 13.3298 5.0799C13.3314 5.06695 13.3314 5.054 13.3298 5.04105C13.3093 4.9941 13.2817 4.9504 13.2478 4.91155L9.7944 1.45819C9.75555 1.4242 9.71184 1.39668 9.6649 1.37617H9.62605L9.47496 1.33301H5.12802C4.41306 1.33301 3.83301 1.91306 3.83301 2.62802V12.9881C3.83301 13.703 4.41306 14.2831 5.12802 14.2831H12.0347C12.7497 14.2831 13.3297 13.703 13.3297 12.9881V5.21803V5.19213H13.3298ZM11.8578 4.78636H10.3081C10.0696 4.78636 9.87642 4.59319 9.87642 4.35469V2.80497L11.8578 4.78636ZM12.0348 13.4197H5.12808C4.88958 13.4197 4.69642 13.2266 4.69642 12.9881V2.62802C4.69642 2.38951 4.88958 2.19635 5.12808 2.19635H9.01311V4.35469C9.01311 5.06965 9.59316 5.6497 10.3081 5.6497H12.4665V12.9881C12.4665 13.1025 12.4211 13.2125 12.3402 13.2935C12.2593 13.3744 12.1492 13.4197 12.0348 13.4197L12.0348 13.4197Z"
                    fill="currentColor"
                  />
                </svg>
                File
              </a>
              <a
                v-else
                :href="'https://' + selectedTask.file"
                target="_blank"
                class="font-solusi text-sm text-[#009DFF] hover:text-[#FFFFFF] flex items-center px-2 py-1 hover:bg-[#009DFF] border border-[#009DFF] rounded-md w-full"
              >
                {{ 'https://' + selectedTask.file }}
              </a>
            </div>
            <div class="mb-5 flex flex-col w-full">
              <label
                for="question"
                class="font-solusi text-sm text-[#212121] mb-1"
                >Keterangan (Opsional)</label
              >
              <textarea
                name="question"
                id="question"
                cols="30"
                rows="3"
                v-model="formTask.note"
                class="rounded-md font-solusi text-[#212121] text-sm p-2 border border-gray-300"
                placeholder="Tulis deskripsi..."
                :disabled="selectedTask.file != ''"
              ></textarea>
            </div>

            <div
              v-if="showUploadProgress"
              class="relative mb-3 flex flex-col justify-center items-center"
            >
              <div class="flex mb-0.5 items-center justify-between w-60">
                <div>
                  <span
                    class="font-solusi text-2xs font-semibold inline-block rounded-full text-[#212121]"
                  >
                    Upload Progress...
                  </span>
                </div>
                <div class="text-right">
                  <span
                    class="font-solusi  text-2xs text-[#212121] font-semibold inline-block"
                  >
                    {{ uploadPercentage }}%
                  </span>
                </div>
              </div>
              <div
                class="overflow-hidden h-2 mb-1 text-xs flex rounded bg-[#EEEEEE] w-60"
              >
                <div
                  class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#009DFF]"
                  :style="'width:' + uploadPercentage + '%'"
                ></div>
              </div>
            </div>

            <button
              v-if="selectedTask?.file == ''"
              @click="submitUploadTask"
              class="mx-auto px-12 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center"
              :class="
                checkFormTask && !showUploadProgress
                  ? 'bg-[#00446F] text-[#FFFFFF]'
                  : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
              "
              :disabled="!checkFormTask || showUploadProgress"
            >
              <svg
                v-if="showUploadProgress"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="spinner"
                class="w-5 h-5 animate-spin mr-3"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                ></path>
              </svg>
              Kirim Tugas
            </button>
          </div>
        </div>
        <div v-else class="flex flex-col justify-center items-center h-full">
          <img
            src="/assets/images/mentor/empty-state.svg"
            class="w-3/4 md:w-1/3"
            alt=""
          />
          <p class="font-solusi text-[#383838] font-semibold mt-3 text-center">
            Silahkan pilih salah satu tugas.
          </p>
        </div>
      </div>
      <div
        v-if="tab == 'ask-mentor'"
        class="w-full md:w-[75%] order-1 md:order-2 hidden md:flex flex-col bg-gradient-to-b from-[#00446F] to-[#088BD5] py-6 px-12"
      >
        <p class="font-desain text-[#FFFFFF] font-semibold text-lg mb-6">
          Apa yang ingin kamu tanyakan?
        </p>
        <div class="mb-3 flex flex-col w-full">
          <label for="question" class="font-solusi text-sm text-[#FFFFFF]  mb-2"
            >Pertanyaan</label
          >
          <textarea
            name="question"
            id="question"
            cols="30"
            rows="5"
            v-model="formQuestion.question"
            class="rounded-md font-solusi text-[#212121] text-sm p-2"
            placeholder="Tulis pertanyaan..."
          ></textarea>
        </div>
        <div class="mb-3 flex flex-col w-full justify-center">
          <label
            for="questionFile"
            class="font-solusi text-sm text-[#FFFFFF] mb-2"
            >File (Opsional)</label
          >
          <label
            for="assetsFieldHandle"
            class="py-3 text-center bg-[#FFFFFF] border-2 border-dashed border-gray-300 hover:bg-[#F9FCFF] rounded-md flex flex-col items-center cursor-pointer"
            @dragover="dragoverQuestion"
            @dragleave="dragleaveQuestion"
            @drop="dropQuestion"
          >
            <svg
              class="w-12 h-12 mb-2"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9935 3.00008C11.5386 3.00621 11.1743 3.37975 11.1827 3.83383V14.9449L7.67519 11.4374C7.50184 11.2564 7.2541 11.1651 7.00404 11.1897C6.68725 11.2211 6.41726 11.4336 6.31296 11.7342C6.20787 12.0349 6.28688 12.3693 6.51544 12.591L11.426 17.5015C11.745 17.8191 12.2605 17.8191 12.5796 17.5015L17.4885 12.591C17.6619 12.443 17.7654 12.229 17.7738 12.0012C17.7831 11.7734 17.6964 11.5525 17.5345 11.3914C17.3735 11.2295 17.1525 11.1429 16.9247 11.1521C16.6969 11.1605 16.4829 11.264 16.3349 11.4374L12.8211 14.9526V3.83381C12.8295 3.37282 12.4544 2.9947 11.9935 3.00006L11.9935 3.00008ZM3.81006 16.094C3.59222 16.0963 3.38512 16.1845 3.23326 16.3395C3.08138 16.4952 2.99702 16.7046 3.00008 16.9216V20.1961C2.99855 20.4139 3.08522 20.6233 3.2394 20.7775C3.39358 20.9317 3.60298 21.0183 3.8208 21.0168H20.1829C20.4008 21.0183 20.6102 20.9317 20.7643 20.7775C20.9185 20.6233 21.0052 20.4139 21.0036 20.1961V16.9216C20.9944 16.4768 20.6309 16.1216 20.186 16.1216C19.7411 16.1216 19.3775 16.4768 19.3676 16.9216V19.3806H4.6362V16.9216C4.6385 16.7015 4.55259 16.4898 4.39687 16.3341C4.24194 16.1784 4.03023 16.0917 3.8101 16.094L3.81006 16.094Z"
                fill="#00446F"
              />
            </svg>
            <input
              type="file"
              name="fields[assetsFieldHandle][]"
              id="assetsFieldHandle"
              class="w-px h-px opacity-0 overflow-hidden absolute"
              @change="onQuestionFile"
              ref="questionFile"
            />
            <label
              for="deleteTask"
              v-if="formQuestion.file"
              class="block font-solusi text-sm text-[#00446F] font-semibold"
            >
              {{ formQuestion?.file?.name }}
              <button
                for="deleteTask"
                class="font-solusi text-sm ml-2 text-[#DE1306]"
                @click="removeQuestionFile()"
                title="Remove file"
              >
                hapus
              </button>
            </label>
            <label v-else for="assetsFieldHandle" class="block cursor-pointer">
              <div class="font-solusi text-sm text-[#00446F]">
                <span
                  class="font-solusi text-sm font-semibold text-[#00446F] hover:text-[#009DFF]"
                  >Pilih file</span
                >
                atau drag disini
              </div>
            </label>
          </label>
        </div>
        <p class="mb-6 font-solusi text-[#FFFFFF] text-sm">
          *Pertanyaan yang kamu ajukan hanya bisa dilihat antara kamu dengan
          mentor.
        </p>
        <button
          @click="submitQuestion"
          class="mx-auto px-12 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center"
          :class="
            checkFormQuestion && !loadingSubmitQuestion
              ? 'bg-[#00446F] text-[#FFFFFF]'
              : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
          "
          :disabled="!checkFormQuestion || loadingSubmitQuestion"
        >
          <svg
            v-if="loadingSubmitQuestion"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="spinner"
            class="w-5 h-5 animate-spin mr-3"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
            ></path>
          </svg>
          Ajukan
        </button>
      </div>

      <div
        v-if="tab == 'forum'"
        class="w-full h-full md:w-[75%] order-1 md:order-2 hidden md:flex flex-col bg-gradient-to-b from-[#00446F] to-[#088BD5] py-6 px-12 justify-center items-center"
      >
        <p class="font-solusi font-semibold text-lg text-[#FFFFFF] text-center">
          Ayo Gabung Grup!
        </p>
        <p
          class="font-solusi text-[#FFFFFF] text-lg font-semibold mb-2 text-center"
        >
          Mari berintraksi dengan mentor dan member yang lainnya.
        </p>
        <div class="my-2 flex justify-center">
          <a
            :href="
              classroomLevel.forum
                ? classroomLevel.forum
                : classroomLevel.whatsapp_link
            "
            target="_blank"
            class="text-[#00446F] font-solusi text-sm font-semibold px-4 py-2 rounded-full border border-gray-200 flex items-center bg-white"
          >
            <img
              v-if="classroomLevel.forum && isDiscordLink"
              src="/assets/images/icon/discord.svg"
              class="mr-2 w-4 h-4"
              alt=""
            />
            <svg
              v-else-if="classroomLevel.forum && !isDiscordLink"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="telegram"
              class="mr-2 w-4 h-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
            >
              <path
                fill="currentColor"
                d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
              ></path>
            </svg>
            <img
              v-else
              src="/assets/images/icon/whatsapp.png"
              class="mr-2 w-5 h-5"
              alt=""
            />
            Gabung Grup
          </a>
        </div>
      </div>

      <div
        v-if="tab == 'konsultasi-desain'"
        class="w-full md:w-[75%] order-1 md:order-2 hidden md:flex flex-col bg-[#F9FCFF] overflow-y-auto scroll-custom"
      >
        <div
          v-if="privateWebinar?.length > 0"
          class="w-full h-full relative p-6"
        >
          <div
            v-for="webinar in privateWebinar"
            :key="'p-' + webinar.id"
            class="last:pb-3"
          >
            <CardPrivateWebinar
              :classroom="classroomLevel.classroom"
              :startDate="webinar.started_at"
              :expiredDate="webinar.expired_at"
              :webinar="webinar"
              :joinPrivateWebinar="joinPrivateWebinar"
              :quota="classroomLevel.quota_private"
              @reApply="openModalReapplyPrivateWebinar"
            />
          </div>
        </div>
        <div v-else class="flex flex-col justify-center items-center h-full">
          <img
            src="/assets/images/mentor/empty-state.svg"
            class="w-3/4 md:w-1/3"
            alt=""
          />
          <p class="text-center mt-3 font-solusi font-semibold text-[#333333]">
            Belum ada jadwal konsultasi.
          </p>
          <p class="text-center mt-1 font-solusi font-semibold text-[#333333]">
            Jika ingin mengajukan konsultasi desain, tekan tombol "Pengajuan
            Konsultasi".
          </p>
        </div>
      </div>
    </div>
    <ModalKuis
      :show="showModalStartQuiz"
      imageUrl="/assets/images/modal/illustration-start-the-test.svg"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :textTwo="modalQuiz.textTwo"
      submitText="Ya"
      :submit="checkQuiz"
      closeText="Tidak"
      :close="closeModalStartQuiz"
    />

    <ModalKuis
      :show="showModalStartPreTest"
      imageUrl="/assets/images/modal/illustration-start-the-test.svg"
      :title="'Mulai Pre-Test'"
      :textOne="'Apakah kamu yakin ingin memulai pre-test sekarang?'"
      submitText="Ya"
      :submit="openPreTest"
      closeText="Tidak"
      :close="closeModalStartPrePostTest"
    />

    <ModalKuis
      :show="showModalStartPostTest"
      imageUrl="/assets/images/modal/illustration-start-the-test.svg"
      :title="'Mulai Post-Test'"
      :textOne="'Apakah kamu yakin ingin memulai post-test sekarang?'"
      :textTwo="modalQuiz.textTwo"
      submitText="Ya"
      :submit="openPostTest"
      closeText="Tidak"
      :close="closeModalStartPrePostTest"
    />

    <ModalKuis
      :show="showModalConfirmQuiz"
      :imageUrl="'/assets/images/modal/illustration-test-completed.svg'"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :submitText="'Ya'"
      :submit="submitAnswer"
      :closeText="'Tidak'"
      :close="hideConfirmQuiz"
      :loading="isLoadingSubmitQuiz"
    />

    <ModalKuis
      :show="showModalConfirmPrePostTest"
      :imageUrl="'/assets/images/modal/illustration-test-completed.svg'"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :submitText="'Ya'"
      :submit="submitPrePostTest"
      :closeText="'Tidak'"
      :close="hideConfirmQuiz"
      :loading="isLoadingSubmitQuiz"
    />

    <ModalKuis
      :show="showModalConfirmWebinarQuiz"
      :imageUrl="'/assets/images/modal/illustration-test-completed.svg'"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :submitText="'Ya'"
      :submit="submitWebinarQuiz"
      :closeText="'Tidak'"
      :close="hideConfirmQuiz"
      :loading="isLoadingSubmitQuiz"
    />

    <ModalKuis
      :show="showModalNotDoneQuiz"
      :imageUrl="modalQuiz.imageUrl"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :closeText="''"
      :submitText="'OK'"
      :submit="closeModalNotDoneQuiz"
    />

    <ModalKuis
      :show="showAlertQuiz"
      :imageUrl="modalQuiz.imageUrl"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :closeText="'Tidak'"
      :close="closeAlertQuiz"
      :submitText="'Ya'"
      :submit="confirmAlertQuiz"
    />

    <ModalKuis
      :show="showAlertTab"
      :imageUrl="'/assets/images/modal/illustration-attention.svg'"
      :title="modalQuiz.title"
      :textOne="modalQuiz.textOne"
      :closeText="'Tidak'"
      :close="closeAlertTab"
      :submitText="'Ya'"
      :submit="changeTab"
    />

    <ModalPack
      :show="modalPackStatusMateri"
      :imageUrl="imageUrlModal"
      :firstText="firstTextModal"
      :secondText="secondTextModal"
      :firstButton="firstButtonModal"
      :firstButtonAction="nextMateri"
      :secondButton="secondButtonModal"
    />

    <ModalPack
      :show="modalPackStatusError"
      :imageUrl="imageUrlModal"
      imageWidth="12rem"
      :firstText="firstTextModal"
      :secondText="secondTextModal"
      :firstButton="firstButtonModal"
      :firstButtonAction="hideModalPack"
      :secondButton="secondButtonModal"
    />

    <ModalPack
      :show="modalWebinarQuiz"
      imageUrl="/assets/images/modal/warning.svg"
      firstText="PERINGATAN!"
      :secondText="textModalWebinarQuiz"
      firstButton="Lanjut"
      :firstButtonAction="showWebinarPreTest"
      secondButton=""
      :secondButtonAction="hideModalWebinarQuiz"
      imageWidth="150px"
    />

    <!-- <ModalRequestWebinar
      :show="false"
      imageUrl="/assets/images/modal/warning.svg"
      firstText="WEBINAR PLUS"
      secondText="Webinar Plus bisa dilaksanakan apabila kuota minimal pendaftar terpenuhi. Webinar Plus hanya bisa di ajukan satu kali."
      firstButton="Lanjut"
      :firstButtonAction="submitRequestWebinarPlus"
      secondButton=""
      :secondButtonAction="closeWebinarPlusModal"
      imageWidth="150px"
      :next="nextWebinarPlusModal"
      :showInput="showWebinarPlusReason"
      v-model:reason="payloadRequestWebinarPlus.reason"
      :classroom="payloadRequestWebinarPlus.classroom"
      :error="errorRequestWebinarPlus"
    /> -->

    <ModalResultQuiz
      :show="displayResult"
      :quizName="result.quizName"
      :countTrue="result.countTrue"
      :countFalse="result.countFalse"
      :score="result.score"
      :minScore="result.minScore"
      :reTest="checkQuiz"
      :next="redirectClassroom"
    />

    <ModalResultPreTest
      :show="displayResultPreTest"
      :countTrue="result.countTrue"
      :countFalse="result.countFalse"
      :score="result.score"
      :next="nextMaterialAfterPreTest"
    />

    <ModalResultPostTest
      :show="displayResultPostTest"
      :quizName="result.quizName"
      :countTrue="result.countTrue"
      :countFalse="result.countFalse"
      :minScore="result.minScore"
      :score="result.score"
      :next="refreshPostTest"
    />

    <ModalStatus
      :show="showAlert"
      :status="modalAlert.status"
      :title="modalAlert.title"
      :description="modalAlert.description"
      :close="closeShowAlert"
    />

    <transition name="fade">
      <div
        v-if="showReview"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showReview"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-3 pt-3">
              <div
                @click="closeModalReview()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="px-6 flex-auto overflow-x-hidden overflow-y-auto scroll-custom"
            >
              <p
                class="font-desain text-[#212121] font-semibold text-lg text-center mb-4"
              >
                Beri Ulasan Kelas
              </p>
              <div
                v-if="showAlertReview"
                class="mb-4 flex items-start bg-[#F5F7FD] rounded-md w-full p-2 space-x-2"
              >
                <svg
                  class="w-7 h-auto mt-0.5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C3.58192 0 0 3.58192 0 8C0 12.4181 3.58192 16 8 16C12.4181 16 16 12.4181 16 8C16 3.58192 12.4181 0 8 0ZM7.07563 11.4531V7.79056C7.07563 7.28056 7.48938 6.86619 8 6.86619C8.51062 6.86619 8.92437 7.28056 8.92437 7.79056V11.4531C8.92437 11.9637 8.51062 12.3775 8 12.3775C7.48938 12.3775 7.07563 11.9637 7.07563 11.4531ZM8 5.85744C7.55062 5.85744 7.14563 5.58682 6.97374 5.17181C6.80125 4.7568 6.89624 4.27869 7.21437 3.96118C7.53187 3.64306 8.01 3.54806 8.42499 3.71994C8.84062 3.89181 9.11125 4.29744 9.11125 4.74682C9.11125 5.04118 8.99375 5.3237 8.78562 5.53245C8.57749 5.74058 8.29437 5.85744 7.99998 5.85744H8Z"
                    fill="#FFC200"
                  />
                </svg>
                <p class="font-solusi text-[#212121] text-xs">
                  Pengguna Prakerja wajib memberikan ulasan (rating dan
                  komentar) untuk mendapatkan insentif pemerintah.
                </p>
                <svg
                  @click="showAlertReview = false"
                  class="w-6 h-auto mt-0.5 cursor-pointer"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.098 2.91123C12.7825 2.59572 12.2728 2.59572 11.9573 2.91123L8.0013 6.85915L4.04529 2.90314C3.72978 2.58763 3.22011 2.58763 2.9046 2.90314C2.58909 3.21865 2.58909 3.72832 2.9046 4.04383L6.86061 7.99984L2.9046 11.9558C2.58909 12.2714 2.58909 12.781 2.9046 13.0965C3.22011 13.412 3.72978 13.412 4.04529 13.0965L8.0013 9.14053L11.9573 13.0965C12.2728 13.412 12.7825 13.412 13.098 13.0965C13.4135 12.781 13.4135 12.2714 13.098 11.9558L9.14199 7.99984L13.098 4.04383C13.4054 3.73641 13.4054 3.21865 13.098 2.91123Z"
                    fill="#212121"
                  />
                </svg>
              </div>
              <div
                class="flex justify-center cursor-pointer text-4xl mb-1.5"
                @click="formReview.rating = tempRating"
              >
                <input
                  type="number"
                  :value="formReview.rating"
                  class="hidden"
                />

                <!-- <div v-if="formReview.rating != null">
                  <span class="text-gray-400 hover:text-gray-700" @mouseenter="tempRating = null" @mouseleave="tempRating = formReview.rating">⨯</span>
                </div> -->

                <div v-for="item in [1, 2, 3, 4, 5]" :key="item">
                  <span
                    v-if="isAlreadyRated"
                    :class="
                      tempRating >= item ? 'text-[#FFC200]' : 'text-[#E0E0E0]'
                    "
                  >
                    <svg
                      class="w-9 h-9"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.0489 2.92705C17.3483 2.00574 18.6517 2.00574 18.9511 2.92705L21.8167 11.7467C21.9506 12.1587 22.3346 12.4377 22.7678 12.4377H32.0413C33.0101 12.4377 33.4128 13.6773 32.6291 14.2467L25.1267 19.6976C24.7762 19.9522 24.6295 20.4036 24.7634 20.8156L27.6291 29.6353C27.9284 30.5566 26.874 31.3227 26.0902 30.7533L18.5878 25.3024C18.2373 25.0478 17.7627 25.0478 17.4122 25.3024L9.90976 30.7533C9.12605 31.3227 8.07157 30.5566 8.37092 29.6353L11.2366 20.8156C11.3705 20.4036 11.2238 19.9522 10.8733 19.6976L3.37088 14.2467C2.58717 13.6773 2.98994 12.4377 3.95867 12.4377H13.2322C13.6654 12.4377 14.0494 12.1587 14.1833 11.7467L17.0489 2.92705Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  <span
                    v-else
                    @mouseenter="tempRating = item"
                    @mouseleave="tempRating = formReview.rating"
                    :class="
                      tempRating >= item ? 'text-[#FFC200]' : 'text-[#E0E0E0]'
                    "
                  >
                    <svg
                      class="w-9 h-9"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.0489 2.92705C17.3483 2.00574 18.6517 2.00574 18.9511 2.92705L21.8167 11.7467C21.9506 12.1587 22.3346 12.4377 22.7678 12.4377H32.0413C33.0101 12.4377 33.4128 13.6773 32.6291 14.2467L25.1267 19.6976C24.7762 19.9522 24.6295 20.4036 24.7634 20.8156L27.6291 29.6353C27.9284 30.5566 26.874 31.3227 26.0902 30.7533L18.5878 25.3024C18.2373 25.0478 17.7627 25.0478 17.4122 25.3024L9.90976 30.7533C9.12605 31.3227 8.07157 30.5566 8.37092 29.6353L11.2366 20.8156C11.3705 20.4036 11.2238 19.9522 10.8733 19.6976L3.37088 14.2467C2.58717 13.6773 2.98994 12.4377 3.95867 12.4377H13.2322C13.6654 12.4377 14.0494 12.1587 14.1833 11.7467L17.0489 2.92705Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <p class="font-solusi text-[#333333] text-sm text-center mb-3">
                {{
                  tempRating > 4
                    ? 'Sangat Baik'
                    : tempRating > 3
                    ? 'Baik'
                    : tempRating > 2
                    ? 'Cukup Baik'
                    : tempRating > 1
                    ? 'Kurang Baik'
                    : tempRating > 0
                    ? 'Tidak Baik'
                    : ' '
                }}
              </p>
              <div class="flex flex-col">
                <label
                  for="comment"
                  class="font-solusi text-sm text-[#212121] mb-1"
                  >Komentar</label
                >
                <textarea
                  name="comment"
                  id="comment"
                  cols="30"
                  rows="3"
                  placeholder="Beri komentar kamu di sini"
                  class="font-solusi text-sm p-2 border border-gray-300 rounded-sm"
                  v-model="formReview.content"
                  :disabled="isAlreadyRated"
                >
                </textarea>
              </div>
              <div class="flex flex-col mt-3">
                <label
                  for="rating"
                  class="font-solusi text-sm text-[#212121] mb-1"
                  >Tambah Gambar
                  <span class="font-solusi text-xs text-gray-400"
                    >(Optional)</span
                  ></label
                >
                <div class="w-full flex flex-col justify-center items-center">
                  <div v-if="updatedImageRating" class="relative">
                    <img
                      :src="updatedImageRating"
                      class="w-[100px] h-[100px] rounded-sm"
                    />
                    <label
                      v-if="!isAlreadyRated"
                      for="imageRating"
                      class="absolute -top-3 -right-3 p-1 rounded-full bg-[#FB8500] hover:bg-[#d97706] cursor-pointer duration-300"
                      v-tooltip="{
                        content: 'Ganti Gambar',
                      }"
                    >
                      <svg
                        class="h-5 w-auto text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 0 24 24"
                        width="24px"
                        fill="currentColor"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                          d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
                        />
                      </svg>
                    </label>
                  </div>
                  <label v-else for="imageRating" class="cursor-pointer">
                    <div
                      class="w-[100px] h-[100px] border border-dashed border-[#757575] hover:border-[#00446F] text-[#757575] hover:text-[#00446F] flex flex-col items-center justify-center duration-300 rounded-sm"
                    >
                      <svg
                        class="h-8 w-auto"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 0 24 24"
                        width="24px"
                        fill="currentColor"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                          d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
                        />
                      </svg>
                      <p class="font-solusi text-center text-xs mt-2">
                        Pilih Gambar
                      </p>
                    </div>
                  </label>
                  <input
                    id="imageRating"
                    type="file"
                    ref="imageRating"
                    hidden
                    @change="onFileUpload"
                    accept="image/x-png,image/jpeg,image/jpg"
                  />
                </div>
              </div>
            </div>
            <div class="flex justify-center items-center p-4">
              <button
                v-if="!isAlreadyRated"
                @click="submitReview"
                class="font-solusi font-semibold text-base py-1.5 w-1/2 rounded-full flex items-center justify-center"
                :class="
                  loadingReview
                    ? 'text-[#9E9E9E] bg-[#EEEEEE] border-[#9E9E9E] cursor-wait'
                    : checkFormReview
                    ? 'bg-[#00446F] text-white'
                    : 'bg-border text-[#9E9E9E] cursor-not-allowed'
                "
                :disabled="!checkFormReview || loadingCropImage"
              >
                {{ formReview.content ? 'Ubah Ulasan' : 'Kirim' }}
                <svg
                  v-if="loadingReview"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-5 h-5 animate-spin ml-2"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
              </button>
              <!-- <p v-else class="font-solusi font-semibold text-center text-[#2FA742]">
                Terima kasih telah memberi ulasan
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showModalAskMentor"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalAskMentor"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-3 pt-3">
              <div
                @click="closeModalAskMentor()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="px-6 flex-auto overflow-x-hidden overflow-y-auto scroll-custom"
            >
              <p
                class="font-desain text-[#212121] font-semibold text-lg text-center mb-4"
              >
                Apa yang ingin kamu tanyakan?
              </p>
              <div class="mb-3 flex flex-col">
                <label
                  for="comment"
                  class="font-solusi text-sm text-[#212121] mb-1"
                  >Komentar</label
                >
                <textarea
                  name="comment"
                  id="comment"
                  cols="30"
                  rows="5"
                  placeholder="Tulis pertanyaan..."
                  class="font-solusi text-sm p-2 border border-gray-300 rounded-sm"
                  v-model="formQuestion.question"
                >
                </textarea>
              </div>
              <div class="mb-3 flex flex-col w-full justify-center">
                <label
                  for="questionFile"
                  class="font-solusi text-sm text-[#212121] mb-2"
                  >File (Opsional)</label
                >
                <label
                  for="assetsFieldHandle"
                  class="py-5 text-center bg-[#FFFFFF] border-2 border-dashed border-gray-300 rounded-md flex flex-col items-center cursor-pointer"
                  @dragover="dragoverQuestion"
                  @dragleave="dragleaveQuestion"
                  @drop="dropQuestion"
                >
                  <svg
                    class="w-10 h-10 mb-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.9935 3.00008C11.5386 3.00621 11.1743 3.37975 11.1827 3.83383V14.9449L7.67519 11.4374C7.50184 11.2564 7.2541 11.1651 7.00404 11.1897C6.68725 11.2211 6.41726 11.4336 6.31296 11.7342C6.20787 12.0349 6.28688 12.3693 6.51544 12.591L11.426 17.5015C11.745 17.8191 12.2605 17.8191 12.5796 17.5015L17.4885 12.591C17.6619 12.443 17.7654 12.229 17.7738 12.0012C17.7831 11.7734 17.6964 11.5525 17.5345 11.3914C17.3735 11.2295 17.1525 11.1429 16.9247 11.1521C16.6969 11.1605 16.4829 11.264 16.3349 11.4374L12.8211 14.9526V3.83381C12.8295 3.37282 12.4544 2.9947 11.9935 3.00006L11.9935 3.00008ZM3.81006 16.094C3.59222 16.0963 3.38512 16.1845 3.23326 16.3395C3.08138 16.4952 2.99702 16.7046 3.00008 16.9216V20.1961C2.99855 20.4139 3.08522 20.6233 3.2394 20.7775C3.39358 20.9317 3.60298 21.0183 3.8208 21.0168H20.1829C20.4008 21.0183 20.6102 20.9317 20.7643 20.7775C20.9185 20.6233 21.0052 20.4139 21.0036 20.1961V16.9216C20.9944 16.4768 20.6309 16.1216 20.186 16.1216C19.7411 16.1216 19.3775 16.4768 19.3676 16.9216V19.3806H4.6362V16.9216C4.6385 16.7015 4.55259 16.4898 4.39687 16.3341C4.24194 16.1784 4.03023 16.0917 3.8101 16.094L3.81006 16.094Z"
                      fill="#00446F"
                    />
                  </svg>
                  <input
                    type="file"
                    name="fields[assetsFieldHandle][]"
                    id="assetsFieldHandle"
                    class="w-px h-px opacity-0 overflow-hidden absolute"
                    @change="onQuestionFile"
                    ref="questionFile"
                  />
                  <label
                    for="deleteQuestion"
                    v-if="formQuestion.file"
                    class="font-solusi text-sm text-[#00446F] font-semibold"
                  >
                    {{ formQuestion?.file?.name }}
                    <button
                      for="deleteQuestion"
                      class="font-solusi text-sm ml-2 text-[#DE1306]"
                      @click="removeQuestionFile()"
                      title="Remove file"
                    >
                      hapus
                    </button>
                  </label>
                  <label
                    v-else
                    for="assetsFieldHandle"
                    class="block cursor-pointer"
                  >
                    <div class="font-solusi text-sm text-[#00446F]">
                      <span
                        class="font-solusi text-sm font-semibold text-[#00446F] hover:text-[#009DFF]"
                        >Pilih file</span
                      >
                      atau drag disini
                    </div>
                  </label>
                </label>
              </div>
              <p class="mb-6 font-solusi text-[#333333] text-sm">
                *Pertanyaan yang kamu ajukan hanya bisa dilihat antara kamu
                dengan mentor.
              </p>
            </div>
            <div class="flex justify-center items-center p-4">
              <button
                @click="submitQuestion"
                class="mx-auto px-12 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center"
                :class="
                  checkFormQuestion && !loadingSubmitQuestion
                    ? 'bg-[#00446F] text-[#FFFFFF]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
                "
                :disabled="!checkFormQuestion || loadingSubmitQuestion"
              >
                <svg
                  v-if="loadingSubmitQuestion"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-5 h-5 animate-spin mr-3"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Ajukan
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showModalTask"
        class="opacity-50 fixed md:hidden inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalTask"
        class="overflow-x-hidden overflow-y-auto fixed md:hidden inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-3 pt-3">
              <div
                @click="closeTask()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="flex-auto overflow-x-hidden overflow-y-auto scroll-custom divide-y-8 divide-[#EEEEEE]"
            >
              <div
                class="px-6 w-full flex flex-col overflow-y-auto scroll-custom"
              >
                <p
                  class="font-desain text-[#212121] font-semibold text-lg text-center my-3"
                >
                  {{ selectedTask.name }}
                </p>
                <div
                  v-html="selectedTask.description"
                  class="font-solusi text-[#333333] mb-3"
                ></div>
                <p
                  v-if="timeZone(selectedTask.started_at) <= dateNow"
                  class="font-solusi text-[#DE1306] font-semibold mb-3"
                >
                  Deadline: {{ dateFormat(selectedTask.expired_at) }}
                </p>
                <p v-else class="font-solusi text-[#2FBD71] font-semibold mb-3">
                  Dimulai: {{ dateFormat(selectedTask.started_at) }}
                </p>
                <div
                  class="flex flex-row w-full items-center justify-between mb-4"
                >
                  <span
                    class="flex justify-end items-center px-4 py-2 font-solusi text-[#FFFFFF] font-semibold text-2xs self-end rounded-full"
                    :class="
                      selectedTask?.started_at >= dateNow
                        ? 'bg-[#0A72ED]'
                        : selectedTask?.score > 0
                        ? 'bg-[#2FBD71]'
                        : selectedTask?.file
                        ? 'bg-[#757575]'
                        : selectedTask?.expired_at >= dateNow
                        ? 'bg-[#FB8500]'
                        : 'bg-[#DE1306]'
                    "
                  >
                    <svg
                      v-if="selectedTask?.score > 0"
                      class="mr-1 w-4 h-4"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="6.58301" cy="6" r="6" fill="white" />
                      <path
                        d="M5.21984 8.95562C5.35719 9.09652 5.5483 9.17636 5.74803 9.17636C5.74997 9.17636 5.752 9.17636 5.75414 9.17636C5.95619 9.17466 6.14837 9.09163 6.28466 8.94689L10.2751 4.70869C10.5457 4.42136 10.5246 3.97576 10.2284 3.71341C9.93214 3.45126 9.47262 3.47145 9.20208 3.75869L5.73902 7.43659L4.66103 6.32963C4.38536 6.04672 3.92545 6.03413 3.6339 6.30117C3.34214 6.56831 3.32916 7.0141 3.60455 7.29701L5.21984 8.95562Z"
                        fill="#2FBD71"
                      />
                    </svg>
                    {{
                      selectedTask?.started_at >= dateNow
                        ? 'Belum Mulai'
                        : selectedTask?.score > 0
                        ? 'Sudah Dinilai'
                        : selectedTask?.file
                        ? 'Menunggu Review Mentor'
                        : selectedTask?.expired_at >= dateNow
                        ? 'Belum Unggah'
                        : 'Terlambat'
                    }}
                  </span>
                  <button
                    v-if="selectedTask?.score > 0"
                    @click="openModalTaskScore"
                    class="font-solusi text-[#2097F6] text-sm font-semibold flex items-center px-3 py-1 border border-[#2097F6] rounded-full"
                  >
                    <svg
                      class="mr-1 w-4 h-4"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.92183 3.91797H4.08203V9.03897H7.92183V3.91797ZM7.28121 8.39837H4.72261V4.55857H7.28121V8.39837Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M9.19922 3.91797H13.6796V4.55859H9.19922V3.91797Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M9.19922 6.16016H13.6796V6.80078H9.19922V6.16016Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M9.19922 8.39844H13.6796V9.03906H9.19922V8.39844Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M4.07812 10.6406H13.6797V11.2812H4.07812V10.6406Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M4.07812 12.8789H11.4413V13.5195H4.07812V12.8789Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M4.07812 16.7227H8.55852V17.3633H4.07812V16.7227Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M19.293 8.86713C18.7579 8.33589 17.7227 8.17181 17.0312 8.86713L15.6016 10.2968V2.00001H13.6797V0.078125H0.238281V17.9999H2.16016V19.9218H15.6016V14.8242L19.293 11.1328C19.918 10.5078 19.918 9.49219 19.293 8.86721L19.293 8.86713ZM2.16024 17.3631H0.879001V0.718525H13.043V1.99977H2.1602L2.16024 17.3631ZM14.961 19.2811H2.80084V2.63649H14.961V10.9373L9.71884 16.1795L9.15244 19.0077L11.9806 18.4413L14.9572 15.4609V19.2813L14.961 19.2811ZM10.4688 16.3357L11.3751 15.4294L12.7345 16.7888L11.8243 17.6951L10.4688 16.3357ZM11.1759 17.949L9.96884 18.1911L10.211 16.9841L11.1759 17.949ZM13.1837 16.3357L11.8243 14.9763L17.2539 9.54271L18.6133 10.9021L13.1837 16.3357ZM19.0275 10.4099L17.754 9.14035C18.1095 8.98019 18.5587 9.03878 18.84 9.32394C19.1369 9.6169 19.1954 10.0544 19.0275 10.4099V10.4099Z"
                        fill="#2097F7"
                      />
                      <path
                        d="M15.4453 13.1677L14.9922 12.7145L17.2546 10.4521L17.7077 10.9053L15.4453 13.1677Z"
                        fill="#2097F7"
                      />
                    </svg>
                    Lihat Nilai
                  </button>
                </div>
              </div>
              <div
                v-if="
                  (timeZone(selectedTask?.expired_at) >= dateNow &&
                    timeZone(selectedTask?.started_at) <= dateNow) ||
                    selectedTask.file != ''
                "
                class="px-6"
              >
                <p
                  class="font-desain text-[#212121] font-semibold text-lg my-3"
                >
                  Pengumpulan Tugas
                </p>
                <div v-if="selectedTask.file == ''">
                  <div class="mb-3 flex flex-col w-full justify-center">
                    <label class="block text-left">
                      <span class="font-solusi text-sm text-[#212121] mb-1"
                        >Tipe File</span
                      >
                      <select
                        v-model="typeFile"
                        class="block w-full mt-1 bg-[#FFFFFF] text-[#212121] px-2 py-1 border border-gray-300 rounded-md font-solusi text-sm"
                        @change="onChangeSelectTaskType"
                      >
                        <option class="font-solusi text-sm" value="berkas"
                          >Berkas</option
                        >
                        <option class="font-solusi text-sm" value="link"
                          >Link</option
                        >
                      </select>
                    </label>
                  </div>
                  <div
                    v-if="typeFile == 'link'"
                    class="mb-3 flex flex-col w-full justify-center"
                  >
                    <label class="font-solusi text-sm text-[#212121] mb-1">
                      Link
                      <span
                        v-if="formTask.file && formTask.file != ''"
                        class="font-solusi text-sm text-[#212121] mb-1"
                        >(awali dengan http:// atau https://)</span
                      >
                    </label>
                    <input
                      type="text"
                      class="font-solusi text-sm text-[#212121] p-2 rounded-md border"
                      :class="
                        errorTaskLinkName
                          ? 'border-[#DE1306]'
                          : 'border-gray-300'
                      "
                      v-model="formTask.file"
                      @change="checkFormTaskFileLink"
                      placeholder="Masukkan Link URL (diawali http:// atau https://)"
                    />
                    <span
                      v-if="errorTaskLinkName"
                      class="text-sm font-solusi text-[#DE1306]"
                      >Isi link sesuai format</span
                    >
                  </div>
                  <div
                    v-if="typeFile == 'berkas'"
                    class="mb-3 flex flex-col w-full justify-center"
                  >
                    <label
                      for="questionFile"
                      class="font-solusi text-sm text-[#212121] mb-1"
                      >Berkas</label
                    >
                    <div
                      class="py-3 text-center bg-[#FFFFFF] border-2 border-dashed border-gray-300 rounded-md flex flex-col items-center"
                      @dragover="dragoverTask"
                      @dragleave="dragleaveTask"
                      @drop="dropTask"
                    >
                      <svg
                        class="w-12 h-12 mb-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.9935 3.00008C11.5386 3.00621 11.1743 3.37975 11.1827 3.83383V14.9449L7.67519 11.4374C7.50184 11.2564 7.2541 11.1651 7.00404 11.1897C6.68725 11.2211 6.41726 11.4336 6.31296 11.7342C6.20787 12.0349 6.28688 12.3693 6.51544 12.591L11.426 17.5015C11.745 17.8191 12.2605 17.8191 12.5796 17.5015L17.4885 12.591C17.6619 12.443 17.7654 12.229 17.7738 12.0012C17.7831 11.7734 17.6964 11.5525 17.5345 11.3914C17.3735 11.2295 17.1525 11.1429 16.9247 11.1521C16.6969 11.1605 16.4829 11.264 16.3349 11.4374L12.8211 14.9526V3.83381C12.8295 3.37282 12.4544 2.9947 11.9935 3.00006L11.9935 3.00008ZM3.81006 16.094C3.59222 16.0963 3.38512 16.1845 3.23326 16.3395C3.08138 16.4952 2.99702 16.7046 3.00008 16.9216V20.1961C2.99855 20.4139 3.08522 20.6233 3.2394 20.7775C3.39358 20.9317 3.60298 21.0183 3.8208 21.0168H20.1829C20.4008 21.0183 20.6102 20.9317 20.7643 20.7775C20.9185 20.6233 21.0052 20.4139 21.0036 20.1961V16.9216C20.9944 16.4768 20.6309 16.1216 20.186 16.1216C19.7411 16.1216 19.3775 16.4768 19.3676 16.9216V19.3806H4.6362V16.9216C4.6385 16.7015 4.55259 16.4898 4.39687 16.3341C4.24194 16.1784 4.03023 16.0917 3.8101 16.094L3.81006 16.094Z"
                          fill="#00446F"
                        />
                      </svg>
                      <input
                        type="file"
                        name="fields[assetsFieldHandle][]"
                        id="assetsFieldHandle"
                        class="w-px h-px opacity-0 overflow-hidden absolute"
                        @change="onTaskFile"
                        ref="taskFile"
                      />
                      <label
                        for="deleteFile"
                        v-if="formTask.file"
                        class="font-solusi text-sm text-[#00446F] font-semibold"
                      >
                        {{ formTask?.file?.name }}
                        <button
                          for="deleteFile"
                          class="font-solusi text-sm ml-2 text-[#DE1306]"
                          type="button"
                          @click="removeTaskFile()"
                          title="Remove file"
                        >
                          hapus
                        </button>
                      </label>
                      <label
                        v-else
                        for="assetsFieldHandle"
                        class="block cursor-pointer"
                      >
                        <div class="font-solusi text-sm text-[#00446F]">
                          <span
                            class="font-solusi text-sm font-semibold text-[#00446F] hover:text-[#009DFF]"
                            >Pilih Berkas</span
                          >
                          atau drag disini
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div v-else class="mb-3 flex flex-col w-full">
                  <label class="font-solusi text-sm text-[#212121] mb-1"
                    >File Tugas</label
                  >
                  <a
                    v-if="checkIsAssetFile(selectedTask.file)"
                    :href="'https://' + selectedTask.file"
                    target="_blank"
                    class="font-solusi text-sm text-[#009DFF] hover:text-[#FFFFFF] flex items-center px-2 py-1 hover:bg-[#009DFF] border border-[#009DFF] rounded-md w-fit-content"
                  >
                    <svg
                      class="mr-1 w-5 h-5"
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3298 5.19213C13.3341 5.1549 13.3341 5.11713 13.3298 5.0799C13.3314 5.06695 13.3314 5.054 13.3298 5.04105C13.3093 4.9941 13.2817 4.9504 13.2478 4.91155L9.7944 1.45819C9.75555 1.4242 9.71184 1.39668 9.6649 1.37617H9.62605L9.47496 1.33301H5.12802C4.41306 1.33301 3.83301 1.91306 3.83301 2.62802V12.9881C3.83301 13.703 4.41306 14.2831 5.12802 14.2831H12.0347C12.7497 14.2831 13.3297 13.703 13.3297 12.9881V5.21803V5.19213H13.3298ZM11.8578 4.78636H10.3081C10.0696 4.78636 9.87642 4.59319 9.87642 4.35469V2.80497L11.8578 4.78636ZM12.0348 13.4197H5.12808C4.88958 13.4197 4.69642 13.2266 4.69642 12.9881V2.62802C4.69642 2.38951 4.88958 2.19635 5.12808 2.19635H9.01311V4.35469C9.01311 5.06965 9.59316 5.6497 10.3081 5.6497H12.4665V12.9881C12.4665 13.1025 12.4211 13.2125 12.3402 13.2935C12.2593 13.3744 12.1492 13.4197 12.0348 13.4197L12.0348 13.4197Z"
                        fill="currentColor"
                      />
                    </svg>
                    File
                  </a>
                  <a
                    v-else
                    :href="'https://' + selectedTask.file"
                    target="_blank"
                    class="font-solusi text-sm text-[#009DFF] hover:text-[#FFFFFF] flex items-center px-2 py-1 hover:bg-[#009DFF] border border-[#009DFF] rounded-md w-full"
                  >
                    {{ 'https://' + selectedTask.file }}
                  </a>
                </div>
                <div class="mb-5 flex flex-col w-full">
                  <label
                    for="question"
                    class="font-solusi text-sm text-[#212121] mb-1"
                    >Keterangan (Opsional)</label
                  >
                  <textarea
                    name="question"
                    id="question"
                    cols="30"
                    rows="3"
                    v-model="formTask.note"
                    class="rounded-md font-solusi text-[#212121] text-sm p-2 border border-gray-300"
                    placeholder="Tulis deskripsi..."
                    :disabled="selectedTask.file != ''"
                  ></textarea>
                </div>
              </div>
            </div>
            <div
              v-if="
                timeZone(selectedTask?.expired_at) >= dateNow &&
                  selectedTask?.file == '' &&
                  timeZone(selectedTask?.started_at) <= dateNow
              "
              class="flex items-center p-4 shadow-md"
              :class="showUploadProgress ? 'justify-between' : 'justify-center'"
            >
              <div
                v-if="showUploadProgress"
                class="relative flex flex-col justify-center items-center"
              >
                <div class="flex mb-0.5 items-center justify-between w-40">
                  <div>
                    <span
                      class="font-solusi text-2xs font-semibold inline-block rounded-full text-[#212121]"
                    >
                      Upload Progress...
                    </span>
                  </div>
                  <div class="text-right">
                    <span
                      class="font-solusi  text-2xs text-[#212121] font-semibold inline-block"
                    >
                      {{ uploadPercentage }}%
                    </span>
                  </div>
                </div>
                <div
                  class="overflow-hidden h-2 mb-1.5 text-xs flex rounded bg-[#EEEEEE] w-40"
                >
                  <div
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#009DFF]"
                    :style="'width:' + uploadPercentage + '%'"
                  ></div>
                </div>
              </div>
              <button
                @click="submitUploadTask"
                class="px-10 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center"
                :class="
                  checkFormTask && !showUploadProgress
                    ? 'bg-[#00446F] text-[#FFFFFF]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
                "
                :disabled="!checkFormTask || showUploadProgress"
              >
                <svg
                  v-if="showUploadProgress"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-5 h-5 animate-spin mr-3"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Kirim Tugas
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showTaskScore"
        class="opacity-50 fixed inset-0 bg-black w-full h-full"
        style="z-index:60;"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showTaskScore"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex"
        style="z-index:61;"
      >
        <div class="relative w-3/4 md:w-[30%] my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeModalTaskScore"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-3 pt-3">
              <div
                @click="closeModalTaskScore()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="px-6 flex-auto overflow-x-hidden overflow-y-auto scroll-custom"
            >
              <p
                class="font-desain text-[#212121] font-semibold text-lg text-center mb-4"
              >
                Penilaian Tugas
              </p>
              <div class="mb-3 flex flex-col">
                <span class="font-solusi text-center text-sm text-[#212121]">
                  Nilai
                </span>
                <span
                  class="font-solusi text-4xl text-[#009DFF] font-semibold text-center"
                >
                  {{ selectedTask?.score }}
                </span>
              </div>
              <div class="mb-3 flex flex-col">
                <label
                  for="comment"
                  class="font-solusi text-sm text-[#212121] mb-1"
                  >Review Mentor</label
                >
                <textarea
                  name="comment"
                  id="comment"
                  cols="30"
                  rows="5"
                  placeholder="Review mentor..."
                  class="font-solusi text-sm p-2 border border-gray-300 rounded-sm scroll-custom"
                  :value="selectedTask?.feedback"
                  readonly
                >
                </textarea>
              </div>
            </div>
            <div class="flex justify-center items-center p-4">
              <button
                @click="closeModalTaskScore"
                class="mx-auto px-12 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center bg-[#00446F] text-[#FFFFFF]"
              >
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="modalRequestWebinarPlus"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="modalRequestWebinarPlus"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeWebinarPlusModal"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-3 pt-3">
              <div
                @click="closeWebinarPlusModal()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="flex-auto overflow-x-hidden overflow-y-auto scroll-custom divide-y-8 divide-[#EEEEEE]"
            >
              <div class="px-6">
                <p
                  class="font-desain text-[#212121] font-semibold text-lg mt-3 text-center"
                >
                  Berikan alasan kamu mengapa
                </p>
                <p
                  class="font-desain text-[#212121] font-semibold text-lg mb-3 text-center"
                >
                  ingin mengikuti Webinar Plus dibawah ini
                </p>
                <div class="mb-3 flex flex-col w-full justify-center">
                  <label class="block text-left">
                    <span class="font-solusi text-sm text-[#212121] mb-1"
                      >Pilih Webinar</span
                    >
                    <select
                      v-model="payloadRequestWebinarPlus.id"
                      class="block w-full mt-1 bg-[#FFFFFF] text-[#212121] px-2 py-1 border border-gray-300 rounded-md font-solusi text-sm"
                      required
                    >
                      <option
                        value="0"
                        disabled
                        selected
                        hidden
                        key="default"
                        class="font-solusi text-sm text-[#9E9E9E]"
                        >Pilih Webinar</option
                      >
                      <option
                        v-for="webinar in listRequestWebinarPlus"
                        :key="webinar.id"
                        class="font-solusi text-sm"
                        :value="webinar.id"
                      >
                        {{ webinar.name }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="mb-3 flex flex-col w-full">
                  <label
                    for="reason"
                    class="font-solusi text-sm text-[#212121] mb-1"
                    >Alasan</label
                  >
                  <textarea
                    name="reason"
                    id="reason"
                    cols="30"
                    rows="3"
                    v-model="payloadRequestWebinarPlus.reason"
                    class="rounded-md font-solusi text-[#212121] text-sm p-2 border border-gray-300"
                    placeholder="Beri alasan kamu di sini..."
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="flex items-center p-4 shadow-md justify-center">
              <button
                @click="submitRequestWebinarPlus"
                class="px-10 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center"
                :class="
                  checkFormWebinarPlus
                    ? 'bg-[#00446F] text-[#FFFFFF]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
                "
                :disabled="!checkFormWebinarPlus"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showModalAddQuota"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalAddQuota"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div
          class="relative w-full my-auto md:my-6 mx-2 md:mx-auto duration-300"
          :class="displayPaymentQuota ? 'md:w-[50%]' : 'md:w-[35%]'"
        >
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-between p-3">
              <div
                class="font-desain font-semibold text-lg text-[#212121] flex items-center"
              >
                <svg
                  v-if="displayPaymentQuota"
                  @click="backChooseQuota()"
                  class="w-5 h-5 cursor-pointer mr-2"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.07942 12.3116C2.08342 12.3226 2.08342 12.3336 2.08842 12.3446C2.08842 12.3466 2.08842 12.3476 2.08942 12.3496C2.14942 12.4916 2.23742 12.6116 2.33942 12.7196C2.35042 12.7316 2.35442 12.7466 2.36542 12.7586L10.0134 20.3366C10.2624 20.5826 10.5884 20.7056 10.9144 20.7056C11.2404 20.7056 11.5654 20.5826 11.8144 20.3366C12.3124 19.8436 12.3124 19.0456 11.8144 18.5526L6.34042 13.1276L21.1054 13.1276C21.8094 13.1276 22.3784 12.5636 22.3784 11.8656C22.3784 11.1696 21.8094 10.6046 21.1054 10.6046L6.34142 10.6046L11.8154 5.15257C12.3134 4.66057 12.3134 3.86157 11.8154 3.36957C11.3184 2.87657 10.5114 2.87657 10.0134 3.36957L2.36542 10.9736C2.25542 11.0826 2.17642 11.2116 2.11442 11.3476C2.09442 11.3896 2.08342 11.4306 2.06942 11.4726C2.03542 11.5746 2.01442 11.6766 2.00742 11.7846C2.00442 11.8286 1.99842 11.8696 2.00042 11.9136C2.00542 12.0496 2.02942 12.1816 2.07942 12.3116Z"
                    fill="#212121"
                  />
                </svg>
                {{
                  displayPaymentQuota
                    ? 'Pilih Metode Pembayaran'
                    : 'Kuota Konsultasi'
                }}
              </div>
              <div
                @click="closeModalAddQuota()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="flex-auto"
              :class="
                displayPaymentQuota
                  ? 'overflow-x-hidden overflow-y-auto scroll-custom border-b-4 border-[#EEEEEE]'
                  : ''
              "
            >
              <transition name="fade">
                <div
                  v-if="!displayPaymentQuota"
                  class="px-6 pt-6 pb-3 w-[60%] m-auto"
                >
                  <div class="mb-6 w-full flex items-center justify-between">
                    <button
                      @click="minQuota"
                      class="outline-none focus:outline-none font-solusi font-semibold w-8 h-8 text-xl flex items-center justify-center rounded-md duration-300"
                      :class="
                        disabledMinQuota
                          ? 'text-[#9E9E9E] bg-[#F5F6F8] cursor-not-allowed'
                          : 'text-[#212121] bg-[#F6FBFF] hover:text-[#009DFF]'
                      "
                      :disabled="disabledMinQuota"
                    >
                      -
                    </button>
                    <span
                      class="font-solusi text-2xl font-semibold text-[#333333]"
                    >
                      {{ formAddQuota.amount }}
                    </span>
                    <button
                      @click="plusQuota"
                      class="outline-none focus:outline-none font-solusi font-semibold w-8 h-8 text-xl flex items-center justify-center rounded-md duration-300"
                      :class="
                        disabledPlusQuota
                          ? 'text-[#9E9E9E] bg-[#F5F6F8] cursor-not-allowed'
                          : 'text-[#212121] bg-[#F6FBFF] hover:text-[#009DFF]'
                      "
                      :disabled="disabledPlusQuota"
                    >
                      +
                    </button>
                  </div>
                  <Slider
                    v-model="formAddQuota.amount"
                    showTooltip="drag"
                    :tooltips="false"
                    :min="1"
                    :max="20"
                    class="slider-blue"
                  ></Slider>
                  <p
                    class="text-center font-solusi text-[#757575] text-xs pt-3"
                  >
                    1 Kuota = Rp. {{ formatPrice(listQuotaPrice?.price) }}
                  </p>
                </div>
                <div v-else class="px-6 py-3">
                  <div
                    v-for="(manual, i) in listPaymentManual"
                    :key="i"
                    class="bg-white flex flex-col justify-between mb-4"
                  >
                    <p class="font-desain text-lg text-[#212121] font-semibold">
                      {{ manual.type }}
                    </p>
                    <p class="font-solusi text-base text-[#212121] mb-2">
                      {{ manual.note }}
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                      <div
                        v-for="(payment, j) in manual.payment"
                        :key="j"
                        @click="selectPayment(payment)"
                        class="cursor-pointer col-span-1 rounded-md border relative p-2 h-16 w-full md:h-[130px] md:w-[130px] flex flex-row items-center justify-between md:justify-center"
                        :class="
                          formAddQuota.payment_code == payment.code
                            ? 'bg-[#FFFAF1] border-[#FFC200]'
                            : 'bg-white border-[#EEEEEE]'
                        "
                      >
                        <svg
                          v-if="formAddQuota.payment_code == payment.code"
                          class="absolute -top-2.5 -right-2.5 w-6 h-6"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="12" cy="12" r="12" fill="#009DFF" />
                          <path
                            d="M9.27366 17.9117C9.54836 18.1935 9.93059 18.3532 10.3301 18.3532C10.3339 18.3532 10.338 18.3532 10.3423 18.3532C10.7464 18.3498 11.1307 18.1838 11.4033 17.8943L19.3842 9.41787C19.9253 8.84321 19.8833 7.95201 19.2909 7.42732C18.6983 6.903 17.7792 6.94339 17.2381 7.51786L10.312 14.8737L8.15605 12.6598C7.60471 12.0939 6.68489 12.0687 6.10178 12.6028C5.51827 13.1371 5.49231 14.0287 6.04308 14.5945L9.27366 17.9117Z"
                            fill="white"
                          />
                        </svg>
                        <div class="flex flex-row md:flex-col items-center">
                          <img
                            :src="payment.icon"
                            class="md:mx-auto h-5 md:h-7 md:mb-5"
                            alt=""
                          />
                          <p
                            class="ml-3 md:ml-0 font-solusi text-sm text-[#212121] text-center"
                          >
                            {{ payment.name }}
                          </p>
                        </div>
                        <input
                          type="radio"
                          v-model="formAddQuota.payment_code"
                          :value="payment.code"
                          class="block md:hidden"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="flex items-end px-3 pb-3 pt-2 justify-between">
              <div class="flex flex-col items-start">
                <div class="font-solusi text-sm text-[#212121] font-semibold">
                  Total
                </div>
                <div class="font-desain text-lg text-[#333333] font-semibold">
                  Rp.
                  {{
                    usePackageTopup
                      ? formatPrice(selectedPackage.price)
                      : formatPrice(listQuotaPrice?.price * formAddQuota.amount)
                  }}
                </div>
              </div>
              <button
                v-if="!displayPaymentQuota"
                @click="displayPaymentQuota = true"
                class="px-4 py-1.5 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center bg-[#00446F] text-[#FFFFFF] text-sm"
              >
                Pilih Metode Pembayaran
              </button>
              <button
                v-else
                @click="submitAddQuota"
                class="px-4 py-1.5 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center justify-center text-sm"
                :class="
                  checkPaymentCodeSelected
                    ? 'bg-[#00446F] text-[#FFFFFF]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed'
                "
                :disabled="!checkPaymentCodeSelected || loadingAddQuota"
              >
                <svg
                  v-if="loadingAddQuota"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-4 h-4 animate-spin mr-2"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Lanjut Bayar
              </button>
            </div>
            <div
              v-if="!displayPaymentQuota && packageTopup?.length > 0"
              class="flex flex-col items-center p-4 shadow-md justify-between space-y-5 border-t-4 border-[#EEEEEE] overflow-x-hidden overflow-y-auto scroll-custom bg-[#F6FBFF]"
            >
              <div
                v-for="paket in packageTopup"
                :key="paket.code"
                class="w-full flex space-x-4 p-2 bg-[#FFFFFF] rounded-lg shadow-sm hover:shadow-md duration-300"
              >
                <img
                  :src="
                    paket?.thumbnail
                      ? paket?.thumbnail
                      : '/assets/images/icon/package-topup.png'
                  "
                  class="w-24 h-24 rounded-lg"
                  alt=""
                />
                <div class="h-24 flex-grow flex flex-col justify-between">
                  <div class="flex flex-col">
                    <p
                      class="font-desain text-[#212121] font-semibold text-base"
                    >
                      {{ paket.name }}
                    </p>
                    <p class="font-solusi text-[#757575] text-xs md:text-sm">
                      Tambah {{ paket.amount }} kuota (Rp.
                      {{ formatPrice(paket.price) }})
                    </p>
                  </div>
                  <p
                    class="font-solusi text-[#333333] text-xs line-clamp-3 overflow-hidden"
                  >
                    {{ paket.description }}
                  </p>
                </div>
                <div class="flex justify-center items-center">
                  <a
                    @click="choosePackage(paket)"
                    class="font-solusi text-[#0A72ED] font-semibold text-sm cursor-pointer"
                    >Pilih</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showModalPrivateWebinar"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalPrivateWebinar"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div
          class="relative w-full my-auto md:my-6 mx-2 md:mx-auto duration-300 md:w-1/3"
        >
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-between px-3 pt-3">
              <div
                class="font-desain font-semibold text-lg text-[#212121] flex items-center"
              >
                {{
                  isReapplyPrivateWebinar
                    ? 'Pengajuan Ulang Konsultasi Desain'
                    : 'Pengajuan Konsultasi Desain'
                }}
              </div>
              <div
                @click="closeModalPrivateWebinar()"
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
              >
                <svg
                  class="fill-current text-[#212121]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="px-6 pt-6 pb-3 flex-auto overflow-x-hidden overflow-y-auto scroll-custom"
            >
              <div class="mb-3 flex flex-col">
                <label
                  for="private-webinar-note"
                  class="font-solusi text-[#212121] text-sm"
                >
                  Pilih Materi
                </label>
                <v-select
                  label="name"
                  placeholder="Pilih Materi"
                  :options="materials"
                  :reduce="option => option.name"
                  :clearable="false"
                  class="select-custom"
                  v-model="formPrivateWebinar.material"
                  @input="changePrivateWebinarMaterial()"
                  :disabled="isReapplyPrivateWebinar"
                ></v-select>
              </div>

              <div class="mb-3 flex flex-col">
                <label for="note" class="font-solusi text-[#212121] text-sm">
                  Keterangan
                </label>
                <textarea
                  name="private-webinar-note"
                  id="private-webinar-note"
                  cols="30"
                  rows="3"
                  v-model="formPrivateWebinar.note"
                  class="rounded-md font-solusi text-[#212121] text-sm p-2 border border-gray-300"
                  :class="isReapplyPrivateWebinar ? '' : ''"
                  placeholder="Berikan keterangan disini..."
                  :disabled="isReapplyPrivateWebinar"
                ></textarea>
              </div>

              <div class="mb-3 flex flex-col">
                <label for="" class="font-solusi text-[#212121] text-sm">
                  List Mentor
                </label>
                <v-select
                  label="name"
                  placeholder="Pilih Mentor"
                  :options="classroomLevel?.classroom?.mentor_data"
                  :reduce="option => option.name"
                  :clearable="false"
                  class="select-custom"
                  v-model="formPrivateWebinar.mentor"
                  :disabled="isReapplyPrivateWebinar"
                ></v-select>
              </div>

              <div class="mb-0 flex flex-col">
                <label
                  for="private-webinar-date"
                  class="font-solusi text-[#212121] text-sm"
                >
                  Jadwal Konsultasi Desain
                </label>
                <v-date-picker
                  v-model="formPrivateWebinar.request_started_at"
                  mode="datetime"
                  :min-date="new Date()"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="font-solusi text-sm px-3 py-2 rounded w-full border"
                      placeholder="Tanggal konsultasi desain"
                      :value="inputValue"
                      v-on="inputEvents"
                      name="private-webinar-date"
                      id="private-webinar-date"
                      autocomplete="off"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
            <div class="px-8 py-4 shadow-md grid grid-cols-2 gap-8">
              <button
                @click="closeModalPrivateWebinar"
                class="col-span-1 px-4 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center text-sm justify-center border bg-[#FFFFFF] text-[#00446F] border-[#00446F]"
              >
                Batal
              </button>
              <button
                v-if="!isReapplyPrivateWebinar"
                @click="submitAddPrivateWebinar"
                class="col-span-1 px-4 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center text-sm justify-center border"
                :class="[
                  checkFormAddPrivateWebinar
                    ? 'bg-[#00446F] text-[#FFFFFF] border-[#00446F]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed',
                  loadingAddPrivateWebinar ? 'cursor-wait' : '',
                ]"
                :disabled="!checkFormAddPrivateWebinar"
              >
                <svg
                  v-if="loadingAddPrivateWebinar"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-4 h-4 mr-2 animate-spin"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Ajukan Konsultasi
              </button>
              <button
                v-else
                @click="submitReapplyPrivateWebinar"
                class="col-span-1 px-4 py-2 rounded-full font-solusi font-semibold outline-none focus:outline-none duration-500 flex items-center text-sm justify-center border"
                :class="[
                  checkFormAddPrivateWebinar
                    ? 'bg-[#00446F] text-[#FFFFFF] border-[#00446F]'
                    : 'bg-[#F5F6F8] text-[#9E9E9E] cursor-not-allowed',
                  loadingAddPrivateWebinar ? 'cursor-wait' : '',
                ]"
                :disabled="!checkFormAddPrivateWebinar"
              >
                <svg
                  v-if="loadingAddPrivateWebinar"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-4 h-4 mr-2 animate-spin"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Ajukan Ulang
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="showModalImageRating"
        class="opacity-50 fixed inset-0 z-51 bg-black"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="showModalImageRating"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 ouline-none focus:outline-none flex justify-center items-center z-51"
      >
        <div
          class="relative w-full md:w-1/3 my-6 mx-4 md:mx-auto p-6 bg-[#FFFFFF] rounded-md"
        >
          <cropper
            ref="cropper"
            class="cropper"
            :src="previewImageRating"
            :stencil-props="{
              aspectRatio: 1 / 1,
            }"
          />
          <div class="pt-6 flex justify-center space-x-5">
            <button
              @click="closeModalImage"
              :disabled="loadingCropImage"
              class="font-solusi font-semibold text-base px-6 py-1.5 text-[#00446F] bg-[#FFFFFF] border border-[#00446F] rounded-full"
              :class="loadingCropImage ? 'cursor-not-allowed' : ''"
            >
              Batal
            </button>
            <button
              @click="cropImage"
              class="font-solusi font-semibold text-base px-6 py-1.5 border rounded-full duration-500 flex items-center justify-center"
              :class="
                loadingCropImage
                  ? 'text-[#9E9E9E] bg-[#EEEEEE] border-[#9E9E9E] cursor-wait'
                  : 'text-[#FFFFFF] bg-[#00446F] border-[#00446F]'
              "
              :disabled="loadingCropImage"
            >
              <svg
                v-if="loadingCropImage"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="spinner"
                class="w-5 h-5 animate-spin mr-2"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                ></path>
              </svg>
              Potong Gambar
            </button>
          </div>
        </div>
      </div>
    </transition>
    <!-- <Loading :show="isLoading" /> -->
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue'
import {
  Quiz,
  Subject,
  Module,
  WebinarQuiz,
  PrivateWebinar,
  PackageTopup,
} from '@/dto'
import ClassroomLevel from '@/dto/ClassroomLevel'
import Classroom from '@/dto/Classroom'

import ClassroomModel from '@/models/ClassroomModel'
import QuizModel from '@/models/QuizModel'
import VoucherModel from '@/models/VoucherModel'
import WebinarQuizModel from '@/models/WebinarQuizModel'
import TransactionModel from '@/models/TransactionModel'

import Webinar from '@/main/components/Cards/Webinar.vue'
import ModalPack from '@/main/components/Modals/ModalPack.vue'
import ModalRequestWebinar from '@/main/components/Modals/ModalRequestWebinar.vue'
import ModalQuiz from '@/main/components/Modals/ModalQuiz.vue'
import ModalKuis from '@/main/components/Modals/ModalKuis.vue'
import ModalResultQuiz from '@/main/components/Modals/ModalResultQuiz.vue'
import ModalResultPreTest from '@/main/components/Modals/ModalResultPreTest.vue'
import ModalResultPostTest from '@/main/components/Modals/ModalResultPostTest.vue'
import CardWebinar from '@/main/components/Cards/CardWebinar.vue'
import ModalStatus from '@/main/components/Modals/ModalStatus.vue'
import Slider from '@vueform/slider'
import CardPrivateWebinar from '@/main/components/Cards/CardPrivateWebinar.vue'
import Loading from '@/main/components/Loading.vue'

import { formatDuration } from '@/utils/Util'
import axios from 'axios'
import moment from 'moment'
import Cookies from 'js-cookie'
import 'fix-date'
import { useToast } from 'vue-toastification'
import { dragscrollNext } from 'vue-dragscroll'

export default defineComponent({
  directives: {
    dragscroll: dragscrollNext,
  },
  setup() {
    const toast = useToast()
    return {
      toast,
    }
  },
  data() {
    return {
      classroom: {} as Classroom,
      classroomLevel: {} as ClassroomLevel,
      classroomCode: '',
      classroomLevelCode: '',
      listWebinar: null as any,
      tab: '' as any,
      quiz: [] as Quiz[],
      modul: [] as Module[],
      subjects: null as Subject[] | null,
      isLoading: true as Boolean,
      webinarRecord: [] as any,
      isLoadingMaterial: true,
      isLoadingQuiz: true,
      isLoadingWebinar: true,
      isLoadingWebinarRecord: true,
      isLoadingSubmitQuiz: false,
      isCountdown: this.$route.query.is_countdown,
      isTab: this.$route.query.tab as any,
      levelData: {} as ClassroomLevel,
      dateNow: moment().format('YYYY-MM-DD HH:mm:ss'),
      selectedModule: null as any,
      subjectSelected: {} as any,
      selectedWebinarRecord: null as any,
      preTest: [] as any,
      postTest: [] as any,
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      distanceDay: true,
      isStartedYet: false,
      isProcessed: false,
      isNoAccomplishement: false,
      options: {
        clickToPlay: true,
        keyboard: {
          focused: false,
          global: false,
        },
        disableContextMenu: false,
        quality: {
          default: 480,
          // The options to display in the UI, if available for the source media
          options: [1080, 720, 480, 360],
          forced: true,
        },
        settings: ['quality'],
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'settings',
          'airplay',
          'fullscreen',
        ],
      },
      modalPackStatusError: false,
      imageUrlModal: '',
      firstTextModal: '',
      secondTextModal: '',
      firstButtonModal: '',
      secondButtonModal: '',
      uploadPercentage: 0,
      showUploadProgress: false,
      tasks: [] as any,
      modalWebinarQuiz: false,
      textModalWebinarQuiz: '',
      webinarQuiz: {} as WebinarQuiz,
      isDonePreTest: true,
      isExistPostTest: false,
      isDonePostTest: true,
      isAttemptPostTest: false,
      isAutoPlay: true,
      isPrakerja: false,
      postTestClass: {} as any,
      modalRequestWebinarPlus: false,
      payloadRequestWebinarPlus: {
        id: 0 as number,
        reason: '' as string,
        classroom: '' as string,
      },
      errorRequestWebinarPlus: false,
      showWebinarPlusReason: false,
      modalPostTest: false,
      textModalPostTest: '',
      modalExam: false,
      textModalExam: '',
      isDoneQuiz: false,
      selectedExam: {} as any,
      selectedMaterial: {} as any,
      selectedMaterialItem: {} as any,
      materials: [] as any,
      selectedQuiz: {} as any,
      toggledMaterial: [] as any,
      isExistMaterial: false,
      countMateri: 0 as number,
      countProgress: 0 as number,
      countDoneProgress: 0 as number,
      isDoneMateri: false,
      errorAskMentor: false,
      listUserQuestion: [] as any,
      loadingUserQuestion: false,
      loadingSubmitQuestion: false,
      userQuestion: '' as string,
      formQuestion: {
        question: '' as string,
        file: '' as string,
      },
      assets: [] as any,
      isExistResolution: false,
      resolutionVideos: [] as any,
      modalPackStatusMateri: false,
      quizId: 0 as number,
      quizData: {} as Quiz,
      payloadQuiz: {
        answers: [] as any,
        item_ids: [] as any,
      },
      questionIndex: 0 as number,
      showQuiz: false,
      displayResult: false,
      result: {
        quizName: '' as any,
        countTrue: 0 as Number,
        countFalse: 0 as Number,
        score: 0 as Number,
        minScore: 0 as Number,
      },
      isExpandQuestion: true,
      showModalStartQuiz: false,
      showModalConfirmQuiz: false,
      showModalNotDoneQuiz: false,
      modalQuiz: {
        title: '' as String,
        textOne: '' as String,
        textTwo: '' as String,
        imageUrl: '' as String,
      },
      showAlertQuiz: false,
      tempMaterial: {} as any,
      tempMaterialItem: {} as any,
      redirect: '' as string,
      prePostTestData: {} as any,
      showPrePost: false,
      showModalStartPreTest: false,
      showModalStartPostTest: false,
      showModalConfirmPrePostTest: false,
      testType: 0, // 0 = pre test, 1 = post test
      displayResultPreTest: false,
      displayResultPostTest: false,
      showPostTest: false,
      isExistPreTest: false,
      showReview: false,
      showAlertReview: true,
      tempRating: null as any,
      orig: null as any,
      formReview: {
        rating: null as any,
        content: '' as string,
        imageRating: null as any,
      },
      loadingReview: false as boolean,
      previewImageRating: null as any,
      showModalImageRating: false,
      updatedImageRating: null as any,
      loadingCropImage: false as boolean,
      showWebinarList: true,
      showWebinarRecordList: false,
      filterWebinar: 'waiting',
      showAlert: false,
      modalAlert: {
        status: '' as string,
        title: '' as string,
        description: '' as string,
      },
      payloadWebinarQuiz: {
        answers: [] as any,
        item_ids: [] as any,
      },
      webinarQuizData: {} as WebinarQuiz,
      showWebinarQuiz: false,
      showModalConfirmWebinarQuiz: false,
      isDoneWebinarQuiz: false,
      tempTab: '' as any,
      showAlertTab: false,
      showWebinar: false,
      showWebinarRecord: false,
      showModalAskMentor: false,
      selectedTask: {} as any,
      showModalTask: false,
      typeFile: 'berkas',
      formTask: {
        file: null as any,
        note: '' as string,
      },
      errorTaskLinkName: false,
      showTaskScore: false,
      listRequestWebinarPlus: [] as any,
      isVideo: this.$route.query.video as any,
      isModule: this.$route.query.module as any,
      isVideoDone: true,
      isModuleDone: true,
      isQuizDone: true,
      isWebinarDone: true,
      isSubmissionDone: true,
      isExamDone: true,
      isAlreadyRated: false,
      privateWebinar: [] as any,
      showModalAddQuota: false,
      listQuotaPrice: {} as any,
      loadingAddQuota: false,
      formAddQuota: {
        amount: 1 as number,
        payment_code: '' as string,
        classroom_code: '' as string,
      },
      displayPaymentQuota: false,
      showModalPrivateWebinar: false,
      filterPrivateWebinar: 'requested' as string,
      formPrivateWebinar: {
        material: '' as string,
        note: '' as string,
        mentor: '' as string,
        request_started_at: '' as string,
      },
      loadingAddPrivateWebinar: false,
      showAlertPrivateWebinar: false,
      isReapplyPrivateWebinar: false,
      selectedPrivateWebinar: {} as PrivateWebinar,
      formReapplyPrivateWebinar: {
        request_started_at: '' as string,
      },
      packageTopup: [] as PackageTopup[],
      selectedPackage: {} as PackageTopup,
      usePackageTopup: false,
      isExistForum: true,
      listPaymentManual: [
        {
          type: 'E-Wallet',
          note:
            'Kamu bisa melakukan transaksi melalui e-wallet yang kamu miliki.',
          payment: [
            {
              account: 'OVO',
              code: 'ovo',
              icon: '/assets/images/payment/logo_ovo.png',
              id: 22,
              instructions: '',
              name: 'OVO',
            },
            {
              account: 'Dana',
              code: 'dana',
              icon: '/assets/images/payment/logo_dana.png',
              id: 23,
              instructions: '',
              name: 'DANA',
            },
            {
              account: 'Gopay',
              code: 'gopay',
              icon: '/assets/images/payment/logo_gopay.png',
              id: 24,
              instructions: '',
              name: 'GOPAY',
            },
            {
              account: 'Link Aja',
              code: 'link-aja',
              icon: '/assets/images/payment/logo_linkaja.png',
              id: 25,
              instructions: '',
              name: 'Link Aja',
            },
            {
              account: 'Shopee Pay',
              code: 'shopeepay',
              icon: '/assets/images/payment/logo_shopeepay.png',
              id: 26,
              instructions: '',
              name: 'Shopee Pay',
            },
          ],
        },
        {
          type: 'Transfer Bank',
          note: 'Kode unik transaksi untuk mempercepat proses verifikasi.',
          payment: [
            {
              account: '1380556667777',
              code: 'mandiritf',
              icon: '/assets/images/payment/logo_mandiri.png',
              id: 19,
              instructions:
                '1. Masukkan kartu ke mesin ATM, pilihlah bahasa masukan kemudian masukkan kode PIN ATM Anda dengan benar.\\n2. Pilihlah menu “Transaksi Lainnya” pada laman menu.\\n3. Pilihlah “Transfer” , lalu pilih “Rekening Mandiri”.\\n4. Masukan Nomor $1 a.n. $3 kemudian pilih Benar.\\n5. Masukan jumlah nominal uang $2 kemudian pilih Benar.\\n6. Mohon periksa kembali informasi nomor rekening tujuan dan nominal uang yang akan ditransfer.\\n7. Kemudian, selembar struk akan keluar dari ATM. Jangan lupa untuk mengunggah bukti struk transaksi ini untuk menyelesaikan transaksi.',
              name: 'Bank Mandiri',
            },
            {
              account: '3948000999',
              code: 'bcatf',
              icon: '/assets/images/payment/logo_bca.png',
              id: 20,
              instructions:
                '1. Masukkan kartu ke mesin ATM, pilihlah bahasa masukan kemudian masukkan kode PIN ATM Anda dengan benar.\\n2. Pilihlah menu “Transfer” dan “Ke Rek BCA”.\\n3. Kemudian, masukkan nomor rekening BCA yang dituju $1 a.n. $3\\n4. Setelah itu, lanjutkan dengan memasukkan nominal sebesar $2.\\n5. Lalu, ada pertanyaan tentang No Referensi. Bagian ini bisa dikosongkan.\\n6. Tekan OK atau Ya.\\n7. Kemudian, selembar struk akan keluar dari ATM. Jangan lupa untuk mengunggah bukti struk transaksi ini untuk menyelesaikan transaksi.',
              name: 'Bank BCA',
            },
          ],
        },
      ] as any,
    }
  },

  async created() {
    // document.addEventListener('beforeunload', ()=> {
    //   window.confirm('test')
    // });
    if (Object.keys(this.getProfileData)?.length == 0) {
      this.getProfile()
    }
    const params: any = this.$route.params
    this.classroomCode = params.code
    this.classroomLevelCode = params.code + '1'
    this.isLoading = true
    await this.getClassRoomLevelDetail(this.classroomLevelCode)
    if (!this.isTab) {
      this.tab = 'materi'
    } else {
      this.tab = this.isTab
    }
    await this.init()
  },

  async mounted() {
  },

  computed: {
    _seconds() {
      return 1000
    },
    _minutes() {
      return 1000 * 60
    },
    _hours() {
      return 60000 * 60
    },
    _days() {
      return 3600000 * 24
    },
    getProfileData(): any {
      return this.$store.getters['profileStore/getProfileData']
    },
    checkFormReview(): Boolean {
      if (this.formReview.rating > 0 && this.formReview.content != '') {
        return true
      } else {
        return false
      }
    },
    checkFormQuestion(): Boolean {
      if (this.formQuestion.question) {
        return true
      } else {
        return false
      }
    },
    countWebinarWaiting(): number {
      const {
        'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
      } = this.$store.getters as any
      if (getClassroomWebinarData?.length > 0) {
        return getClassroomWebinarData.filter((el: any) => {
          if (this.timeZone(el.started_at) > this.dateNow) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },
    countWebinarOnGoing(): number {
      const {
        'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
      } = this.$store.getters as any
      if (getClassroomWebinarData?.length > 0) {
        return getClassroomWebinarData.filter((el: any) => {
          if (
            this.timeZone(el.started_at) <= this.dateNow &&
            this.timeZone(el.expired_at) >= this.dateNow
          ) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },
    countWebinarDone(): number {
      const {
        'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
      } = this.$store.getters as any
      if (getClassroomWebinarData?.length > 0) {
        return getClassroomWebinarData.filter((el: any) => {
          if (this.timeZone(el.expired_at) < this.dateNow) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },

    countPrivateWebinarRequested(): number {
      const {
        'classroomStore/getClassroomPrivateWebinarData': getClassroomPrivateWebinarData,
      } = this.$store.getters as any
      if (getClassroomPrivateWebinarData?.length > 0) {
        return getClassroomPrivateWebinarData.filter((el: any) => {
          if (el.status == 0) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },

    countPrivateWebinarApproved(): number {
      const {
        'classroomStore/getClassroomPrivateWebinarData': getClassroomPrivateWebinarData,
      } = this.$store.getters as any
      if (getClassroomPrivateWebinarData?.length > 0) {
        return getClassroomPrivateWebinarData.filter((el: any) => {
          if (el.status == 1) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },

    countPrivateWebinarRejected(): number {
      const {
        'classroomStore/getClassroomPrivateWebinarData': getClassroomPrivateWebinarData,
      } = this.$store.getters as any
      if (getClassroomPrivateWebinarData?.length > 0) {
        return getClassroomPrivateWebinarData.filter((el: any) => {
          if (el.status == -1) {
            return el
          }
        }).length
      } else {
        return 0
      }
    },

    countPrivateWebinarAll(): number {
      const {
        'classroomStore/getClassroomPrivateWebinarData': getClassroomPrivateWebinarData,
      } = this.$store.getters as any
      if (getClassroomPrivateWebinarData?.length > 0) {
        return getClassroomPrivateWebinarData.length
      } else {
        return 0
      }
    },

    checkFormTask(): boolean {
      if (this.typeFile == 'berkas') {
        if (this.formTask?.file) {
          return true
        } else {
          return false
        }
      } else {
        if (this.formTask?.file?.includes('https://')) {
          return true
        } else {
          return false
        }
      }
    },

    checkFormWebinarPlus(): boolean {
      if (
        this.payloadRequestWebinarPlus.id &&
        this.payloadRequestWebinarPlus.reason
      ) {
        return true
      } else {
        return false
      }
    },

    isDiscordLink(): boolean {
      if (this.classroomLevel.forum.includes('discord')) {
        return true
      } else {
        return false
      }
    },

    disabledMinQuota(): boolean {
      if (this.formAddQuota.amount < 2) {
        return true
      } else {
        return false
      }
    },

    disabledPlusQuota(): boolean {
      if (this.formAddQuota.amount >= 20) {
        return true
      } else {
        return false
      }
    },

    checkPaymentCodeSelected(): boolean {
      if (this.formAddQuota.payment_code == '') {
        return false
      } else {
        return true
      }
    },

    checkFormAddPrivateWebinar(): boolean {
      if (
        this.formPrivateWebinar.request_started_at != '' &&
        this.formPrivateWebinar.note != '' &&
        this.formPrivateWebinar.material != '' &&
        this.formPrivateWebinar.mentor != ''
      ) {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    async getProfile() {
      await this.$store.dispatch('profileStore/fetchProfileData')
    },
    sideScroll(
      el: string,
      direction: string,
      speed: number,
      distance: number,
      step: number
    ) {
      var scrollAmount = 0 as number
      const element: any = this.$refs[el]
      // console.log(element)
      var slideTimer = setInterval(function() {
        if (direction == 'left') {
          element.scrollLeft -= step
        } else {
          element.scrollLeft += step
        }
        scrollAmount += step
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer)
        }
      }, speed)
      // console.log('width',element.scrollWidth)
      // console.log('left',element.scrollLeft)
    },
    showConfirmWebinarQuiz() {
      this.showModalConfirmWebinarQuiz = true
      this.modalQuiz.title = 'Selesaikan ' + this.webinarQuizData?.name
      this.modalQuiz.textOne =
        'Apakah kamu yakin ingin menyelesaikan ' +
        this.webinarQuizData?.name +
        ' ini?'
    },
    showConfirmPrePostTest() {
      this.showModalConfirmPrePostTest = true
      this.modalQuiz.title =
        'Selesaikan ' + (this.testType ? 'Post-Test' : 'Pre-Test')
      this.modalQuiz.textOne =
        'Apakah kamu yakin ingin menyelesaikan ' +
        (this.testType ? 'post-Test' : 'pre-Test') +
        ' ini?'
    },
    showConfirmQuiz() {
      this.showModalConfirmQuiz = true
      this.modalQuiz.title = 'Selesaikan Kuis'
      this.modalQuiz.textOne = 'Apakah kamu yakin ingin menyelesaikan kuis ini?'
    },
    hideConfirmQuiz() {
      if (!this.isLoadingSubmitQuiz) {
        this.showModalConfirmQuiz = false
        this.showModalConfirmPrePostTest = false
        this.showModalConfirmWebinarQuiz = false
      }
    },
    nextAfterChoose(length: number) {
      if (length != this.questionIndex + 1) {
        this.questionIndex = this.questionIndex + 1
        const el: any = this.$refs['q' + this.questionIndex]
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
          })
        }
      }
    },
    countMaterialDone(materi: any) {
      var done = 0
      materi.forEach((el: any) => {
        if (el.data.is_done) {
          done++
        }
      })
      return done
    },
    prevQuestion() {
      this.questionIndex = this.questionIndex - 1
      const el: any = this.$refs['q' + this.questionIndex]
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
    nextQuestion() {
      this.questionIndex = this.questionIndex + 1
      const el: any = this.$refs['q' + this.questionIndex]
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
    changeQuestion(number: number) {
      this.questionIndex = number
    },
    async checkQuiz() {
      await this.getOneQuiz(this.selectedMaterialItem.data.id)
      this.showModalStartQuiz = false
      this.displayResult = false
      this.showQuiz = true
    },
    openModalQuiz(data: any) {
      this.showModalStartQuiz = true
      this.modalQuiz.title = 'Mulai Kuis'
      this.modalQuiz.textOne =
        'Apakah kamu yakin ingin memulai ' + data.name + ' sekarang?'
      this.modalQuiz.textTwo = 'Nilai kelulusan:  ' + data.min_score
    },
    closeModalStartQuiz() {
      this.showModalStartQuiz = false
    },
    async getOneQuiz(id: number) {
      this.payloadQuiz.item_ids = []
      this.payloadQuiz.answers = []
      this.questionIndex = 0
      if (this.quizData?.id != id) {
        const { success, data } = await QuizModel.list(id)
        if (success) {
          this.questionIndex = 0
          this.quizData = data
        }
      }
      for (let i = 0; i < this.quizData?.items?.length; i++) {
        this.payloadQuiz.item_ids.push(this.quizData.items[i].id)
        this.payloadQuiz.answers.push(null)
      }
    },

    async submitPrePostTest() {
      const isNull = this.payloadQuiz.answers.some(function(el: any) {
        return el == null
      })
      let type = this.testType ? 'Post-Test' : 'Pre-Test'
      if (!isNull) {
        this.isLoadingSubmitQuiz = true
        try {
          let payload = {}
          if (this.testType) {
            payload = {
              answers: this.payloadQuiz.answers,
              item_ids: this.payloadQuiz.item_ids,
              post_test_id: this.prePostTestData.id,
            }
          } else {
            payload = {
              answers: this.payloadQuiz.answers,
              item_ids: this.payloadQuiz.item_ids,
              pre_test_id: this.prePostTestData.id,
            }
          }
          const { success, data } = await ClassroomModel.submitPrePostTest(
            this.classroomCode,
            this.testType,
            payload
          )
          this.isLoadingSubmitQuiz = false
          this.hideConfirmQuiz()
          if (this.testType == 0) {
            this.checkIsExistPostTest()
          }
          if (success) {
            if (this.testType == 1) {
              this.result.quizName = type
              this.result.score = data.score
              this.result.countTrue = Math.round(
                (this.prePostTestData.items?.length * data.score) / 100
              )
              this.result.countFalse =
                this.prePostTestData.items?.length -
                Math.round(
                  (this.prePostTestData.items?.length * data.score) / 100
                )
              this.result.minScore = this.postTestClass.min_score
              this.displayResultPostTest = true
              this.postTestClass.score = data.score
              if (data.score >= this.postTestClass?.min_score) {
                this.postTestClass.is_done = true
                this.isDonePostTest = true
                this.isAttemptPostTest = true
              } else {
                this.isDonePostTest = false
                this.isAttemptPostTest = true  
              }
            } else {
              this.result.score = data.score
              this.result.countTrue = Math.round(
                (this.prePostTestData.items?.length * data.score) / 100
              )
              this.result.countFalse =
                this.prePostTestData.items?.length -
                Math.round(
                  (this.prePostTestData.items?.length * data.score) / 100
                )
              this.displayResultPreTest = true
            }
          } else {
            let text = ''
            let notAnswered = [] as any
            this.payloadQuiz.answers.forEach((el: any, i: number) => {
              if (el == null) {
                notAnswered.push(i + 1)
              }
            })
            text = [
              notAnswered.slice(0, -1).join(', '),
              notAnswered.slice(-1)[0],
            ].join(notAnswered?.length < 2 ? '' : ' dan ')
            this.modalQuiz.imageUrl =
              '/assets/images/modal/illustration-test-not-completed.svg'
            this.modalQuiz.title = 'Maaf, ' + type + ' kamu belum selesai'
            this.modalQuiz.textOne = 'Harap selesaikan soal nomor ' + text
            this.showModalNotDoneQuiz = true
          }
        } catch (err) {
          this.isLoadingSubmitQuiz = false
          const error: any = err
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = error.response.data.errors[0].message
        }
      } else {
        this.hideConfirmQuiz()
        let text = ''
        let notAnswered = [] as any
        this.payloadQuiz.answers.forEach((el: any, i: number) => {
          if (el == null) {
            notAnswered.push(i + 1)
          }
        })
        text = [
          notAnswered.slice(0, -1).join(', '),
          notAnswered.slice(-1)[0],
        ].join(notAnswered?.length < 2 ? '' : ' dan ')
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        this.modalQuiz.title = 'Maaf, ' + type + ' kamu belum selesai'
        this.modalQuiz.textOne = 'Harap selesaikan soal nomor ' + text
        this.showModalNotDoneQuiz = true
      }
    },
    async submitAnswer() {
      const isNull = this.payloadQuiz.answers.some(function(el: any) {
        return el == null
      })
      if (!isNull) {
        this.isLoadingSubmitQuiz = true
        try {
          const { success, data } = await QuizModel.add(
            this.quizData.id,
            this.payloadQuiz
          )
          this.isLoadingSubmitQuiz = false
          this.hideConfirmQuiz()
          if (success) {
            this.result.quizName = this.quizData?.name
            this.result.countTrue = data.correct
            this.result.countFalse = data.wrong
            this.result.score = data.score
            this.result.minScore =
              this.quizData.min_score > 0
                ? this.quizData.min_score
                : this.quizData.is_exam
                ? 60
                : 80
            this.displayResult = true
            if (this.result.score >= this.result.minScore) {
              this.materials.forEach((el: any) => {
                if (el.material?.length > 0) {
                  el.material.forEach((e: any) => {
                    if (e.type == 'quiz' && e.data.id == this.quizData.id) {
                      e.data.is_done = true
                    }
                  })
                }
              })
              this.checkClassroomProgress()
            }
          } else {
            let text = ''
            let notAnswered = [] as any
            this.payloadQuiz.answers.forEach((el: any, i: number) => {
              if (el == null) {
                notAnswered.push(i + 1)
              }
            })
            text = [
              notAnswered.slice(0, -1).join(', '),
              notAnswered.slice(-1)[0],
            ].join(notAnswered.length < 2 ? '' : ' dan ')
            this.modalQuiz.imageUrl =
              '/assets/images/modal/illustration-test-not-completed.svg'
            this.modalQuiz.title = 'Maaf, kuis kamu belum selesai'
            this.modalQuiz.textOne = 'Harap selesaikan soal nomor ' + text
            this.showModalNotDoneQuiz = true
          }
        } catch (err) {
          this.isLoadingSubmitQuiz = false
          const error: any = err
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = error.response.data.errors[0].message
        }
      } else {
        this.hideConfirmQuiz()
        let text = ''
        let notAnswered = [] as any
        this.payloadQuiz.answers.forEach((el: any, i: number) => {
          if (el == null) {
            notAnswered.push(i + 1)
          }
        })
        text = [
          notAnswered.slice(0, -1).join(', '),
          notAnswered.slice(-1)[0],
        ].join(notAnswered.length < 2 ? '' : ' dan ')
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        this.modalQuiz.title = 'Maaf, kuis kamu belum selesai'
        this.modalQuiz.textOne = 'Harap selesaikan soal nomor ' + text
        this.showModalNotDoneQuiz = true
      }
    },
    async submitWebinarQuiz() {
      const isNull = this.payloadWebinarQuiz.answers.some(function(el: any) {
        return el == null
      })
      if (!isNull) {
        this.isLoadingSubmitQuiz = true
        try {
          const { success, data } = await WebinarQuizModel.submitV2(
            this.webinarQuizData.id,
            this.payloadWebinarQuiz
          )
          this.isLoadingSubmitQuiz = false
          this.hideConfirmQuiz()
          if (success) {
            this.isDoneWebinarQuiz = true
            this.webinarQuizData.items.map((e: any) => {
              const findResult = data.overview.find(
                (el: any) => el.item_id == e.id
              )
              e.result = findResult.result
            })
            this.showAlert = true
            this.modalAlert.status = 'success'
            this.modalAlert.title = 'Selamat'
            this.modalAlert.description = 'Kamu mendapatkan nilai ' + data.score
          }
          await this.getWebinarQuiz()
          this.getListWebinar()
        } catch (err) {
          this.isLoadingSubmitQuiz = false
          const error: any = err
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = error.response.data.errors[0].message
        }
      } else {
        this.hideConfirmQuiz()
        let text = ''
        let notAnswered = [] as any
        this.payloadWebinarQuiz.answers.forEach((el: any, i: number) => {
          if (el == null) {
            notAnswered.push(i + 1)
          }
        })
        text = [
          notAnswered.slice(0, -1).join(', '),
          notAnswered.slice(-1)[0],
        ].join(notAnswered.length < 2 ? '' : ' dan ')
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        this.modalQuiz.title =
          'Maaf, ' + this.webinarQuizData.name + ' kamu belum selesai'
        this.modalQuiz.textOne = 'Harap selesaikan soal nomor ' + text
        this.showModalNotDoneQuiz = true
      }
    },
    closeModalNotDoneQuiz() {
      this.showModalNotDoneQuiz = false
    },
    onQuestionFile(event: any) {
      this.formQuestion.file = event.target.files[0]
    },
    removeQuestionFile() {
      this.formQuestion.file = ''
    },
    dragoverQuestion(event: any) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-[#E8EDFF]')) {
        event.currentTarget.classList.remove('bg-[#FFFFFF]')
        event.currentTarget.classList.add('bg-[#E8EDFF]')
      }
    },
    dragleaveQuestion(event: any) {
      // Clean up
      event.currentTarget.classList.add('bg-[#FFFFFF]')
      event.currentTarget.classList.remove('bg-[#E8EDFF]')
    },
    dropQuestion(event: any) {
      event.preventDefault()
      ;(this.$refs.questionFile as any).files = event.dataTransfer.files
      this.formQuestion.file = event.dataTransfer.files[0]
      // Clean up
      event.currentTarget.classList.add('bg-[#FFFFFF]')
      event.currentTarget.classList.remove('bg-[#E8EDFF]')
    },

    async nextMaterialAfterPreTest() {
      this.isDonePreTest = true
      await this.getMaterialsList()
      this.showPrePost = false
      this.showQuiz = false
      this.displayResultPreTest = false
    },
    refreshPostTest() {
      // await this.checkIsExistPostTest()
      this.displayResultPostTest = false
      this.showPrePost = false
    },
    async redirectClassroom() {
      await this.getMaterialsList()
      this.showAlertQuiz = false
      this.displayResult = false
      this.showQuiz = false
    },
    isActiveMateri(item: any) {
      return this.toggledMaterial.indexOf(item) >= 0
    },
    toggleMateri(item: any) {
      const index = this.toggledMaterial.indexOf(item)
      if (index >= 0) {
        this.toggledMaterial.splice(index, 1)
        return
      }
      this.toggledMaterial.push(item)
    },
    async getOneVideo(id: number) {
      this.assets = []
      this.resolutionVideos = []
      await ClassroomModel.detailSubject(id)
        .then(res => {
          if (res.success) {
            this.assets = res.data?.assets
            if (res.data?.resolutions?.length > 0) {
              this.isExistResolution = true
              this.resolutionVideos = res.data
            } else {
              this.isExistResolution = false
            }
            this.settingQuality(this.resolutionVideos)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    changePage(to: string) {
      if (this.showQuiz || this.showPrePost || this.showWebinarQuiz) {
        this.redirect = to
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        if (this.showQuiz) {
          this.modalQuiz.title = 'Maaf, kuis kamu belum selesai'
          this.modalQuiz.textOne =
            'Apakah kamu yakin ingin meninggalkan kuis ini?'
        } else if (this.showPrePost) {
          if (this.testType) {
            this.modalQuiz.title = 'Maaf, post-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan post-test ini?'
          } else {
            this.modalQuiz.title = 'Maaf, pre-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan pre-test ini?'
          }
        } else if (this.showWebinarQuiz) {
          if (this.isDoneWebinarQuiz) {
            this.modalQuiz.imageUrl =
              '/assets/images/modal/illustration-attention.svg'
            this.modalQuiz.title = 'Apakah kamu yakin ingin keluar?'
            this.modalQuiz.textOne = ''
          } else {
            if (this.webinarQuizData?.quiz_type) {
              this.modalQuiz.title =
                'Maaf, post-test webinar kamu belum selesai'
              this.modalQuiz.textOne =
                'Apakah kamu yakin ingin meninggalkan post-test ini?'
            } else {
              this.modalQuiz.title = 'Maaf, pre-test webinar kamu belum selesai'
              this.modalQuiz.textOne =
                'Apakah kamu yakin ingin meninggalkan pre-test ini?'
            }
          }
        }
        this.showAlertQuiz = true
      } else {
        if (to == '-1') {
          this.$router.go(-1)
        } else {
          this.$router.push(to)
        }
      }
    },
    confirmAlertQuiz() {
      this.showQuiz = false
      this.showPrePost = false
      this.showAlertQuiz = false
      this.showPostTest = false
      if (this.redirect != '') {
        if (this.redirect == 'quiz') {
          this.redirectClassroom()
        } else if (this.redirect == 'pre-test') {
          this.showPrePost = false
          this.showAlertQuiz = false
        } else if (this.redirect == 'webinar-quiz') {
          this.showWebinarQuiz = false
          this.showAlertQuiz = false
        } else {
          if (this.redirect == '-1') {
            this.$router.go(-1)
          } else {
            this.$router.push(this.redirect)
          }
        }
      } else {
        this.openMaterial(this.tempMaterial, this.tempMaterialItem)
      }
    },
    closeAlertQuiz() {
      this.showAlertQuiz = false
    },
    async openMaterial(materials: any, item: any) {
      this.showPostTest = false
      if (this.isDonePreTest) {
        this.redirect = ''
        if (this.showQuiz || this.showPrePost) {
          if (this.showQuiz) {
            this.modalQuiz.title = 'Maaf, kuis kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan kuis ini?'
          } else if (this.testType) {
            this.modalQuiz.title = 'Maaf, post-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan post-test ini?'
          } else {
            this.modalQuiz.title = 'Maaf, pre-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan pre-test ini?'
          }
          this.showAlertQuiz = true
          this.tempMaterial = materials
          this.tempMaterialItem = item
        } else {
          if (item.data.is_done || !this.isPrakerja) {
            this.selectedMaterial = materials
            this.selectedMaterialItem = item
            if (this.selectedMaterialItem) {
              if (item.type == 'video') {
                await this.getOneVideo(this.selectedMaterialItem.data.id)
                this.openVideoControl()
                const file = document.querySelector(
                  '#vplyr'
                ) as HTMLVideoElement
                if (file != null) {
                  file.load()
                }
              } else if (item.type == 'module') {
                if (this.selectedMaterialItem.data.is_done == false) {
                  await ClassroomModel.ViewModul(
                    this.selectedMaterialItem.data.id
                  )
                  await this.refreshMaterials()
                }
              } else if (item.type == 'quiz') {
                await this.getOneQuiz(item.data.id)
              }
            }
          } else {
            const filteredMaterial = this.materials.find((e: any) => !e.is_done)
            this.selectedMaterial = filteredMaterial
            const filteredMaterialItem = filteredMaterial.material.find(
              (e: any) => !e.data.is_done
            )
            if (filteredMaterialItem) {
              if (Object.keys(this.selectedMaterialItem)?.length == 0) {
                this.selectedMaterialItem = filteredMaterialItem
              }
              if (
                this.selectedMaterialItem?.data?.material_ordering + 1 !=
                  filteredMaterialItem.data.material_ordering &&
                this.selectedMaterialItem.data.material_ordering !=
                  item.data.material_ordering
              ) {
                this.modalPackStatusError = true
                if (this.selectedMaterialItem?.type == 'video') {
                  this.imageUrlModal =
                    '/assets/images/modal/must-finished-video-before.svg'
                } else if (this.selectedMaterialItem?.type == 'module') {
                  this.imageUrlModal =
                    '/assets/images/modal/must-finished-module-before.png'
                } else if (this.selectedMaterialItem?.type == 'quiz') {
                  this.imageUrlModal =
                    '/assets/images/modal/must-finished-task-before.svg'
                } else {
                  this.imageUrlModal =
                    '/assets/images/modal/must-finished-video-before.svg'
                }
                this.firstTextModal =
                  'Kamu harus menyelesaikan materi ini dahulu '
                this.secondTextModal = ''
                this.firstButtonModal = 'OK'
              }
              if (
                this.selectedMaterialItem?.data?.material_ordering ==
                filteredMaterialItem.data.material_ordering
              ) {
                const el: any = this.$refs['materi']
                if (el) {
                  el.scrollIntoView({
                    behavior: 'smooth',
                  })
                }
                return
              }
              this.selectedMaterialItem = filteredMaterialItem
              if (this.selectedMaterialItem.type == 'video') {
                await this.getOneVideo(this.selectedMaterialItem.data.id)
                if (this.isPrakerja) {
                  this.closeVideoControl()
                } else {
                  this.openVideoControl()
                }
                const file = document.querySelector(
                  '#vplyr'
                ) as HTMLVideoElement
                if (file != null) {
                  file.load()
                }
              } else if (this.selectedMaterialItem.type == 'module') {
                if (this.selectedMaterialItem.data.is_done == false) {
                  await ClassroomModel.ViewModul(
                    this.selectedMaterialItem.data.id
                  )
                  await this.refreshMaterials()
                }
              } else if (this.selectedMaterialItem.type == 'quiz') {
                await this.getOneQuiz(this.selectedMaterialItem.data.id)
              }
            } else {
              this.selectedMaterialItem = item
              if (this.selectedMaterialItem.type == 'video') {
                await this.getOneVideo(this.selectedMaterialItem.data.id)
                this.openVideoControl()
                const file = document.querySelector(
                  '#vplyr'
                ) as HTMLVideoElement
                if (file != null) {
                  file.load()
                }
              } else if (this.selectedMaterialItem.type == 'quiz') {
                await this.getOneQuiz(this.selectedMaterialItem.data.id)
              }
            }
          }
          const el: any = this.$refs['materi']
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
            })
          }
        }
      } else {
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        this.modalQuiz.title = 'Materi belum bisa dilihat'
        this.modalQuiz.textOne =
          'Kamu harus mengerjakan pre-test terlebih dahulu'
        this.showModalNotDoneQuiz = true
      }
    },
    async onEndVideo() {
      const { success } = await ClassroomModel.ViewSubject(
        this.selectedMaterialItem.data.id
      )
      await this.refreshMaterials()
      if (success) {
        this.modalPackStatusMateri = true
        this.imageUrlModal = '/assets/images/modal/success-watch-video.svg'
        this.firstTextModal = 'Video Berhasil ditonton. '
        this.secondTextModal = 'Tonton materi selanjutnya'
        this.firstButtonModal = 'Lanjut'
      }
    },
    nextMateri() {
      if (
        this.selectedMaterialItem?.data?.material_ordering == this.countMateri
      ) {
        this.modalPackStatusError = true
        this.imageUrlModal = '/assets/images/modal/all-video-watched.svg'
        this.firstTextModal = 'Selamat!'
        this.secondTextModal =
          'Anda telah menyelesaikan semua materi pada kelas ini'
        this.firstButtonModal = 'OK'
        this.modalPackStatusMateri = false
      } else {
        this.modalPackStatusMateri = false
        this.changeMateri(
          this.selectedMaterialItem?.data?.material_ordering,
          'next'
        )
      }
    },

    changeMateri(ordering: number, type: string) {
      let material = null
      let materialItem = null
      if (type == 'next') {
        this.materials.forEach((el: any) => {
          if (el.material.length > 0) {
            el.material.forEach((e: any) => {
              if (e.data.material_ordering == ordering + 1) {
                material = el
                materialItem = e
              }
            })
          }
        })
      } else {
        this.materials.forEach((el: any) => {
          if (el.material.length > 0) {
            el.material.forEach((e: any) => {
              if (e.data.material_ordering == ordering - 1) {
                material = el
                materialItem = e
              }
            })
          }
        })
      }
      this.openMaterial(material, materialItem)
    },

    async refreshMaterials() {
      await ClassroomModel.getMaterials(this.classroomCode)
        .then(res => {
          const orderingMaterials = (res.data as any[]).sort(
            (a, b) => a.ordering - b.ordering
          )
          const find = orderingMaterials.filter(
            (el: any) => el.ordering == this.selectedMaterial.ordering
          )
          if (find) {
            this.selectedMaterial = find[0]
          }

          const tempMaterial = [] as any[]
          orderingMaterials.forEach((el: any) => {
            const findNotDone = el.material.find((e: any) => !e.data?.is_done)
            if (findNotDone) {
              tempMaterial.push({
                ...el,
                is_done: false,
              })
            } else {
              tempMaterial.push({
                ...el,
                is_done: true,
              })
            }
          })

          if (tempMaterial.length) {
            this.materials = tempMaterial
          }
          const isNotDone = this.materials.find((e: any) => !e.is_done)
          if (isNotDone) {
            this.isDoneMateri = false
          } else {
            this.isDoneMateri = true
          }
          this.checkClassroomProgress()
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getMaterialsList() {
      await ClassroomModel.getMaterials(this.classroomCode)
        .then(async res => {
          if (res.data.length > 0) {
            this.isExistMaterial = true
            const el = document.getElementById('play')
            this.isNoAccomplishement = false
            el?.children[0].children[0].children[1].setAttribute(
              'style',
              'pointer-events:none;'
            )
            const orderingMaterials = (res?.data as any[]).sort(
              (a, b) => a.ordering - b.ordering
            )
            let tempCountMateri = 0
            const tempMaterial = [] as any[]
            orderingMaterials.forEach((el: any) => {
              tempCountMateri += el.material.length
              const findNotDone = el.material.find((e: any) => !e.data?.is_done)
              if (findNotDone) {
                tempMaterial.push({
                  ...el,
                  is_done: false,
                })
              } else {
                tempMaterial.push({
                  ...el,
                  is_done: true,
                })
              }
            })
            this.countMateri = tempCountMateri

            if (tempMaterial.length) {
              this.materials = tempMaterial
              if (this.isDonePreTest) {
                if (this.isVideo || this.isModule) {
                  let material = null
                  let materialItem = null
                  this.materials.forEach((el: any) => {
                    if (el.material.length > 0) {
                      el.material.forEach((e: any) => {
                        if (
                          this.isVideo &&
                          e.type == 'video' &&
                          e.data.id == this.isVideo
                        ) {
                          material = el
                          materialItem = e
                        } else if (
                          this.isModule &&
                          e.type == 'module' &&
                          e.data.id == this.isModule
                        ) {
                          material = el
                          materialItem = e
                        }
                      })
                    }
                  })
                  if (material != null && materialItem != null) {
                    this.openMaterial(material, materialItem)
                    return
                  }
                }
                const find = tempMaterial.find(e => !e.is_done)
                if (find) {
                  this.isDoneMateri = false
                  const findItem = find.material.find(
                    (e: any) => !e.data?.is_done
                  )
                  if (findItem) {
                    this.selectedMaterial = find
                    this.selectedMaterialItem = findItem
                  } else {
                    this.selectedMaterial = find
                    this.selectedMaterialItem = find.material[0]
                  }
                } else {
                  if (this.isExistPostTest) {
                    this.openPostTestPage()
                  } else {
                    this.isDoneMateri = true
                    this.selectedMaterial = tempMaterial[0]
                    if (tempMaterial[0]?.material.length) {
                      this.selectedMaterialItem = tempMaterial[0]?.material[0]
                    } else {
                      this.selectedMaterialItem = {}
                    }
                  }
                }

                if (this.selectedMaterialItem?.type == 'video') {
                  await this.getOneVideo(this.selectedMaterialItem.data.id)
                  if (
                    !this.isPrakerja ||
                    this.selectedMaterialItem.data.is_done
                  ) {
                    this.openVideoControl()
                  } else {
                    this.closeVideoControl()
                  }
                  const file = document.querySelector(
                    '#vplyr'
                  ) as HTMLVideoElement
                  if (file != null) {
                    file.load()
                  }
                } else if (this.selectedMaterialItem?.type == 'module') {
                  if (this.selectedMaterialItem.data?.is_done == false) {
                    await ClassroomModel.ViewModul(
                      this.selectedMaterialItem.data.id
                    )
                    this.refreshMaterials()
                  }
                } else if (this.selectedMaterialItem?.type == 'quiz') {
                  await this.getOneQuiz(this.selectedMaterialItem.data.id)
                }
              } else {
                return
              }
            }
          } else {
            this.isExistMaterial = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async init() {
      await this.checkUserPrakerja()
      await this.checkIsExistPreTest()
      await this.getMaterialsList()
      this.checkIsExistPostTest()
      if (this.classroomLevel.classroom?.is_must_webinar) {
        await this.getListWebinar()
        await this.getWebinarRecord()
      }
      if (this.classroomLevel.classroom?.is_must_submission) {
        await this.getTaskList()
      }
      this.checkClassroomProgress()
      this.openTab(this.tab)
    },
    checkClassroomProgress() {
      this.countProgress = 0
      this.countDoneProgress = 0
      this.isVideoDone = true
      this.isModuleDone = true
      this.isQuizDone = true
      this.isWebinarDone = true
      this.isSubmissionDone = true
      this.isExamDone = true
      if (
        this.classroomLevel.certificate != '' ||
        this.classroomLevel.is_level_done
      ) {
        this.countProgress = 1
        this.countDoneProgress = 1
      } else {
        this.materials.forEach((el: any) => {
          if (el.material.length) {
            el.material.forEach((e: any) => {
              if (e.type == 'video') {
                if (this.classroomLevel.classroom.is_must_subject) {
                  if (e.data.is_done) {
                    this.countDoneProgress++
                  } else {
                    this.isVideoDone = false
                  }
                  this.countProgress++
                } else {
                  this.isVideoDone = true
                }
              } else if (e.type == 'module') {
                if (this.classroomLevel.classroom.is_must_module) {
                  if (e.data.is_done) {
                    this.countDoneProgress++
                  } else {
                    this.isModuleDone = false
                  }
                  this.countProgress++
                } else {
                  this.isModuleDone = true
                }
              } else if (e.type == 'quiz') {
                if (e.data.is_exam) {
                  if (this.classroomLevel.classroom.is_must_exam) {
                    if (e.data.is_done) {
                      this.countDoneProgress++
                    } else {
                      this.isExamDone = false
                    }
                    this.countProgress++
                  } else {
                    this.isExamDone = true
                  }
                } else {
                  if (this.classroomLevel.classroom.is_must_quiz) {
                    if (e.data.is_done) {
                      this.countDoneProgress++
                    } else {
                      this.isQuizDone = false
                    }
                    this.countProgress++
                  } else {
                    this.isQuizDone = true
                  }
                }
              }
            })
          }
        })
        if (this.classroomLevel.classroom.is_must_webinar) {
          this.countProgress++
          if (this.classroomLevel.is_webinar_done) {
            this.isWebinarDone = true
            this.countDoneProgress++
          } else {
            if (this.webinarRecord?.length) {
              const viewedWebinarRecord = this.webinarRecord.filter(
                (el: any) => {
                  if (el.is_viewed) {
                    return el
                  }
                }
              ).length
              if (this.webinarRecord?.length == viewedWebinarRecord) {
                this.countDoneProgress++
                this.isWebinarDone = true
              } else {
                this.isWebinarDone = false
              }
              // this.countProgress = this.countProgress + this.webinarRecord.length
              // this.webinarRecord.forEach((el: any) => {
              //   if (el.is_viewed) {
              //     this.countDoneProgress++
              //   }
              // })
            }
          }
        } else {
          this.isWebinarDone = true
        }
        // console.log(this.countProgress)
        if (this.classroomLevel.classroom.is_must_submission) {
          this.countProgress = this.countProgress + this.tasks?.length
          if (this.tasks?.length > 0) {
            this.tasks.forEach((el: any) => {
              if (el.score > 0) {
                this.countDoneProgress++
              } else {
                this.isSubmissionDone = false
              }
            })
          } else {
            this.isSubmissionDone = true
          }
        } else {
          this.isSubmissionDone = true
        }
      }
      // console.log('count progress', this.countProgress)
      // console.log('count progress done', this.countDoneProgress)
    },
    dateFormat(date: string) {
      return moment(date)
        .locale('id')
        .format('DD MMMM YYYY HH:mm')
    },
    countWatchedVideo() {
      const watchedVideo = this.subjects?.filter(e => e.is_viewed === true)
      return watchedVideo?.length
    },
    countWatchedModule() {
      const watchedModule = this.modul?.filter(e => e.is_read === true)
      return watchedModule?.length
    },
    countProgressMateri() {
      let isDoneMateri = 0
      this.materials.forEach((el: any) => {
        if (el.material?.length) {
          el.material.forEach((e: any) => {
            if (e.data.is_done) {
              isDoneMateri++
            }
          })
        }
      })
      return isDoneMateri
    },

    onTaskFile(event: any) {
      if (event.target.files[0]) {
        this.formTask.file = event.target.files[0]
      }
    },

    onChangeSelectTaskType() {
      this.formTask.file = null
      this.errorTaskLinkName = false
    },

    checkFormTaskFileLink() {
      if (this.formTask.file.includes('https://')) {
        this.errorTaskLinkName = false
      } else {
        this.errorTaskLinkName = true
      }
    },

    submitUploadTask() {
      this.showUploadProgress = true

      const formData = new FormData()
      formData.append('file', this.formTask.file)
      if (this.formTask.note) {
        formData.append('note', this.formTask.note)
      }

      const token = Cookies.getJSON('auth')

      axios
        .post(
          'https://api.sekolahdesain.id/classroom/private/api/v1/classroom/task/' +
            this.selectedTask.id +
            '/submit',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token.token}`,
            },
            onUploadProgress: (progressEvent: any) => {
              this.uploadPercentage = Number(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              )
            },
          }
        )
        .then(async () => {
          this.showUploadProgress = false
          this.formTask.note = ''
          this.formTask.file = null
          this.typeFile = 'berkas'
          this.toast.success('Berhasil upload tugas')
          await this.getTaskList()
          const findTask = this.tasks.find(
            (el: any) => el.id == this.selectedTask.id
          )
          this.selectedTask = findTask
        })
        .catch(() => {
          this.toast.error('Gagal upload tugas')
        })
    },

    async getClassRoomLevelDetail(classroomLevelCode: string) {
      try {
        await this.$store
          .dispatch('classroomStore/fetchDetailClassroom', classroomLevelCode)
          .then(() => {
            const {
              'classroomStore/getLoadingDetailClassroom': getLoadingDetailClassroom,
              'classroomStore/getDetailClassroom': getDetailClassroom,
            } = this.$store.getters
            this.classroomLevel = getDetailClassroom
            if (this.classroomLevel?.forum.length < 6 && this.classroomLevel?.whatsapp_link.length < 6) {
              this.isExistForum = false
            }
            if (this.classroomLevel.is_locked) {
              this.isAutoPlay = false
            }
            // this.isLoading = getLoadingDetailClassroom
            // if(!this.isExistMaterial) {
            //   this.showVideoControl()
            // }
            this.showCountdown()
          })
      } catch (error) {
        const err: any = error
        console.log(err.response.data.errors[0])
        if (err.response.data.errors[0].message == 'Level belum dibeli') {
          window.location.assign('/classroom/' + this.classroomCode)
        } else if (err.response.data.errors[0].message == 'record not found') {
          window.location.assign('/')
        } else {
          window.location.reload()
        }
      }
    },

    async checkUserPrakerja() {
      const { data } = await VoucherModel.isUserPrakerja(this.classroomCode)
      if (data.is_prakerja) {
        this.isPrakerja = true
      }
      // console.log('prakerja', this.isPrakerja)
    },

    async checkIsExistPreTest() {
      await ClassroomModel.getPreTest(this.classroomCode)
        .then(res => {
          this.isExistPreTest = true
          if (res.data.is_done == false) {
            this.testType = 0
            this.prePostTestData = res.data
            this.isDonePreTest = false
            this.isAutoPlay = false
            this.payloadQuiz.item_ids = []
            this.payloadQuiz.answers = []
            this.questionIndex = 0
            for (let i = 0; i < res.data?.items?.length; i++) {
              this.payloadQuiz.item_ids.push(this.prePostTestData.items[i].id)
              this.payloadQuiz.answers.push(null)
            }
          }
        })
        .catch(err => {
          if (
            err.response.data.errors[0].message == 'Sudah mengerjakan Pre Test'
          ) {
            this.isDonePreTest = true
            this.isExistPreTest = true
          }
          if (err.response.data.errors[0].message == 'Kelas belum dibeli') {
            this.$router.push('/classroom/' + this.classroomCode)
          }
        })
    },

    openModalPreTest() {
      if (this.isDonePreTest) {
        this.showModalNotDoneQuiz = true
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-completed.svg'
        this.modalQuiz.title = 'Pre-test sudah dikerjakan'
        this.modalQuiz.textOne = 'Kamu sudah mengerjakan pre-test'
      } else {
        this.showModalStartPreTest = true
      }
    },

    openPreTest() {
      this.showModalStartPreTest = false
      this.showModalStartPostTest = false
      this.showPrePost = true
    },

    closeModalStartPrePostTest() {
      this.showModalStartPreTest = false
      this.showModalStartPostTest = false
    },

    async checkIsExistPostTest() {
      await ClassroomModel.getPostTest(this.classroomCode)
        .then(res => {
          if (res.success) {
            this.postTestClass = res.data
            this.isExistPostTest = true
            if (res.data.is_done == false) {
              this.isDonePostTest = false
            }
            if (res.data.is_attempt) {
              this.isAttemptPostTest = true
            }
          }
        })
        .catch(err => {
          if (
            err.response.data.errors[0].message ==
            'Harap kerjakan Pre Test terlebih dahulu'
          ) {
            this.isDonePreTest = false
            this.isDonePostTest = false
            this.isExistPostTest = true
          }
          if (
            err.response.data.errors[0].message ==
            'Tidak Ada Post Test'
          ) {
            this.isExistPostTest = false
            this.isDonePostTest = true
          }
          // console.error(err)
        })
    },

    openModalPostTest() {
      if (
        this.classroomLevel.certificate != '' &&
        this.classroomLevel.is_level_done
      ) {
        this.payloadQuiz.item_ids = []
        this.payloadQuiz.answers = []
        this.questionIndex = 0
        for (let i = 0; i < this.postTestClass?.items?.length; i++) {
          this.payloadQuiz.item_ids.push(this.postTestClass.items[i].id)
          this.payloadQuiz.answers.push(null)
        }
        this.showModalStartPostTest = true
        this.modalQuiz.textTwo =
          'Nilai kelulusan: ' + this.postTestClass?.min_score
      } else {
        this.checkClassroomProgress()
        if (
          this.isVideoDone &&
          this.isModuleDone &&
          this.isQuizDone &&
          this.isWebinarDone &&
          this.isSubmissionDone &&
          this.isExamDone
        ) {
          this.payloadQuiz.item_ids = []
          this.payloadQuiz.answers = []
          this.questionIndex = 0
          for (let i = 0; i < this.postTestClass?.items?.length; i++) {
            this.payloadQuiz.item_ids.push(this.postTestClass.items[i].id)
            this.payloadQuiz.answers.push(null)
          }
          this.showModalStartPostTest = true
          this.modalQuiz.textTwo =
            'Nilai kelulusan: ' + this.postTestClass?.min_score
        } else {
          this.modalQuiz.imageUrl =
            '/assets/images/modal/illustration-test-not-completed.svg'
          this.modalQuiz.title = 'Post-test belum bisa dikerjakan'
          let text = 'Kamu harus menyelesaikan '
          if (this.isExistPreTest && !this.isDonePreTest) {
            text = text + ' Pre-Test,'
          }
          if (!this.isVideoDone) {
            text = text + ' Video,'
          }
          if (!this.isModuleDone) {
            text = text + ' Modul,'
          }
          if (!this.isQuizDone) {
            text = text + ' Kuis,'
          }
          if (!this.isExamDone) {
            text = text + ' Ujian,'
          }
          if (!this.isWebinarDone) {
            text = text + ' Webinar,'
          }
          if (!this.isSubmissionDone) {
            text = text + ' Tugas,'
          }
          text = text.slice(0, -1)
          this.modalQuiz.textOne = text + ' terlebih dahulu'
          this.showModalNotDoneQuiz = true
        }
      }
    },

    openPostTestPage() {
      if (!this.isDonePreTest) {
        this.modalQuiz.imageUrl =
          '/assets/images/modal/illustration-test-not-completed.svg'
        this.modalQuiz.title = 'Post-test belum bisa dikerjakan'
        this.modalQuiz.textOne =
          'Kamu harus mengerjakan pre-test dan materi terlebih dahulu'
        this.showModalNotDoneQuiz = true
      } else {
        this.showPostTest = true
        this.selectedMaterial = {}
        // this.selectedMaterialItem = {}
      }
    },

    openLastMaterial() {
      let material = this.materials[this.materials?.length - 1]
      let materialItem = material.material[material.material?.length - 1]
      this.openMaterial(material, materialItem)
    },

    openPostTest() {
      this.showModalStartPostTest = false
      this.testType = 1
      this.prePostTestData = this.postTestClass
      this.showPrePost = true
    },

    showVideoControl() {
      const el = document.getElementById('play')
      if (
        this.classroomLevel.classroom?.is_must_subject ||
        this.classroomLevel.classroom?.is_must_module ||
        this.classroomLevel.classroom?.is_must_quiz ||
        this.classroomLevel.classroom?.is_must_webinar ||
        this.classroomLevel.classroom?.is_must_webinar_record ||
        this.classroomLevel.classroom?.is_must_exam
      ) {
        this.isNoAccomplishement = false
        el?.children[0].children[0].children[1].setAttribute(
          'style',
          'pointer-events:none;'
        )
      } else {
        this.isNoAccomplishement = true
      }
    },

    openVideoControl() {
      const el = document.getElementById('play')
      el?.children[0].children[0].children[1].removeAttribute('style')
      this.options.keyboard.focused = true
      this.options.keyboard.global = true
      this.options.disableContextMenu = true
    },

    closeVideoControl() {
      const el = document.getElementById('play')
      el?.children[0].children[0].children[1].setAttribute(
        'style',
        'pointer-events:none;'
      )
      this.options.keyboard.focused = false
      this.options.keyboard.global = false
      this.options.disableContextMenu = false
    },

    showCountdown() {
      if (this.isCountdown === 'false') {
        this.isProcessed = true
        this.isStartedYet = true
        this.isDonePreTest = true
      } else {
        const startedAt = this.classroomLevel?.classroom?.started_at
        if (startedAt) {
          const now = new Date()
          const end = new Date(startedAt)
          const distance = end.getTime() - now.getTime()
          if (distance < 0) {
            this.isProcessed = true
            this.isStartedYet = true
          } else {
            this.isAutoPlay = false
            this.isProcessed = true
            const timer = setInterval(() => {
              const now = new Date()
              const end = new Date(startedAt)
              const distance = end.getTime() - now.getTime()
              if (distance < 0) {
                clearInterval(timer)
                this.isStartedYet = true
                return
              }
              this.isAutoPlay = false
              const days = Math.floor(distance / this._days)
              const hours = Math.floor((distance % this._days) / this._hours)
              const minutes = Math.floor(
                (distance % this._hours) / this._minutes
              )
              const seconds = Math.floor(
                (distance % this._minutes) / this._seconds
              )
              if (days <= 0) {
                this.distanceDay = false
                this.displaySeconds = seconds < 10 ? 0 + seconds : seconds
              } else {
                this.distanceDay = true
                this.displayDays = days < 10 ? 0 + days : days
              }
              this.displayMinutes = minutes < 10 ? 0 + minutes : minutes
              this.displayHours = hours < 10 ? 0 + hours : hours
            }, 1000)
          }
        } else {
          this.isProcessed = true
          this.isStartedYet = true
        }
      }
    },

    async getTaskList() {
      const { data } = await ClassroomModel.getTaskClassroom(
        this.classroomLevelCode
      )

      this.tasks = data
      // console.log('daftar tugas', this.tasks)
    },

    closeAlertTab() {
      this.showAlertTab = false
    },

    changeTab() {
      this.showPrePost = false
      this.showQuiz = false
      this.showWebinarQuiz = false
      this.openTab(this.tempTab)
    },

    async openTab(tab: String) {
      this.isLoading = false
      if (!this.isDonePreTest && tab != 'materi') {
        this.$router.push('/classroom/' + this.classroomCode + '/activity')
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Akses Dibatasi'
        this.modalAlert.description =
          'Kerjakan Pre-Test dahulu untuk bisa mengakses materi yang ada, Semangat!'
        this.tab = 'materi'
        return
      }
      if (this.showPrePost || this.showQuiz || this.showWebinarQuiz) {
        this.tempTab = tab
        if (this.showQuiz) {
          this.modalQuiz.title = 'Maaf, kuis kamu belum selesai'
          this.modalQuiz.textOne =
            'Apakah kamu yakin ingin meninggalkan kuis ini?'
        } else if (this.showPrePost) {
          if (this.testType) {
            this.modalQuiz.title = 'Maaf, post-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan post-test ini?'
          } else {
            this.modalQuiz.title = 'Maaf, pre-test kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan pre-test ini?'
          }
        } else if (this.showWebinarQuiz) {
          if (this.webinarQuizData?.quiz_type) {
            this.modalQuiz.title = 'Maaf, post-test webinar kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan post-test webinar ini?'
          } else {
            this.modalQuiz.title = 'Maaf, pre-test webinar kamu belum selesai'
            this.modalQuiz.textOne =
              'Apakah kamu yakin ingin meninggalkan pre-test webinar ini?'
          }
        }
        this.showAlertTab = true
      } else {
        if (tab !== 'materi') {
          const file = document.querySelector('#vplyr') as HTMLVideoElement
          if (file != null) {
            file.pause()
          }
        }
        this.showAlertTab = false
        this.isLoadingWebinar = true
        this.isLoadingMaterial = true
        this.tab = tab
        // Refactor, if data of tab info empty then call vuex action
        if (
          tab === 'webinar' &&
          this.classroomLevel.classroom.must_webinar_tab
        ) {
          this.$router.push(
            '/classroom/' + this.classroomCode + '/activity?tab=webinar'
          )
          if (this.webinarRecord?.length == 0) {
            this.getWebinarRecord()
          }
          await this.getWebinarQuiz()
          const {
            'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
          } = this.$store.getters as any

          if (getClassroomWebinarData?.length == 0) {
            this.getListWebinar()
          }
        } else if (
          tab === 'task' &&
          this.classroomLevel.classroom.must_submission_tab
        ) {
          this.$router.push(
            '/classroom/' + this.classroomCode + '/activity?tab=task'
          )
          if (this.tasks?.length == 0) {
            this.getTaskList()
          }
        } else if (tab === 'ask-mentor') {
          this.$router.push(
            '/classroom/' + this.classroomCode + '/activity?tab=ask-mentor'
          )
          if (this.listUserQuestion?.length == 0) {
            this.getClassroomQuestion()
          }
        } else if (
          tab === 'forum' &&
          this.isExistForum
        ) {
          this.$router.push(
            '/classroom/' + this.classroomCode + '/activity?tab=forum'
          )
        } else if (
          tab === 'konsultasi-desain' &&
          this.classroomLevel.classroom.is_webinar_private
        ) {
          this.$router.push(
            '/classroom/' + this.classroomCode + '/activity?tab=konsultasi-desain'
          )
          this.getPrivateWebinar()
        } else {
          if (
            this.classroomLevel?.classroom?.must_subject_tab ||
            (this.classroomLevel?.classroom?.must_module_tab &&
              this.classroomLevel?.classroom?.must_quizzes_tab)
          ) {
            this.tab = 'materi'
            this.$router.push('/classroom/' + this.classroomCode + '/activity')
            if (this.materials?.length == 0) {
              this.getMaterialsList()
            }
          } else {
            this.tab = 'forum'
            this.$router.push(
              '/classroom/' + this.classroomCode + '/activity?tab=forum'
            )
          }
        }
      }
    },

    async getClassroomQuestion() {
      this.loadingUserQuestion = true
      await ClassroomModel.listQuestion(this.classroomCode)
        .then(res => {
          this.loadingUserQuestion = false
          this.listUserQuestion = res.data.reverse()
        })
        .catch(err => {
          this.loadingUserQuestion = false
          console.log(err)
        })
    },

    openModalAskMentor() {
      this.showModalAskMentor = true
    },

    closeModalAskMentor() {
      this.showModalAskMentor = false
    },

    async submitQuestion() {
      this.loadingSubmitQuestion = true
      let formData = new FormData()
      formData.append('question', this.formQuestion.question)
      if (this.formQuestion.file) {
        formData.append('file', this.formQuestion.file)
      }
      await ClassroomModel.addQuestion(this.classroomCode, formData)
        .then(res => {
          this.loadingSubmitQuestion = false
          if (res.success) {
            this.showModalAskMentor = false
            this.formQuestion.file = ''
            this.formQuestion.question = ''
            const el = this.$refs.questionFile
            if (el) {
              ;(this.$refs.questionFile as any).value = null
            }
            this.toast.success('Pertanyaan berhasil diajukan')
            this.getClassroomQuestion()
          } else {
            this.toast.error('Silahkan coba kembali')
          }
        })
        .catch(err => {
          const error: any = err.response.data.errors[0].message
          this.toast.error(error)
          this.loadingSubmitQuestion = false
        })
    },
    async getQuiz() {
      try {
        const { data } = await ClassroomModel.listQuiz(this.classroomLevelCode)
        this.isLoadingQuiz = false
        const isExamExist = data.some(el => el.is_exam == true)
        if (isExamExist) {
          this.quiz = (data as Quiz[]).sort((a, b) =>
            a.is_exam === b.is_exam ? 0 : a.is_exam ? 1 : -1
          )
        } else {
          this.quiz = data
        }
        const isDoneQuiz = data.filter(el => {
          if (el.is_exam == false && el.is_done == false) {
            return el
          }
        })
        if (isExamExist) {
          if (isDoneQuiz?.length > 0) {
            this.isDoneQuiz = false
          } else {
            this.isDoneQuiz = true
          }
        } else {
          this.isDoneQuiz = true
        }
      } catch (error) {
        this.isLoadingQuiz = false
      }
    },
    async getListWebinar() {
      try {
        this.$store
          .dispatch(
            'classroomStore/fetchClassroomWebinar',
            this.classroomLevelCode
          )
          .then(() => {
            const {
              'classroomStore/getLoadingClassroomWebinarData': getLoadingClassroomWebinarData,
            } = this.$store.getters
            this.isLoadingWebinar = getLoadingClassroomWebinarData
            const {
              'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
            } = this.$store.getters as any
            if (getClassroomWebinarData?.length > 0) {
              this.listRequestWebinarPlus = getClassroomWebinarData.filter(
                (el: any) => {
                  if (
                    el.can_request_plus &&
                    this.timeZone(el.request_plus_started_at) <= this.dateNow &&
                    this.timeZone(el.request_plus_expired_at) >= this.dateNow
                  ) {
                    return el
                  }
                }
              )
            }
            if (this.countWebinarOnGoing > 0) {
              this.changeFilterWebinar('ongoing')
            } else {
              this.changeFilterWebinar(this.filterWebinar)
            }
          })
      } catch (error) {
        this.isLoadingWebinar = false
      }
    },
    async getWebinarRecord() {
      // const { data } = await ClassroomModel.detailClassroomLevel(classroomCode)
      // this.levelData = data
      this.levelData = await this.$store.getters[
        'classroomStore/getDetailClassroom'
      ]
      if (!this.levelData.id) {
        const { data } = await ClassroomModel.detailClassroomLevel(
          this.classroomLevelCode
        )
        this.levelData = data
      }
      try {
        await this.$store
          .dispatch(
            'classroomStore/fetchClassroomWebinarRecord',
            this.levelData.id
          )
          .then(() => {
            const {
              'classroomStore/getLoadingClassroomWebinarRecordData': getLoadingClassroomWebinarRecordData,
              'classroomStore/getClassroomWebinarRecordData': getClassroomWebinarRecordData,
            } = this.$store.getters
            this.isLoadingWebinarRecord = getLoadingClassroomWebinarRecordData
            this.webinarRecord = []
            if (getClassroomWebinarRecordData) {
              getClassroomWebinarRecordData.forEach((el: any, i: number) => {
                if (el.link.includes('iframe')) {
                  this.webinarRecord.push({
                    ...el,
                    type: 'Youtube',
                  })
                } else {
                  this.webinarRecord.push({
                    ...el,
                    type: 'Zoom',
                  })
                }
              })
            }
          })
      } catch (error) {
        this.isLoadingWebinarRecord = false
      }
    },
    // reRender() {
    //   this.init()
    // },
    async onClickWebinar(id: number, startedDate: any, expiredDate: any) {
      const start = this.timeZone(startedDate)
      const end = this.timeZone(expiredDate)
      const exist = this.preTest?.filter((x: any) => x.webinar_id == id)
      if (exist?.length > 0) {
        if (exist[0].is_done === false) {
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description =
            'Kamu harus menyelesaikan Pre-Test Webinar dahulu'
          return
        }
      }
      if (this.getDateNow() < start) {
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Gagal'
        this.modalAlert.description = 'Webinar belum mulai'
        return
      }
      if (this.getDateNow() > end) {
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Gagal'
        this.modalAlert.description = 'Webinar telah berakhir'
        return
      }

      const { data, success } = await ClassroomModel.joinWebinar(id)
      if (success) {
        window.location.assign(data.redirection)
        this.init()
      }
    },
    getDateNow() {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    },
    onClickPreTest(data: any) {
      this.webinarQuiz = data
      const startedDate = this.timeZone(data.started_at)
      const endedDate = this.timeZone(data.ended_at)
      if (data?.is_done) {
        this.showAlert = true
        this.modalAlert.status = 'success'
        this.modalAlert.title = 'Berhasil'
        this.modalAlert.description = 'Kamu sudah mengerjakan Pre-Test Webinar'
        return
      }
      if (
        data.started_at == '0001-01-01 00:00:00' ||
        data.started_at == '' ||
        data.started_at == null
      ) {
        this.textModalWebinarQuiz =
          'Pre-test Webinar ini hanya dapat dikerjakan satu kali. Semua soal dalam pre-test akan dibahas oleh mentor dalam webinar.'
        this.modalWebinarQuiz = true
        return
      } else {
        if (startedDate > this.getDateNow()) {
          const formatDate = moment(startedDate)
            .locale('id')
            .format('DD MMMM YYYY HH:mm')

          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description =
            'Pre-Test Webinar baru bisa diakses: ' + formatDate + ' WIB'
          return
        } else if (endedDate < this.getDateNow()) {
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = 'Waktu Pre-Test Webinar telah berakhir'
          return
        } else {
          this.textModalWebinarQuiz =
            'Pre-test Webinar ini hanya dapat dikerjakan satu kali. Semua soal dalam pre-test akan dibahas oleh mentor dalam webinar.'
          this.modalWebinarQuiz = true
          return
        }
      }
    },
    async onClickPostTest(data: any) {
      this.webinarQuiz = data
      const startedDate = this.timeZone(data.started_at)
      const endedDate = this.timeZone(data.ended_at)
      if (data?.is_done) {
        this.showAlert = true
        this.modalAlert.status = 'success'
        this.modalAlert.title = 'Berhasil'
        this.modalAlert.description = 'Kamu sudah mengerjakan Post-Test Webinar'
        return
      }
      if (this.preTest?.length > 0) {
        const exist = this.preTest?.filter(
          (x: any) => x.webinar_id == data.webinar_id
        )
        if (exist?.length > 0) {
          if (exist[0].is_done === false) {
            this.showAlert = true
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description =
              'Kamu harus menyelesaikan Pre-Test Webinar dahulu'
            return
          }
        } else {
          if (startedDate > this.getDateNow()) {
            const formatDate = moment(startedDate)
              .locale('id')
              .format('DD MMMM YYYY HH:mm')
            this.showAlert = true
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description =
              'Post-Test Webinar baru bisa diakses: ' + formatDate + ' WIB'
            return
          } else if (endedDate < this.getDateNow()) {
            this.showAlert = true
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description =
              'Waktu Post-Test Webinar telah berakhir'
            return
          }
          // else {
          // this.$router.push(
          //   `/classroom/${this.classroomCode}/post-test/${data.id}`
          // )
          // }

          // if (this.classroomLevel?.is_webinar_done) {
          // } else {
          //   this.showAlert = true
          //   this.modalAlert.status = 'error'
          //   this.modalAlert.title = 'Gagal'
          //   this.modalAlert.description = 'Kamu harus mengikuti webinar dahulu'
          //   return
          // }
        }
      }
      this.payloadWebinarQuiz.item_ids = []
      this.payloadWebinarQuiz.answers = []
      this.isDoneWebinarQuiz = false
      this.questionIndex = 0
      await WebinarQuizModel.getWebinarQuizV2(this.webinarQuiz.id).then(res => {
        this.webinarQuizData = res.data
        for (let i = 0; i < this.webinarQuizData?.items?.length; i++) {
          this.payloadWebinarQuiz.item_ids.push(
            this.webinarQuizData.items[i].id
          )
          this.payloadWebinarQuiz.answers.push(null)
        }
        this.showWebinarQuiz = true
      })
    },
    async showWebinarPreTest() {
      this.payloadWebinarQuiz.item_ids = []
      this.payloadWebinarQuiz.answers = []
      this.isDoneWebinarQuiz = false
      this.questionIndex = 0
      const { data } = await WebinarQuizModel.getWebinarQuizV2(
        this.webinarQuiz.id
      )
      this.webinarQuizData = data
      for (let i = 0; i < this.webinarQuizData?.items?.length; i++) {
        this.payloadWebinarQuiz.item_ids.push(this.webinarQuizData.items[i].id)
        this.payloadWebinarQuiz.answers.push(null)
      }
      this.showWebinarQuiz = true
      this.modalWebinarQuiz = false
    },
    hideModalWebinarQuiz() {
      this.modalWebinarQuiz = false
      this.webinarQuiz = {} as WebinarQuiz
    },
    formatDuration(duration: string) {
      return formatDuration(duration)
    },

    settingQuality(data: any) {
      if (data?.resolutions?.length > 0) {
        this.isExistResolution = true
        // const quality = [] as any
        // data.resolutions.forEach((el: any) => {
        //   const res = parseInt(el.resolution)
        //   quality.push(res)
        // })
        // this.options.quality.default = quality[0]
        // this.options.quality.options = [360, 480, 720, 1080]
        // this.options.settings = ['quality']
        const el = document.getElementById('play')
        el?.children[0].children[0].children[4].removeAttribute('style')
      } else {
        this.isExistResolution = false
        // this.options.quality.options = []
        // this.options.settings = []
        const el = document.getElementById('play')
        el?.children[0].children[0].children[4].setAttribute(
          'style',
          'display:none!important'
        )
      }
      // console.log(this.options)
    },

    hideModalPack() {
      // console.log('close')
      this.modalPackStatusError = false
    },

    async getWebinarQuiz() {
      const { data, success } = await ClassroomModel.listWebinarQuiz(
        this.classroomLevelCode
      )
      if (success) {
        const get = data.filter(
          (el: any) => el.quiz_type === 0 && el.is_done === true
        )
        this.preTest = data
          .sort((a, b) => a.ordering - b.ordering)
          .filter((el: any) => el.quiz_type === 0)
        // this.postTest = data.filter((el: any) => el.quiz_type === 1)

        this.postTest = data
          .sort((a, b) => a.ordering - b.ordering)
          .filter((el: any) => el.quiz_type === 1)
        // console.log('pre test', this.preTest)
        // console.log('post test', this.postTest)
      }
    },
    timeZone(date: string) {
      const dt = new Date(date)
      const offset = new Date().getTimezoneOffset()
      const timeZoneOffset = offset / 60

      switch (timeZoneOffset) {
        case -8:
          dt.setHours(dt.getHours() + 1)
          break
        case -9:
          dt.setHours(dt.getHours() + 2)
          break
        default:
          break
      }
      return moment(dt).format('YYYY-MM-DD HH:mm:ss')
    },

    onClickRequestWebinarPlus(
      id: number,
      start: string,
      end: string,
      classroom: string
    ) {
      this.payloadRequestWebinarPlus.classroom = classroom
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      if (this.timeZone(start) <= now && this.timeZone(end) >= now) {
        this.payloadRequestWebinarPlus.id = id
        this.modalRequestWebinarPlus = true
      } else {
        const startedAt = moment(start)
          .locale('id')
          .format('DD MMMM YYYY HH:mm')
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Forbidden'
        this.modalAlert.description =
          'Pengajuan Webinar Plus bisa diakses pada ' + startedAt
      }
    },

    showWebinarPlusModal() {
      this.modalRequestWebinarPlus = true
    },

    closeWebinarPlusModal() {
      this.modalRequestWebinarPlus = false
      this.payloadRequestWebinarPlus.id = 0
      this.payloadRequestWebinarPlus.reason = ''
      // this.showWebinarPlusReason = false
    },

    // nextWebinarPlusModal() {
    //   this.showWebinarPlusReason = true
    // },

    async submitRequestWebinarPlus() {
      const payload = {
        reason: this.payloadRequestWebinarPlus.reason,
      }
      await ClassroomModel.requestWebinarPlusUser(
        this.payloadRequestWebinarPlus.id,
        payload
      )
        .then(res => {
          this.showAlert = true
          if (res.success) {
            this.closeWebinarPlusModal()
            this.modalAlert.status = 'success'
            this.modalAlert.title = 'Berhasil'
            this.modalAlert.description =
              'Anda berhasil mengirim Request Webinar Plus'
          } else {
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description = 'Terjadi Kesalahan'
          }
        })
        .catch(err => {
          this.closeWebinarPlusModal()
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = err.response.data.errors[0].message
        })
    },

    checkTask(start: any) {
      const now = new Date()
      const startAt = new Date(start)
      if (now.getTime() >= startAt.getTime()) {
        return false
      } else {
        return true
      }
    },

    moreQuestion() {
      this.isExpandQuestion = !this.isExpandQuestion
    },

    downloadLink(pdf: string) {
      axios
        .get(pdf, {
          responseType: 'blob',
          headers: {
            'Content-type': 'application/pdf',
          },
        })
        .then(response => {
          const blob = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = blob
          const filename = pdf.substring(pdf.lastIndexOf('/') + 1)
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(() => {
          window.open(pdf, '_blank')
        })
    },

    openModalReview() {
      if (
        this.classroomLevel.certificate != '' &&
        this.classroomLevel.is_level_done &&
        this.isDonePostTest
      ) {
        if (this.classroomLevel.rating > 3) {
          this.isAlreadyRated = true
        } else {
          this.isAlreadyRated = false
        }
        this.formReview.rating = this.classroomLevel.rating
        this.tempRating = this.classroomLevel.rating
        this.formReview.content = this.classroomLevel.content
        if (this.classroomLevel.image_rating) {
          this.updatedImageRating = this.classroomLevel.image_rating
        }
        this.previewImageRating = null
        this.showReview = true
      } else {
        this.checkClassroomProgress()
        if (
          this.isVideoDone &&
          this.isModuleDone &&
          this.isQuizDone &&
          this.isWebinarDone &&
          this.isSubmissionDone &&
          this.isExamDone &&
          !this.classroomLevel?.is_locked &&
          this.isStartedYet &&
          this.isDonePostTest
        ) {
          if (this.classroomLevel.rating > 3) {
            this.isAlreadyRated = true
          } else {
            this.isAlreadyRated = false
          }
          this.formReview.rating = this.classroomLevel.rating
          this.tempRating = this.classroomLevel.rating
          this.formReview.content = this.classroomLevel.content
          if (this.classroomLevel.image_rating) {
            this.updatedImageRating = this.classroomLevel.image_rating
          }
          this.showReview = true
        } else {
          this.showModalNotDoneQuiz = true
          this.modalQuiz.imageUrl =
            '/assets/images/modal/illustration-attention.svg'
          this.modalQuiz.title = 'Kelas Belum Selesai'
          let text = 'Yuk selesikan '
          if (this.isExistPreTest && !this.isDonePreTest) {
            text = text + ' Pre-Test,'
          }
          if (!this.isVideoDone) {
            text = text + ' Video,'
          }
          if (!this.isModuleDone) {
            text = text + ' Modul,'
          }
          if (!this.isQuizDone) {
            text = text + ' Kuis,'
          }
          if (!this.isExamDone) {
            text = text + ' Ujian,'
          }
          if (!this.isWebinarDone) {
            text = text + ' Webinar,'
          }
          if (!this.isSubmissionDone) {
            text = text + ' Tugas,'
          }
          if (this.isExistPostTest && !this.isDonePostTest) {
            text = text + ' Post-Test,'
          }
          text = text.slice(0, -1)
          this.modalQuiz.textOne = text + ' dulu ya, Semangat!'
        }
      }
    },

    closeModalReview() {
      if (!this.loadingReview) {
        this.showReview = false
      }
    },

    async submitReview() {
      this.loadingReview = true
      await ClassroomModel.GiveReviewClassroomLevelV2(
        this.classroomLevelCode,
        this.formReview
      )
        .then(res => {
          this.loadingReview = false
          if (res.success) {
            this.toast.success('Review berhasil terkirim')
            this.getClassRoomLevelDetail(this.classroomLevelCode)
            this.showReview = false
          } else {
            this.toast.error('Terjadi Kesalahan, silahkan coba kembali.')
          }
        })
        .catch(err => {
          this.loadingReview = false
          this.toast.error('Review gagal terkirim')
          console.error(err)
        })
    },

    toggleWebinar() {
      this.showWebinarList = !this.showWebinarList
    },

    changeFilterWebinar(filter: string) {
      if (!this.showWebinarQuiz) {
        this.showWebinar = true
        this.showWebinarList = true
        this.showWebinarRecord = false
        this.showWebinarRecordList = false
        this.filterWebinar = filter
        this.selectedWebinarRecord = null
        const {
          'classroomStore/getClassroomWebinarData': getClassroomWebinarData,
        } = this.$store.getters as any
        const dateNow = moment().format('YYYY-MM-DD HH:mm:ss')
        if (getClassroomWebinarData?.length > 0) {
          this.listWebinar = getClassroomWebinarData.filter((el: any) => {
            if (filter == 'done') {
              if (this.timeZone(el.expired_at) < dateNow) {
                return el
              }
            } else if (filter == 'ongoing') {
              if (
                this.timeZone(el.started_at) <= dateNow &&
                this.timeZone(el.expired_at) >= dateNow
              ) {
                return el
              }
            } else {
              if (this.timeZone(el.started_at) > dateNow) {
                return el
              }
            }
          })
        }
      }
    },

    toggleWebinarRecord() {
      this.showWebinarRecordList = !this.showWebinarRecordList
    },

    checkRegexIframe(link: string) {
      if (link.includes('<iframe')) {
        return true
      } else {
        return false
      }
    },

    async openWebinarRecord(record: any) {
      if (record.is_viewed == false) {
        if (!this.getProfileData) {
          await this.getProfile()
        }
        await ClassroomModel.viewWebinarRecord(
          record.id,
          this.getProfileData.uuid
        )
        await this.getWebinarRecord()
        this.checkClassroomProgress()
      }
      this.showWebinar = false
      this.showWebinarList = false
      this.showWebinarRecord = true
      this.showWebinarRecordList = true
      this.selectedWebinarRecord = record
      if (this.selectedWebinarRecord?.link?.includes('iframe')) {
        var parser: any = new DOMParser()
        var parsedIframe = parser.parseFromString(
          this.selectedWebinarRecord?.link,
          'text/html'
        )
        let iFrame = parsedIframe.getElementsByTagName('iframe')
        this.selectedWebinarRecord.url = iFrame[0].src
      }
    },

    webinarTimeFormatted(start: string, end: string) {
      const startDate = moment(start)
        .locale('id')
        .format('DD MMMM YYYY HH:mm')
      const endDate = moment(end)
        .locale('id')
        .format('HH:mm')
      return startDate + ' - ' + endDate + ' WIB'
    },

    copyPasswordWebinar() {
      const password = this.$refs.password as HTMLInputElement
      try {
        password.setAttribute('type', 'text')
        password.select()
        document.execCommand('copy')
        this.toast.success('Berhasil disalin')
      } catch (err) {
        this.toast.error('Oops, unable to copy')
      }
      password.setAttribute('type', 'hidden')
    },

    closeShowAlert() {
      this.showAlert = false
    },

    roundingScore(score: number) {
      return Math.round(score)
    },

    openTask(task: any) {
      this.selectedTask = task
      if (task.file != '') {
        if (task.note == '') {
          this.formTask.note = '<tidak memberikan keterangan>'
        } else {
          this.formTask.note = task.note
        }
      }
      this.showModalTask = true
    },

    closeTask() {
      this.selectedTask = {}
      this.showModalTask = false
    },

    openModalTaskScore() {
      this.showTaskScore = true
    },

    closeModalTaskScore() {
      this.showTaskScore = false
    },

    removeTaskFile() {
      this.formTask.file = ''
    },
    dragoverTask(event: any) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-[#E8EDFF]')) {
        event.currentTarget.classList.remove('bg-[#FFFFFF]')
        event.currentTarget.classList.add('bg-[#E8EDFF]')
      }
    },
    dragleaveTask(event: any) {
      // Clean up
      event.currentTarget.classList.add('bg-[#FFFFFF]')
      event.currentTarget.classList.remove('bg-[#E8EDFF]')
    },
    dropTask(event: any) {
      event.preventDefault()
      ;(this.$refs.taskFile as any).files = event.dataTransfer.files
      this.formTask.file = event.dataTransfer.files[0]
      // Clean up
      event.currentTarget.classList.add('bg-[#FFFFFF]')
      event.currentTarget.classList.remove('bg-[#E8EDFF]')
    },

    async openModalAddQuota() {
      if (!this.listQuotaPrice?.price) {
        await TransactionModel.getQuotaPrice()
          .then(res => {
            this.listQuotaPrice = res.data
          })
          .catch(err => {
            this.toast.error(err.response.data.errors[0].message)
          })
      }
      if (this.packageTopup?.length == 0) {
        await TransactionModel.getListWebinarPackage()
          .then(res => {
            this.packageTopup = res.data
          })
          .catch(err => {
            this.toast.error(err.response.data.errors[0].message)
          })
      }
      this.formAddQuota.classroom_code = this.classroomCode
      this.showModalAddQuota = true
    },

    closeModalAddQuota() {
      this.showModalAddQuota = false
      this.displayPaymentQuota = false
      this.formAddQuota.amount = 1
      this.formAddQuota.payment_code = ''
    },

    minQuota() {
      this.formAddQuota.amount = this.formAddQuota.amount - 1
    },

    plusQuota() {
      this.formAddQuota.amount = this.formAddQuota.amount + 1
    },

    selectPayment(data: any) {
      this.formAddQuota.payment_code = data.code
    },

    async submitAddQuota() {
      this.loadingAddQuota = true
      let payload: any = {
        code: this.selectedPackage.code,
        amount: this.formAddQuota.amount,
        payment_code: this.formAddQuota.payment_code,
        classroom_code: this.formAddQuota.classroom_code,
      }
      if (this.usePackageTopup) {
        delete payload.amount
        await TransactionModel.addTransactionForPackage(payload)
          .then(res => {
            this.loadingAddQuota = false
            this.$router.push('/payment/' + res.data.code)
          })
          .catch(err => {
            this.loadingAddQuota = false
            this.toast.error(err.response.data.errors[0].message)
          })
      } else {
        delete payload.code
        await TransactionModel.addTransactionForQuota(payload)
          .then(res => {
            this.loadingAddQuota = false
            this.$router.push('/payment/' + res.data.code)
          })
          .catch(err => {
            this.loadingAddQuota = false
            this.toast.error(err.response.data.errors[0].message)
          })
      }
    },

    async getPrivateWebinar() {
      if (Object.keys(this.classroomLevel)?.length === 0) {
        await this.getClassRoomLevelDetail(this.classroomLevelCode)
      }
      if (this.materials?.length == 0) {
        await this.getMaterialsList()
      }

      await this.$store
        .dispatch(
          'classroomStore/fetchClassroomPrivateWebinar',
          this.classroomCode
        )
        .then(() => {
          if (this.countPrivateWebinarApproved > 0) {
            this.changeFilterPrivateWebinar('approved')
          } else {
            this.changeFilterPrivateWebinar(this.filterPrivateWebinar)
          }
        })
    },

    changeFilterPrivateWebinar(filter: string) {
      this.filterPrivateWebinar = filter
      const {
        'classroomStore/getClassroomPrivateWebinarData': getClassroomPrivateWebinarData,
      } = this.$store.getters as any
      if (getClassroomPrivateWebinarData?.length > 0) {
        this.privateWebinar = getClassroomPrivateWebinarData.filter(
          (el: any) => {
            if (filter == 'requested') {
              if (el.status == 0) {
                return el
              }
            } else if (filter == 'approved') {
              if (el.status == 1) {
                return el
              }
            } else if (filter == 'rejected') {
              if (el.status == -1) {
                return el
              }
            } else {
              return el
            }
          }
        )
      }
    },

    openModalPrivateWebinar() {
      // const popover: any = document.getElementsByClassName('v-popper--theme-webinar').item(0)
      // console.log(popover)
      // this.showAlertPrivateWebinar = true
      this.showModalPrivateWebinar = true
      this.isReapplyPrivateWebinar = false
      this.formPrivateWebinar.material = ''
      this.formPrivateWebinar.note = ''
      this.formPrivateWebinar.mentor = ''
      this.formPrivateWebinar.request_started_at = ''
    },

    closeModalPrivateWebinar() {
      this.showModalPrivateWebinar = false
      this.isReapplyPrivateWebinar = false
      this.formPrivateWebinar.material = ''
      this.formPrivateWebinar.note = ''
      this.formPrivateWebinar.mentor = ''
      this.formPrivateWebinar.request_started_at = ''
    },

    async submitAddPrivateWebinar() {
      this.loadingAddPrivateWebinar = true
      const payload = {
        request_started_at: moment(
          this.formPrivateWebinar.request_started_at
        ).format('YYYY-MM-DD HH:mm:00'),
        material: this.formPrivateWebinar.material,
        note: this.formPrivateWebinar.note,
      }
      // console.log(payload)
      await ClassroomModel.addPrivateWebinar(this.classroomCode, payload)
        .then(res => {
          this.loadingAddPrivateWebinar = false
          if (res.success) {
            this.showAlert = true
            this.modalAlert.status = 'success'
            this.modalAlert.title = 'Berhasil'
            this.modalAlert.description =
              'Pengajuan konsultasi desain terkirim, Silahkan hubungi Admin.'
          } else {
            this.showAlert = true
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description =
              'Terjadi kesalahan, silahkan coba kembali.'
          }
          this.getClassRoomLevelDetail(this.classroomLevelCode)
          this.getPrivateWebinar()
          this.closeModalPrivateWebinar()
        })
        .catch(err => {
          this.loadingAddPrivateWebinar = false
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = err.response.data.errors[0].message
        })
    },

    changePrivateWebinarMaterial() {
      console.log(this.formPrivateWebinar.material)
    },

    openModalReapplyPrivateWebinar(data: any) {
      this.selectedPrivateWebinar = data
      this.isReapplyPrivateWebinar = true
      this.showModalPrivateWebinar = true
      const noteSplit = data.note.split(/\r\n|\n\r|\n|\r/)
      this.formPrivateWebinar.material = noteSplit[0]
      this.formPrivateWebinar.note = noteSplit[1]
      this.formPrivateWebinar.mentor = this.classroomLevel.classroom.mentor_data[0].name
    },

    async submitReapplyPrivateWebinar() {
      this.loadingAddPrivateWebinar = true
      const payload = {
        request_started_at: moment(
          this.formPrivateWebinar.request_started_at
        ).format('YYYY-MM-DD HH:mm:00'),
      }
      // console.log(this.selectedPrivateWebinar)
      // console.log(payload)
      await ClassroomModel.reapplyPrivateWebinar(
        this.selectedPrivateWebinar.id,
        payload
      )
        .then(res => {
          this.loadingAddPrivateWebinar = false
          if (res.success) {
            this.getClassRoomLevelDetail(this.classroomLevelCode)
            this.getPrivateWebinar()
            this.closeModalPrivateWebinar()
            this.showAlert = true
            this.modalAlert.status = 'success'
            this.modalAlert.title = 'Berhasil'
            this.modalAlert.description =
              'Pengajuan ulang konsultasi desain terkirim, Silahkan hubungi Admin.'
          } else {
            this.showAlert = true
            this.modalAlert.status = 'error'
            this.modalAlert.title = 'Gagal'
            this.modalAlert.description =
              'Terjadi kesalahan, silahkan coba kembali.'
          }
        })
        .catch(err => {
          this.loadingAddPrivateWebinar = false
          this.showAlert = true
          this.modalAlert.status = 'error'
          this.modalAlert.title = 'Gagal'
          this.modalAlert.description = err.response.data.errors[0].message
        })
    },

    async joinPrivateWebinar(link: string, startedDate: any, expiredDate: any) {
      const start = this.timeZone(startedDate)
      const end = this.timeZone(expiredDate)
      if (this.getDateNow() < start) {
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Gagal'
        this.modalAlert.description = 'Konsultasi belum mulai'
        return
      }
      if (this.getDateNow() > end) {
        this.showAlert = true
        this.modalAlert.status = 'error'
        this.modalAlert.title = 'Gagal'
        this.modalAlert.description = 'Konsultasi telah berakhir'
        return
      }

      window.location.assign(link)
    },

    backChooseQuota() {
      this.usePackageTopup = false
      this.selectedPackage = {} as PackageTopup
      this.displayPaymentQuota = false
    },

    choosePackage(data: PackageTopup) {
      this.usePackageTopup = true
      this.selectedPackage = data
      this.displayPaymentQuota = true
    },

    formatPrice(price: string) {
      return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },

    checkIsAssetFile(file: string) {
      if (file.includes('assets')) {
        return true
      } else {
        return false
      }
    },

    dateFormatLong(date: string) {
      return moment(date)
        .locale('id')
        .format('dddd, DD MMMM YYYY')
    },

    async onFileUpload(event: any) {
      const size = event.target.files[0].size
      if (size > 2097152) {
        this.toast.error('Ukuran foto maksimal 2Mb')
        return
      }
      const fileName = event.target.files[0].name.substr(-3).toLowerCase()
      if (['png', 'jpg', 'peg'].indexOf(fileName) <= -1) {
        this.toast.error('Format file tidak sesuai')
        return
      }
      this.formReview.imageRating = event.target.files[0]
      this.previewImageRating = URL.createObjectURL(event.target.files[0])
      if (this.previewImageRating) {
        this.showModalImageRating = true
      }
    },

    closeModalImage() {
      this.previewImageRating = null
      this.formReview.imageRating = null
      this.showModalImageRating = false
      const input: any = this.$refs.imageRating
      input.value = null;
    },

    cropImage() {
      this.loadingCropImage = true
      const { canvas } = (this.$refs.cropper as any).getResult()
      canvas.toBlob((blob: any) => {
        this.loadingCropImage = false
        // blob.name = this.file.name
        // blob.lastModifiedDate = new Date()
        const image = new File([blob], blob.name, { type: 'image/png' })
        this.updatedImageRating = URL.createObjectURL(image)
        this.formReview.imageRating = image
        this.showModalImageRating = false
      })
    },
  },

  components: {
    Webinar,
    CardWebinar,
    CardPrivateWebinar,
    ModalPack,
    ModalRequestWebinar,
    ModalQuiz,
    ModalKuis,
    ModalResultQuiz,
    ModalResultPreTest,
    ModalResultPostTest,
    ModalStatus,
    Slider,
    Loading,
  },
})
</script>

<style src="@vueform/slider/themes/default.css"></style>
<style scoped>
.collapse-enter-active,
.collapse-leave-active {
  transition: max-height 0.5s ease-in-out;
  max-height: 100vh;
  overflow: hidden;
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0px;
  overflow: hidden;
}

.header-quiz {
  min-height: 0px;
  width: 100%;
  display: flex;
  align-items: stretch;
  margin: 0;
  padding: 1rem 0 1rem 2rem;
  flex-direction: row;
  flex: 1 1 0%;
  overflow: auto hidden;
  position: absolute;
  top: 0;
  background-color: #ffffff;
  z-index: 3;
}

.question-number {
  font-family: 'Poppins', sans-serif;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #ffffff; */
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 6px 0px;
  border: 1px solid #f3f4f6;
  margin-right: 1rem;
  font-weight: 700;
  cursor: pointer;
  padding: 1rem;
}

.question-selected {
  background-color: rgba(0, 157, 255, 1);
  color: #ffffff;
}

.body-quiz {
  background-color: #eff6ff;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
}

.question-body {
  padding: 6rem 2.5rem 1.5rem 2.5rem;
  background-color: #eff6ff;
}

.question-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  text-align: justify;
}

.h-quiz {
  height: 100%;
  background-color: #eff6ff;
}

.text-quiz {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 0.85rem;
}

.btn-quiz {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  color: white;
  border-radius: 0.25rem;
  width: 100%;
  padding: 5px 0;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
}

.bg-selected-materi {
  background-color: #eff6ff;
}

.selected-materi {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  color: #013454;
}

.h-fit {
  height: -moz-fit-content;
  height: -web-fit-content;
  height: fit-content;
}

.btn-asset {
  outline: none;
  border: 1px solid #5a6268;
  color: #212121;
  border-radius: 1.5rem;
  padding: 0.25rem 1rem;
  font-size: 0.7rem;
  font-weight: 700;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.075) !important;
}

.btn-choice {
  /* font-family: 'Poppins', sans-serif; */
  min-width: 30px;
  min-height: 30px;
  border-radius: 3px;
  border: 1px solid rgba(51, 51, 51, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(51, 51, 51, 1);
  height: fit-content;
  height: -moz-fit-content;
  height: -webkit-fit-content;
  font-weight: 700;
}

.text-poppins {
  font-family: 'Poppins', sans-serif !important;
}

.choice-selected {
  background-color: rgba(0, 157, 255, 1);
  color: #ffffff;
  border: 1px solid rgba(0, 157, 255, 1);
}

.text-2xs {
  font-size: 0.7rem;
  line-height: 0.8rem;
}

/* * SCROLLBAR */
#scroll-main::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
#scroll-main::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}
#scroll-main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #00446e;
}

#scroll-quiz::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
#scroll-quiz::-webkit-scrollbar {
  height: 5px;
  background-color: #f5f5f5;
}
#scroll-quiz::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #9ca3af;
}

.slider-blue {
  --slider-connect-bg: #009dff;
  --slider-tooltip-bg: #0a72ed;
  --slider-handle-ring-color: #00446f;
}

::v-deep(.select-custom .vs__search::placeholder, .select-custom
    .vs__dropdown-toggle, .select-custom .vs__dropdown-menu) {
  /* background: #dfe5fb;
  border: none; */
  font-family: 'SolusiSans', ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  /* color: #394066;
  text-transform: lowercase;
  font-variant: small-caps; */
}

::v-deep(.select-custom .vs__selected) {
  font-family: 'SolusiSans', ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #212121;
}
::v-deep(.select-custom .vs__dropdown-option) {
  font-family: 'SolusiSans', ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #212121;
}
::v-deep(.select-custom .vs__search) {
  font-family: 'SolusiSans', ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #212121;
}

::v-deep(.select-custom .vs__dropdown-menu) {
  position: absolute;
  top: 2rem;
  right: 0;
  z-index: 999999 !important;
  animation-fill-mode: both;
  max-height: 200px;
}

@media (max-width: 768px) {
  .header-quiz {
    padding: 1rem;
  }
  .question-body {
    padding: 6rem 1rem 2.5rem 1rem;
    min-height: 40vh;
  }
}
</style>
